export const deleteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    />
  </svg>
);

export const editIcon = (
  <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="25" height="25" rx="5" fill="currentColor" />
    <path
      d="M13.9127 7.8382L8.72272 13.0282C8.52272 13.2282 8.33273 13.6182 8.29273 13.8982L8.01273 15.8782C7.91273 16.5982 8.41272 17.0982 9.13272 16.9982L11.1127 16.7182C11.3927 16.6782 11.7827 16.4882 11.9827 16.2882L17.1727 11.0982C18.0627 10.2082 18.4927 9.1682 17.1727 7.8482C15.8527 6.5182 14.8127 6.9382 13.9127 7.8382Z"
      stroke="white"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.1729 8.5782C13.6129 10.1482 14.8429 11.3882 16.4229 11.8282"
      stroke="white"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const viewIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 -960 960 960"
  >
    <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
  </svg>
);

export const closeIcon = (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 14 14"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
    />
  </svg>
);

export const arrowDownIcon = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z"
      fill="currentColor"
    />
  </svg>
);

export const arrowUpIcon = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.2929 15.2893C18.6834 14.8988 18.6834 14.2656 18.2929 13.8751L13.4007 8.98766C12.6195 8.20726 11.3537 8.20757 10.5729 8.98835L5.68257 13.8787C5.29205 14.2692 5.29205 14.9024 5.68257 15.2929C6.0731 15.6835 6.70626 15.6835 7.09679 15.2929L11.2824 11.1073C11.673 10.7168 12.3061 10.7168 12.6966 11.1073L16.8787 15.2893C17.2692 15.6798 17.9024 15.6798 18.2929 15.2893Z"
      fill="currentColor"
    />
  </svg>
);

export const calendarIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
    <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z" />
  </svg>
);
export const venueIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="white"
      d="M20.891 2.006L20.997 2l.13.008l.09.016l.123.035l.107.046l.1.057l.09.067l.082.075l.052.059l.082.116l.052.096q.07.15.09.316l.005.106q0 .113-.024.22l-.035.123l-6.532 18.077A1.55 1.55 0 0 1 14 22.32a1.55 1.55 0 0 1-1.329-.747l-.065-.127l-3.352-6.702l-6.67-3.336a1.55 1.55 0 0 1-.898-1.259L1.68 10c0-.56.301-1.072.841-1.37l.14-.07l18.017-6.506l.106-.03l.108-.018z"
    />
  </svg>
);
export const whiteCalendarIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path
      fill="white"
      d="M96 32v32H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48h-48V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32m352 160H0v272c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48z"
    />
  </svg>
);
export const timeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    className="w-4 h-4"
  >
    <path d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 320q133 0 226.5-93.5T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160Z" />
  </svg>
);

export const listIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
    <path d="M280-600v-80h560v80H280Zm0 160v-80h560v80H280Zm0 160v-80h560v80H280ZM160-600q-17 0-28.5-11.5T120-640q0-17 11.5-28.5T160-680q17 0 28.5 11.5T200-640q0 17-11.5 28.5T160-600Zm0 160q-17 0-28.5-11.5T120-480q0-17 11.5-28.5T160-520q17 0 28.5 11.5T200-480q0 17-11.5 28.5T160-440Zm0 160q-17 0-28.5-11.5T120-320q0-17 11.5-28.5T160-360q17 0 28.5 11.5T200-320q0 17-11.5 28.5T160-280Z" />
  </svg>
);

export const refreshIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 -960 960 960"
  >
    <path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z" />
  </svg>
);

export const clockIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
  </svg>
);

export const likeIcon = (
  <svg viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.8325 22.3996C13.4217 22.5446 12.745 22.5446 12.3342 22.3996C8.83 21.2033 1 16.2129 1 7.75458C1 4.02083 4.00875 1 7.71833 1C9.9175 1 11.8629 2.06333 13.0833 3.70667C14.3037 2.06333 16.2612 1 18.4483 1C22.1579 1 25.1667 4.02083 25.1667 7.75458C25.1667 16.2129 17.3367 21.2033 13.8325 22.3996Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const likeIconB = (
  <svg viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.4078 19.0073C11.0669 19.1248 10.5069 19.1206 10.1678 18.9981C7.27525 17.9865 0.826179 13.8084 0.8783 6.80859C0.901307 3.71868 3.40985 1.23729 6.47977 1.26015C8.29972 1.2737 9.90312 2.16566 10.903 3.53315C11.9231 2.1807 13.5496 1.31279 15.3595 1.32627C18.4294 1.34913 20.9008 3.8676 20.8777 6.95751C20.8256 13.9573 14.3151 18.039 11.4078 19.0073Z"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const share = (
  <svg viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.5676 6.59982L14.9785 1.28142C14.5279 0.759219 13.6708 1.07428 13.6656 1.76399L13.6498 3.89104C13.6483 4.09181 13.4843 4.25336 13.2835 4.25187L11.0907 4.23554C5.71641 4.19552 1.32725 8.51978 1.28721 13.894C3.40348 11.4891 6.4595 10.1212 9.66291 10.1451L13.0102 10.17C13.3376 10.1724 13.601 10.4398 13.5986 10.7673L13.5845 12.665C13.5793 13.3547 14.4317 13.6825 14.89 13.1671L19.5578 7.9176C19.891 7.54291 19.8951 6.97942 19.5676 6.59982Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const reel = (
  <svg viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.2435 14.2801L21.2881 8.28031C21.3254 3.28045 19.3403 1.26562 14.3405 1.22839L8.34063 1.18371C3.34076 1.14648 1.32593 3.13154 1.2887 8.1314L1.24402 14.1312C1.2068 19.1311 3.19185 21.1459 8.19171 21.1832L14.1915 21.2278C19.1914 21.2651 21.2062 19.28 21.2435 14.2801Z"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.82324 6.24536L20.7827 6.38653"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.85938 1.29028L7.82319 6.15015"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.8193 1.34204L14.7865 5.75192"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.99773 13.639L9.00666 12.439C9.01813 10.8991 10.1128 10.2772 11.437 11.0571L12.4725 11.6648L13.508 12.2725C14.8323 13.0524 14.8229 14.3124 13.4872 15.0725L12.4427 15.6647L11.3983 16.2569C10.0626 17.017 8.97732 16.3789 8.98879 14.839L8.99773 13.639V13.639Z"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const playIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M1.5 8a6.5 6.5 0 1 0 13 0a6.5 6.5 0 0 0-13 0m4.879-2.773l4.264 2.559a.25.25 0 0 1 0 .428l-4.264 2.559A.25.25 0 0 1 6 10.559V5.442a.25.25 0 0 1 .379-.215"
    />
  </svg>
);
export const pauseIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2m-1 14H9V8h2zm4 0h-2V8h2z"
    />
  </svg>
);

export const darkLibraryIcon = (
  <svg viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.02887 0.0312505H16.6429C18.4875 0.031228 19.9572 0.0312169 21.0952 0.182597C22.2644 0.338106 23.2344 0.669868 23.9599 1.4536C24.6934 2.24588 24.9208 3.22228 24.9295 4.36284C24.9378 5.45938 24.7424 6.84504 24.4997 8.56584L24.0058 12.0686C23.8162 13.4143 23.662 14.5073 23.4223 15.3639C23.1714 16.26 22.8017 16.9974 22.1172 17.5642C21.438 18.1265 20.6323 18.369 19.6799 18.4833C18.7591 18.5938 17.6005 18.5938 16.1582 18.5938H9.51366C8.07129 18.5938 6.91283 18.5938 5.99196 18.4833C5.0396 18.369 4.23387 18.1265 3.55472 17.5642C2.87015 16.9974 2.5004 16.26 2.24956 15.3639C2.00979 14.5073 1.8557 13.4143 1.66601 12.0686L1.17215 8.56584C0.929509 6.84504 0.734119 5.45938 0.742444 4.36284C0.751095 3.22228 0.978401 2.24588 1.71189 1.4536C2.43746 0.669868 3.40737 0.338106 4.57658 0.182597C5.71468 0.0312169 7.18442 0.031228 9.02887 0.0312505ZM4.79907 1.85536C3.80338 1.98779 3.29095 2.23193 2.95019 2.60001C2.61735 2.95954 2.43693 3.44879 2.42989 4.37566C2.42263 5.33203 2.59822 6.59315 2.85286 8.39934L3.32871 11.7743C3.5287 13.1927 3.66876 14.1736 3.8746 14.909C4.07284 15.6172 4.30613 15.9955 4.6309 16.2644C4.96109 16.5378 5.40438 16.7132 6.19302 16.8078C7.00161 16.9048 8.05859 16.9063 9.56821 16.9063H16.1036C17.6132 16.9063 18.6703 16.9048 19.4788 16.8078C20.2675 16.7132 20.7108 16.5378 21.041 16.2644C21.3657 15.9955 21.599 15.6172 21.7972 14.909C22.0031 14.1736 22.1432 13.1927 22.3432 11.7743L22.819 8.39934C23.0737 6.59315 23.2493 5.33203 23.242 4.37566C23.235 3.44879 23.0545 2.95954 22.7216 2.60001C22.3809 2.23193 21.8684 1.98779 20.8728 1.85536C19.859 1.72052 18.5019 1.71875 16.5795 1.71875H9.09237C7.16995 1.71875 5.81285 1.72052 4.79907 1.85536Z"
      fill="currentColor"
    />
  </svg>
);

export const darkTaskIcon = (
  <svg viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.1226 0.576841L12.4739 0.224575L12.1226 0.576842L13.1103 1.56195C13.144 1.61187 13.1672 1.68358 13.1672 1.76025C13.1672 1.84678 13.1392 1.88463 13.1356 1.88873L5.75075 9.13509L5.75074 9.13508L5.74786 9.13795C5.55365 9.33164 5.32796 9.40789 5.08814 9.40789C4.84832 9.40789 4.62263 9.33164 4.42842 9.13795L0.913407 5.6323C0.849264 5.56833 0.836914 5.51416 0.836914 5.48128C0.836914 5.44839 0.849264 5.39423 0.913407 5.33025L1.92621 4.32015C1.99035 4.25619 2.04527 4.24331 2.07953 4.24331C2.11379 4.24331 2.16871 4.25619 2.23285 4.32015L2.23282 4.32018L2.23704 4.32428L4.79883 6.81982L5.15018 7.16209L5.49912 6.81736L11.8142 0.578515L11.8159 0.576842C11.8801 0.512875 11.935 0.5 11.9692 0.5C12.0035 0.5 12.0584 0.512875 12.1226 0.576841Z"
      stroke="currentColor"
    />
    <path
      d="M28.0248 7.50647H15.5733C15.312 7.50647 15.1201 7.31314 15.1201 7.05578V5.15442C15.1201 4.89706 15.312 4.70374 15.5733 4.70374H28.0248C28.2861 4.70374 28.4781 4.89706 28.4781 5.15442V7.05578C28.4781 7.31314 28.2861 7.50647 28.0248 7.50647Z"
      stroke="currentColor"
    />
    <path
      d="M28.0251 16.0032H12.714C12.4527 16.0032 12.2607 15.8098 12.2607 15.5525V13.6511C12.2607 13.3938 12.4527 13.2004 12.714 13.2004H28.0251C28.2864 13.2004 28.4784 13.3938 28.4784 13.6511V15.5525C28.4784 15.8098 28.2864 16.0032 28.0251 16.0032Z"
      stroke="currentColor"
    />
    <path
      d="M7.38809 15.5525V15.5803L7.39117 15.6078C7.40173 15.7027 7.36891 15.7909 7.28942 15.8669C7.20536 15.9473 7.07654 16.0032 6.93487 16.0032H5.02842C4.76711 16.0032 4.5752 15.8098 4.5752 15.5525V13.6511C4.5752 13.3938 4.76711 13.2004 5.02842 13.2004H6.93487C7.19618 13.2004 7.38809 13.3938 7.38809 13.6511V15.5525Z"
      stroke="currentColor"
    />
    <path
      d="M7.38809 24.0493V24.0771L7.39117 24.1047C7.40173 24.1995 7.36891 24.2878 7.28942 24.3637C7.20536 24.4441 7.07654 24.5 6.93487 24.5H5.02842C4.76711 24.5 4.5752 24.3067 4.5752 24.0493V22.1479C4.5752 21.8906 4.76711 21.6973 5.02842 21.6973H6.93487C7.19617 21.6973 7.38809 21.8906 7.38809 22.1479V24.0493Z"
      stroke="currentColor"
    />
    <path
      d="M28.0251 24.5H12.714C12.4527 24.5 12.2607 24.3067 12.2607 24.0493V22.1479C12.2607 21.8906 12.4527 21.6973 12.714 21.6973H28.0251C28.2864 21.6973 28.4784 21.8906 28.4784 22.1479V24.0493C28.4784 24.3067 28.2864 24.5 28.0251 24.5Z"
      stroke="currentColor"
    />
  </svg>
);

export const themeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z" />
  </svg>
);

export const logOutIcon = (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.39969 10.8333V2.5H11.0797V10.8333H9.39969ZM10.2397 17.5C9.20369 17.5 8.22719 17.3021 7.31019 16.9062C6.39319 16.5104 5.59169 15.9722 4.90569 15.2917C4.21969 14.6111 3.67719 13.816 3.27819 12.9062C2.87919 11.9965 2.67969 11.0278 2.67969 10C2.67969 8.88889 2.91069 7.84028 3.37269 6.85417C3.83469 5.86806 4.48569 5.01389 5.32569 4.29167L6.54369 5.5C5.84369 6.02778 5.30469 6.6875 4.92669 7.47917C4.54869 8.27083 4.35969 9.11111 4.35969 10C4.35969 11.6111 4.93369 12.9861 6.08169 14.125C7.22969 15.2639 8.61569 15.8333 10.2397 15.8333C11.8777 15.8333 13.2672 15.2639 14.4082 14.125C15.5492 12.9861 16.1197 11.6111 16.1197 10C16.1197 9.11111 15.9342 8.27083 15.5632 7.47917C15.1922 6.6875 14.6497 6.02778 13.9357 5.5L15.1537 4.29167C15.9937 5.01389 16.6447 5.86806 17.1067 6.85417C17.5687 7.84028 17.7997 8.88889 17.7997 10C17.7997 11.0278 17.6002 11.9965 17.2012 12.9062C16.8022 13.816 16.2632 14.6111 15.5842 15.2917C14.9052 15.9722 14.1072 16.5104 13.1902 16.9062C12.2732 17.3021 11.2897 17.5 10.2397 17.5Z"
      fill="currentColor"
    />
  </svg>
);

export const sideIconLink = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 -960 960 960"
  >
    <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
  </svg>
);

export const closeSideIcon = (
  <svg viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0524 29.448C16.779 34.1745 24.5602 34.1276 29.3441 29.3438C34.1279 24.5599 34.1748 16.7787 29.4482 12.0521C24.7217 7.32556 16.9404 7.37244 12.1566 12.1563C7.37272 16.9401 7.32585 24.7214 12.0524 29.448Z"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.3125 17.3125L24.1875 24.1875"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.2712 24.2292L24.2295 17.2709"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const walletIcon = (
  <svg
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" />{" "}
    <path d="M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12" />
    <path d="M20 12v4h-4a2 2 0 0 1 0 -4h4" />
  </svg>
);

export const streetOneIcon = (
  <svg viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 1V7" stroke="black" stroke-linecap="round" />
    <path d="M11 10V15" stroke="black" stroke-linecap="round" />
    <path d="M11 18V24" stroke="black" stroke-linecap="round" />
    <path d="M1 23.5L6.5 1" stroke="black" stroke-linecap="round" />
    <path d="M16 1L21.5 23.5" stroke="black" stroke-linecap="round" />
  </svg>
);

export const streetTwoIcon = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_658_1319)">
      <path
        d="M20.7656 6.8L18.3656 4.4H12.2V3.9596C13.1116 3.7736 13.8 2.966 13.8 2C13.8 0.8972 12.9028 0 11.8 0C10.6972 0 9.79997 0.8972 9.79997 2C9.79997 2.9656 10.4884 3.7736 11.4 3.9596V4.4H8.25637C7.56357 4.4 6.99997 4.9636 6.99997 5.6568V6.8H5.63437L3.23438 9.2L5.63437 11.6H11.4V20H9.39997V21.6H8.19997V24H15.4V21.6H14.2V20H12.2V11.6H15.7436C16.4364 11.6 17 11.0364 17 10.3432V9.2H18.3656L20.7656 6.8ZM10.6 2C10.6 1.3384 11.1384 0.8 11.8 0.8C12.4616 0.8 13 1.3384 13 2C13 2.6616 12.4616 3.2 11.8 3.2C11.1384 3.2 10.6 2.6616 10.6 2ZM14.6 22.4V23.2H8.99997V22.4H9.39997H14.2H14.6ZM13.4 21.6H10.2V20.8H13.4V21.6ZM16.2 10.3432C16.2 10.5952 15.9952 10.8 15.7436 10.8H5.96557L4.36557 9.2L5.96557 7.6H6.99997H15.7436C15.9952 7.6 16.2 7.8048 16.2 8.0568V9.2V10.3432ZM17 8.4V8.0568C17 7.364 16.4364 6.8 15.7436 6.8H7.79997V5.6568C7.79997 5.4048 8.00478 5.2 8.25637 5.2H18.0344L19.6344 6.8L18.0344 8.4H17Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_658_1319">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const additionalAddressIcon = (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.33344 25.6667H25.6668"
      stroke="black"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.44153 25.6666L3.49986 11.6316C3.49986 10.9199 3.83819 10.2433 4.39819 9.80001L12.5649 3.44166C13.4049 2.78833 14.5832 2.78833 15.4349 3.44166L23.6015 9.78833C24.1732 10.2317 24.4999 10.9083 24.4999 11.6316V25.6666"
      stroke="black"
      stroke-miterlimit="10"
      stroke-linejoin="round"
    />
    <path
      d="M15.1668 19.8333H12.8334C11.8651 19.8333 11.0834 20.6149 11.0834 21.5833V25.6666H16.9168V21.5833C16.9168 20.6149 16.1351 19.8333 15.1668 19.8333Z"
      stroke="black"
      stroke-miterlimit="10"
      stroke-linejoin="round"
    />
    <path
      d="M11.0834 16.0416H8.7501C8.10844 16.0416 7.58344 15.5166 7.58344 14.8749V13.1249C7.58344 12.4833 8.10844 11.9583 8.7501 11.9583H11.0834C11.7251 11.9583 12.2501 12.4833 12.2501 13.1249V14.8749C12.2501 15.5166 11.7251 16.0416 11.0834 16.0416Z"
      stroke="black"
      stroke-miterlimit="10"
      stroke-linejoin="round"
    />
    <path
      d="M19.25 16.0416H16.9167C16.275 16.0416 15.75 15.5166 15.75 14.8749V13.1249C15.75 12.4833 16.275 11.9583 16.9167 11.9583H19.25C19.8917 11.9583 20.4167 12.4833 20.4167 13.1249V14.8749C20.4167 15.5166 19.8917 16.0416 19.25 16.0416Z"
      stroke="black"
      stroke-miterlimit="10"
      stroke-linejoin="round"
    />
    <path
      d="M22.1667 8.16663L22.1317 4.66663H16.9984"
      stroke="black"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const cityIcon = (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.375 21C4.375 20.5168 3.98325 20.125 3.5 20.125C3.01676 20.125 2.625 20.5168 2.625 21H4.375ZM2.625 16.3334C2.625 16.8166 3.01676 17.2084 3.5 17.2084C3.98325 17.2084 4.375 16.8166 4.375 16.3334H2.625ZM8.16667 10.2084C9.29135 10.2084 10.0468 10.2102 10.6104 10.286C11.1488 10.3584 11.3792 10.4835 11.5312 10.6355L12.7686 9.39808C12.2373 8.8667 11.576 8.65008 10.8436 8.5516C10.1363 8.45652 9.24188 8.45838 8.16667 8.45838V10.2084ZM13.7083 14C13.7083 12.9248 13.7102 12.0304 13.6151 11.3231C13.5167 10.5907 13.3 9.92946 12.7686 9.39808L11.5312 10.6355C11.6832 10.7875 11.8083 11.018 11.8808 11.5563C11.9565 12.1198 11.9583 12.8754 11.9583 14H13.7083ZM8.16667 8.45838C7.09146 8.45838 6.19703 8.45652 5.48978 8.5516C4.75735 8.65008 4.09609 8.8667 3.56471 9.39808L4.80214 10.6355C4.95417 10.4835 5.18459 10.3584 5.72296 10.286C6.2865 10.2102 7.04199 10.2084 8.16667 10.2084V8.45838ZM4.375 14C4.375 12.8754 4.37686 12.1198 4.45263 11.5563C4.52501 11.018 4.6501 10.7875 4.80214 10.6355L3.56471 9.39808C3.03332 9.92946 2.81671 10.5907 2.71823 11.3231C2.62315 12.0304 2.625 12.9248 2.625 14H4.375ZM4.375 25.6667V21H2.625V25.6667H4.375ZM4.375 16.3334V14H2.625V16.3334H4.375Z"
      fill="black"
    />
    <path
      d="M8.16669 25.6667V18.6667C8.16669 16.4668 8.16669 15.3669 8.85011 14.6834C9.53352 14 10.6335 14 12.8334 14H15.1667C17.3666 14 18.4665 14 19.1499 14.6834C19.7001 15.2335 19.8073 16.0536 19.8283 17.5M19.8334 25.6667V22.4583"
      stroke="black"
      stroke-linecap="round"
    />
    <path
      d="M24.5 9.0673C24.5 7.50297 24.5 6.72081 24.0846 6.12124C23.669 5.52166 22.9367 5.24702 21.4719 4.69776C18.6074 3.62358 17.1752 3.0865 16.171 3.78247C15.1667 4.47843 15.1667 6.00805 15.1667 9.0673V13.9999M24.5 25.6666V13.9999"
      stroke="black"
      stroke-linecap="round"
    />
    <path
      d="M4.66669 9.33333V7.58333C4.66669 6.48339 4.66669 5.93342 5.00839 5.59171C5.35011 5.25 5.90008 5.25 7.00002 5.25H9.33335C10.4333 5.25 10.9833 5.25 11.325 5.59171C11.6667 5.93342 11.6667 6.48339 11.6667 7.58333V9.33333"
      stroke="black"
      stroke-linecap="round"
    />
    <path d="M8.16669 4.66671V2.33337" stroke="black" stroke-linecap="round" />
    <path d="M25.6666 25.6666H2.33331" stroke="black" stroke-linecap="round" />
    <path
      d="M11.6667 17.5H12.25M16.3334 17.5H14.5834"
      stroke="black"
      stroke-linecap="round"
    />
    <path d="M11.6667 21H16.3334" stroke="black" stroke-linecap="round" />
  </svg>
);

export const pinCodeIcon = (
  <svg viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.0833 29.0417H9.91665C5.66665 29.0417 2.83331 26.9167 2.83331 21.9584V12.0417C2.83331 7.08337 5.66665 4.95837 9.91665 4.95837H24.0833C28.3333 4.95837 31.1666 7.08337 31.1666 12.0417V21.9584C31.1666 26.9167 28.3333 29.0417 24.0833 29.0417Z"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.4201 13.5417L6.00006 10"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28.4201 9.99996L24.0001 13.5416"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const stateIcon = (
  <svg viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.60009 21.1437H19.4001H2.60009ZM1.40009 17.5437H20.6001H1.40009Z"
      fill="black"
    />
    <path
      d="M2.60009 21.1437H19.4001M11.0001 24.7437C11.0001 24.7437 5.60009 22.9437 5.60009 17.5437M11.0001 24.7437C11.0001 24.7437 16.4001 22.9437 16.4001 17.5437M11.0001 24.7437C16.302 24.7437 20.6001 21.5202 20.6001 17.5437H1.40009C1.40009 21.5202 5.69815 24.7437 11.0001 24.7437Z"
      stroke="#121923"
    />
    <path
      d="M2.75 13C2.75 12.6894 2.41421 12.4375 2 12.4375C1.58579 12.4375 1.25 12.6894 1.25 13H2.75ZM1.25 10C1.25 10.3107 1.58579 10.5625 2 10.5625C2.41421 10.5625 2.75 10.3107 2.75 10H1.25ZM6 6.0625C6.96401 6.0625 7.61157 6.06369 8.09461 6.11241C8.55607 6.15894 8.75357 6.23935 8.88388 6.33709L9.9445 5.5416C9.4891 5.19999 8.92227 5.06074 8.29448 4.99743C7.68826 4.93631 6.92161 4.9375 6 4.9375V6.0625ZM10.75 8.5C10.75 7.8088 10.7516 7.23378 10.6701 6.77914C10.5857 6.3083 10.4 5.8832 9.9445 5.5416L8.88388 6.33709C9.0142 6.43482 9.1214 6.58295 9.1835 6.92904C9.2484 7.2913 9.25 7.777 9.25 8.5H10.75ZM6 4.9375C5.07839 4.9375 4.31174 4.93631 3.70552 4.99743C3.07773 5.06074 2.51093 5.19999 2.05546 5.5416L3.11612 6.33709C3.24643 6.23935 3.44393 6.15894 3.90539 6.11241C4.38843 6.06369 5.03599 6.0625 6 6.0625V4.9375ZM2.75 8.5C2.75 7.777 2.75159 7.2913 2.81654 6.92904C2.87858 6.58295 2.9858 6.43482 3.11612 6.33709L2.05546 5.5416C1.59999 5.8832 1.41432 6.3083 1.32991 6.77914C1.24841 7.23378 1.25 7.8088 1.25 8.5H2.75ZM2.75 16V13H1.25V16H2.75ZM2.75 10V8.5H1.25V10H2.75Z"
      fill="black"
    />
    <path
      d="M6 16V11.5C6 10.0858 6 9.3787 6.58579 8.93935C7.17157 8.5 8.11438 8.5 10 8.5H12C13.8856 8.5 14.8284 8.5 15.4142 8.93935C15.8858 9.29298 15.9777 9.82015 15.9957 10.75M16 16V13.9375"
      stroke="black"
      stroke-linecap="round"
    />
    <path
      d="M20 5.32899C20 4.32336 20 3.82054 19.6439 3.4351C19.2877 3.04965 18.66 2.8731 17.4045 2.52C14.9492 1.82946 13.7216 1.48419 12.8608 1.93161C12 2.37901 12 3.36234 12 5.32899V8.49996M20 16V8.49996"
      stroke="black"
      stroke-linecap="round"
    />
    <path
      d="M3 5.5V4.375C3 3.66789 3 3.31434 3.29289 3.09467C3.58579 2.875 4.05719 2.875 5 2.875H7C7.94281 2.875 8.41421 2.875 8.70711 3.09467C9 3.31434 9 3.66789 9 4.375V5.5"
      stroke="black"
      stroke-linecap="round"
    />
    <path d="M6 2.5V1" stroke="black" stroke-linecap="round" />
    <path d="M21 16H1" stroke="black" stroke-linecap="round" />
    <path
      d="M9 10.75H9.5M13 10.75H11.5"
      stroke="black"
      stroke-linecap="round"
    />
    <path d="M9 13H13" stroke="black" stroke-linecap="round" />
  </svg>
);

export const searchIcon = (
  <svg
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
    className="w-6 h-6"
  >
    <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
  </svg>
);

export const searchCloseIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">
    <path
      d="M8.02083 19.4792C11.1719 22.6303 16.3281 22.6303 19.4792 19.4792C22.6302 16.3282 22.6302 11.172 19.4792 8.02091C16.3281 4.86987 11.1719 4.86987 8.02083 8.02091C4.86979 11.172 4.86979 16.3282 8.02083 19.4792Z"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.4583 11.4583L16.0416 16.0416"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.4584 16.0416L16.0417 11.4583"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const recentSearchIcon = (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="mask0_16_4207" maskUnits="userSpaceOnUse" x="0" y="0">
      <rect width="20" height="20" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_16_4207)">
      <path
        d="M12.5019 4.16669C12.2129 4.16669 11.9686 4.06599 11.769 3.8646C11.5695 3.66321 11.4697 3.41669 11.4697 3.12502C11.4697 2.83335 11.5695 2.58683 11.769 2.38544C11.9686 2.18405 12.2129 2.08335 12.5019 2.08335C12.7909 2.08335 13.0352 2.18405 13.2348 2.38544C13.4343 2.58683 13.5341 2.83335 13.5341 3.12502C13.5341 3.41669 13.4343 3.66321 13.2348 3.8646C13.0352 4.06599 12.7909 4.16669 12.5019 4.16669ZM12.5019 17.9167C12.2129 17.9167 11.9686 17.816 11.769 17.6146C11.5695 17.4132 11.4697 17.1667 11.4697 16.875C11.4697 16.5834 11.5695 16.3368 11.769 16.1354C11.9686 15.934 12.2129 15.8334 12.5019 15.8334C12.7909 15.8334 13.0352 15.934 13.2348 16.1354C13.4343 16.3368 13.5341 16.5834 13.5341 16.875C13.5341 17.1667 13.4343 17.4132 13.2348 17.6146C13.0352 17.816 12.7909 17.9167 12.5019 17.9167ZM15.8049 7.08335C15.5159 7.08335 15.2716 6.98266 15.0721 6.78127C14.8725 6.57988 14.7727 6.33335 14.7727 6.04169C14.7727 5.75002 14.8725 5.50349 15.0721 5.3021C15.2716 5.10071 15.5159 5.00002 15.8049 5.00002C16.0939 5.00002 16.3382 5.10071 16.5378 5.3021C16.7373 5.50349 16.8371 5.75002 16.8371 6.04169C16.8371 6.33335 16.7373 6.57988 16.5378 6.78127C16.3382 6.98266 16.0939 7.08335 15.8049 7.08335ZM15.8049 15C15.5159 15 15.2716 14.8993 15.0721 14.6979C14.8725 14.4965 14.7727 14.25 14.7727 13.9584C14.7727 13.6667 14.8725 13.4202 15.0721 13.2188C15.2716 13.0174 15.5159 12.9167 15.8049 12.9167C16.0939 12.9167 16.3382 13.0174 16.5378 13.2188C16.7373 13.4202 16.8371 13.6667 16.8371 13.9584C16.8371 14.25 16.7373 14.4965 16.5378 14.6979C16.3382 14.8993 16.0939 15 15.8049 15ZM17.0436 11.0417C16.7545 11.0417 16.5103 10.941 16.3107 10.7396C16.1111 10.5382 16.0114 10.2917 16.0114 10C16.0114 9.70835 16.1111 9.46183 16.3107 9.26044C16.5103 9.05905 16.7545 8.95835 17.0436 8.95835C17.3326 8.95835 17.5769 9.05905 17.7764 9.26044C17.976 9.46183 18.0758 9.70835 18.0758 10C18.0758 10.2917 17.976 10.5382 17.7764 10.7396C17.5769 10.941 17.3326 11.0417 17.0436 11.0417ZM9.81818 18.3334C8.67589 18.3334 7.6024 18.1146 6.59773 17.6771C5.59306 17.2396 4.71913 16.6459 3.97595 15.8959C3.23277 15.1459 2.64441 14.2639 2.21089 13.25C1.77737 12.2361 1.56061 11.1528 1.56061 10C1.56061 8.84724 1.77737 7.76391 2.21089 6.75002C2.64441 5.73613 3.23277 4.85419 3.97595 4.10419C4.71913 3.35419 5.59306 2.76044 6.59773 2.32294C7.6024 1.88544 8.67589 1.66669 9.81818 1.66669V3.33335C7.97399 3.33335 6.41193 3.97919 5.13201 5.27085C3.85209 6.56252 3.21212 8.13891 3.21212 10C3.21212 11.8611 3.85209 13.4375 5.13201 14.7292C6.41193 16.0209 7.97399 16.6667 9.81818 16.6667V18.3334ZM9.81818 11.6667C9.36402 11.6667 8.97522 11.5035 8.6518 11.1771C8.32838 10.8507 8.16667 10.4584 8.16667 10C8.16667 9.93058 8.17011 9.85766 8.17699 9.78127C8.18387 9.70488 8.20107 9.63196 8.2286 9.56252L6.51515 7.83335L7.67121 6.66669L9.38466 8.39585C9.43971 8.38196 9.58422 8.36113 9.81818 8.33335C10.2723 8.33335 10.6611 8.49655 10.9846 8.82294C11.308 9.14933 11.4697 9.54169 11.4697 10C11.4697 10.4584 11.308 10.8507 10.9846 11.1771C10.6611 11.5035 10.2723 11.6667 9.81818 11.6667Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const trendingSearchIcon = (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_16_4277"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_16_4277)">
      <path
        d="M2.83332 15L1.66666 13.8333L7.83332 7.625L11.1667 10.9583L15.5 6.66667H13.3333V5H18.3333V10H16.6667V7.83333L11.1667 13.3333L7.83332 10L2.83332 15Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const notificationsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 31 35"
    fill="none"
    className="mr-3"
    id="bell-ic"
  >
    <path
      d="M30.3906 24.9201C29.3904 23.1983 28.1981 19.9406 28.1981 14.1981V13.0265C28.1981 5.896 22.4798 0.0525592 15.451 0.000330007C15.4181 0.000164913 15.3856 0 15.3528 0C11.942 0.00455951 8.67275 1.36382 6.26411 3.77877C3.85548 6.19372 2.50479 9.46656 2.50917 12.8774V14.1981C2.50917 19.9405 1.31627 23.1978 0.315381 24.9196C0.110453 25.2705 0.00167606 25.6692 1.92145e-05 26.0756C-0.00163763 26.482 0.103884 26.8816 0.305944 27.2342C0.508004 27.5868 0.799458 27.8799 1.15092 28.0839C1.50238 28.2879 1.90141 28.3956 2.30779 28.3962H9.0794V28.7264C9.0794 30.3903 9.74037 31.986 10.9169 33.1625C12.0934 34.339 13.6891 35 15.353 35C17.0168 35 18.6126 34.339 19.7891 33.1625C20.9656 31.986 21.6266 30.3903 21.6266 28.7264V28.3962H28.3982C28.8045 28.3957 29.2035 28.288 29.555 28.084C29.9064 27.88 30.1978 27.587 30.3999 27.2345C30.602 26.8819 30.7075 26.4824 30.7059 26.076C30.7042 25.6697 30.5955 25.271 30.3906 24.9201ZM19.6454 28.7264C19.6454 29.8648 19.1932 30.9566 18.3882 31.7616C17.5832 32.5666 16.4914 33.0189 15.353 33.0189C14.2146 33.0189 13.1228 32.5666 12.3178 31.7616C11.5128 30.9566 11.0605 29.8648 11.0605 28.7264V28.3962H19.6454V28.7264ZM28.6792 26.2523C28.6517 26.3024 28.6109 26.3441 28.5614 26.3728C28.5118 26.4015 28.4554 26.4162 28.3982 26.4151H2.30779C2.25053 26.4162 2.19408 26.4015 2.14452 26.3728C2.09496 26.3441 2.05419 26.3024 2.02662 26.2523C1.99608 26.2013 1.98008 26.1429 1.98037 26.0835C1.98065 26.024 1.9972 25.9658 2.02823 25.9151C3.15132 23.983 4.49029 20.3817 4.49029 14.1981V12.8774C4.48594 9.99192 5.62797 7.22292 7.66517 5.1795C9.70237 3.13607 12.4679 1.98559 15.3533 1.98114C15.3807 1.98114 15.4088 1.9813 15.4362 1.98147C21.3807 2.02564 26.217 6.9804 26.217 13.0265V14.1981C26.217 20.3817 27.5551 23.983 28.6777 25.9153C28.7087 25.966 28.7252 26.0242 28.7255 26.0836C28.7257 26.143 28.7097 26.2013 28.6792 26.2523Z"
      fill="black"
    />
  </svg>
);

export const hartIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 31" fill="none">
    <path
      d="M16.5991 29.2961C16.1174 29.4867 15.324 29.4867 14.8423 29.2961C10.7336 27.7237 1.55273 21.1639 1.55273 10.0457C1.55273 5.13779 5.08055 1.16699 9.43011 1.16699C12.0087 1.16699 14.2897 2.56471 15.7207 4.72483C17.1516 2.56471 19.4468 1.16699 22.0112 1.16699C26.3608 1.16699 29.8886 5.13779 29.8886 10.0457C29.8886 21.1639 20.7078 27.7237 16.5991 29.2961Z"
      fill="#8AAB94"
      stroke="#8AAB94"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const editProfileIcon = (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.4565 2.34057L2.15588 10.6412C1.83601 10.961 1.53215 11.5848 1.46817 12.0326L1.02036 15.1993C0.860424 16.3508 1.66009 17.1505 2.81162 16.9906L5.97829 16.5428C6.42611 16.4788 7.04989 16.1749 7.36976 15.855L15.6704 7.55443C17.0938 6.13101 17.7815 4.4677 15.6704 2.35656C13.5592 0.229432 11.8959 0.901159 10.4565 2.34057Z"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.27319 3.52411C9.97691 6.03508 11.9441 8.01827 14.4711 8.72198"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const helpIcon = (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83329 15C5.59718 15 5.39926 14.9202 5.23954 14.7604C5.07982 14.6007 4.99996 14.4028 4.99996 14.1667V12.5H15.8333V5.00002H17.5C17.7361 5.00002 17.934 5.07988 18.0937 5.2396C18.2534 5.39933 18.3333 5.59724 18.3333 5.83335V18.3334L15 15H5.83329ZM1.66663 14.1667V2.50002C1.66663 2.26391 1.74649 2.06599 1.90621 1.90627C2.06593 1.74655 2.26385 1.66669 2.49996 1.66669H13.3333C13.5694 1.66669 13.7673 1.74655 13.927 1.90627C14.0868 2.06599 14.1666 2.26391 14.1666 2.50002V10C14.1666 10.2361 14.0868 10.434 13.927 10.5938C13.7673 10.7535 13.5694 10.8334 13.3333 10.8334H4.99996L1.66663 14.1667Z"
      fill="currentColor"
    />
  </svg>
);

export const SwitchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160z" />
  </svg>
);

export const favoriteIcon = (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.24 17.7917L9.02197 16.7083C7.60797 15.4444 6.43897 14.3542 5.51497 13.4375C4.59097 12.5208 3.85597 11.6979 3.30997 10.9688C2.76397 10.2396 2.38247 9.56944 2.16547 8.95833C1.94847 8.34722 1.83997 7.72222 1.83997 7.08333C1.83997 5.77778 2.28097 4.6875 3.16297 3.8125C4.04497 2.9375 5.14397 2.5 6.45997 2.5C7.18797 2.5 7.88097 2.65278 8.53897 2.95833C9.19697 3.26389 9.76397 3.69444 10.24 4.25C10.716 3.69444 11.283 3.26389 11.941 2.95833C12.599 2.65278 13.292 2.5 14.02 2.5C15.336 2.5 16.435 2.9375 17.317 3.8125C18.199 4.6875 18.64 5.77778 18.64 7.08333C18.64 7.72222 18.5315 8.34722 18.3145 8.95833C18.0975 9.56944 17.716 10.2396 17.17 10.9688C16.624 11.6979 15.889 12.5208 14.965 13.4375C14.041 14.3542 12.872 15.4444 11.458 16.7083L10.24 17.7917Z"
      fill="currentColor"
    />
  </svg>
);

export const filterIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" id="filter">
    <path d="M4 10h7.09a6 6 0 0 0 11.82 0H44a1 1 0 0 0 0-2H22.91A6 6 0 0 0 11.09 8H4a1 1 0 0 0 0 2zM17 5a4 4 0 1 1-4 4A4 4 0 0 1 17 5zM44 23H36.91a6 6 0 0 0-11.82 0H4a1 1 0 0 0 0 2H25.09a6 6 0 0 0 11.82 0H44a1 1 0 0 0 0-2zM31 28a4 4 0 1 1 4-4A4 4 0 0 1 31 28zM44 38H22.91a6 6 0 0 0-11.82 0H4a1 1 0 0 0 0 2h7.09a6 6 0 0 0 11.82 0H44a1 1 0 0 0 0-2zM17 43a4 4 0 1 1 4-4A4 4 0 0 1 17 43z"></path>
  </svg>
);

export const bookingsIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
    <path
      fill="currentColor"
      d="M96 80c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v304H96zm313 47c-9.4-9.4-24.6-9.4-33.9 0l-111 111l-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L409 161c9.4-9.4 9.4-24.6 0-33.9zM0 336c0-26.5 21.5-48 48-48h16v128h448V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z"
    />
  </svg>
);

export const successIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <defs>
      <mask id="ipSSuccess0">
        <g
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="4"
        >
          <path
            fill="#fff"
            stroke="#fff"
            d="m24 4l5.253 3.832l6.503-.012l1.997 6.188l5.268 3.812L41 24l2.021 6.18l-5.268 3.812l-1.997 6.188l-6.503-.012L24 44l-5.253-3.832l-6.503.012l-1.997-6.188l-5.268-3.812L7 24l-2.021-6.18l5.268-3.812l1.997-6.188l6.503.012z"
          />
          <path stroke="#000" d="m17 24l5 5l10-10" />
        </g>
      </mask>
    </defs>
    <path fill="#1fb141" d="M0 0h48v48H0z" mask="url(#ipSSuccess0)" />
  </svg>
);
export const refundedIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <defs>
      <mask id="ipSSuccess0">
        <g
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="4"
        >
          <path
            fill="#fff"
            stroke="#fff"
            d="m24 4l5.253 3.832l6.503-.012l1.997 6.188l5.268 3.812L41 24l2.021 6.18l-5.268 3.812l-1.997 6.188l-6.503-.012L24 44l-5.253-3.832l-6.503.012l-1.997-6.188l-5.268-3.812L7 24l-2.021-6.18l5.268-3.812l1.997-6.188l6.503.012z"
          />
          <path stroke="#000" d="m17 24l5 5l10-10" />
        </g>
      </mask>
    </defs>
    <path fill="#3b82f6" d="M0 0h48v48H0z" mask="url(#ipSSuccess0)" />
  </svg>
);

export const failIcon = (
  <svg
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="#c85151"
    stroke="#c85151"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Icon-Set-Filled"
          transform="translate(-570.000000, -1089.000000)"
          fill="#f41515"
        >
          <path
            d="M591.657,1109.24 C592.048,1109.63 592.048,1110.27 591.657,1110.66 C591.267,1111.05 590.633,1111.05 590.242,1110.66 L586.006,1106.42 L581.74,1110.69 C581.346,1111.08 580.708,1111.08 580.314,1110.69 C579.921,1110.29 579.921,1109.65 580.314,1109.26 L584.58,1104.99 L580.344,1100.76 C579.953,1100.37 579.953,1099.73 580.344,1099.34 C580.733,1098.95 581.367,1098.95 581.758,1099.34 L585.994,1103.58 L590.292,1099.28 C590.686,1098.89 591.323,1098.89 591.717,1099.28 C592.11,1099.68 592.11,1100.31 591.717,1100.71 L587.42,1105.01 L591.657,1109.24 L591.657,1109.24 Z M586,1089 C577.163,1089 570,1096.16 570,1105 C570,1113.84 577.163,1121 586,1121 C594.837,1121 602,1113.84 602,1105 C602,1096.16 594.837,1089 586,1089 L586,1089 Z"
            id="cross-circle"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const paymentInfoIcon = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75ZM12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z"
        fill="#db8433"
      ></path>
    </g>
  </svg>
);

export const sessionIcon = (
  <svg
    viewBox="0 0 21 15"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.912 11L11.088 9.83333L8.4 7.16667V3.33333H6.72V7.83333L9.912 11ZM15.12 14.5833V12.75C16.156 12.2639 16.975 11.5486 17.577 10.6042C18.179 9.65972 18.48 8.625 18.48 7.5C18.48 6.375 18.179 5.34028 17.577 4.39583C16.975 3.45139 16.156 2.73611 15.12 2.25V0.416667C16.646 0.944444 17.8675 1.85764 18.7845 3.15625C19.7015 4.45486 20.16 5.90278 20.16 7.5C20.16 9.09722 19.7015 10.5451 18.7845 11.8438C17.8675 13.1424 16.646 14.0556 15.12 14.5833ZM7.56 15C6.51 15 5.5265 14.8021 4.6095 14.4062C3.6925 14.0104 2.8945 13.4757 2.2155 12.8021C1.5365 12.1285 0.9975 11.3368 0.5985 10.4271C0.1995 9.51736 0 8.54167 0 7.5C0 6.45833 0.1995 5.48264 0.5985 4.57292C0.9975 3.66319 1.5365 2.87153 2.2155 2.19792C2.8945 1.52431 3.6925 0.989583 4.6095 0.59375C5.5265 0.197917 6.51 0 7.56 0C8.61 0 9.5935 0.197917 10.5105 0.59375C11.4275 0.989583 12.2255 1.52431 12.9045 2.19792C13.5835 2.87153 14.1225 3.66319 14.5215 4.57292C14.9205 5.48264 15.12 6.45833 15.12 7.5C15.12 8.54167 14.9205 9.51736 14.5215 10.4271C14.1225 11.3368 13.5835 12.1285 12.9045 12.8021C12.2255 13.4757 11.4275 14.0104 10.5105 14.4062C9.5935 14.8021 8.61 15 7.56 15Z"
      fill="currentColor"
    />
  </svg>
);

export const subscriptionIcon = (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.51997 18.3333C3.05797 18.3333 2.66247 18.1701 2.33347 17.8437C2.00447 17.5173 1.83997 17.125 1.83997 16.6666V8.33329C1.83997 7.87496 2.00447 7.4826 2.33347 7.15621C2.66247 6.82982 3.05797 6.66663 3.51997 6.66663H16.96C17.422 6.66663 17.8175 6.82982 18.1465 7.15621C18.4755 7.4826 18.64 7.87496 18.64 8.33329V16.6666C18.64 17.125 18.4755 17.5173 18.1465 17.8437C17.8175 18.1701 17.422 18.3333 16.96 18.3333H3.51997ZM8.55997 15.8333L13.6 12.5L8.55997 9.16663V15.8333ZM3.51997 5.83329V4.16663H16.96V5.83329H3.51997ZM6.03997 3.33329V1.66663H14.44V3.33329H6.03997Z"
      fill="currentColor"
    />
  </svg>
);

export const messagesIcon = (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.51997 18.3333C3.05797 18.3333 2.66247 18.1701 2.33347 17.8437C2.00447 17.5173 1.83997 17.125 1.83997 16.6666V8.33329C1.83997 7.87496 2.00447 7.4826 2.33347 7.15621C2.66247 6.82982 3.05797 6.66663 3.51997 6.66663H16.96C17.422 6.66663 17.8175 6.82982 18.1465 7.15621C18.4755 7.4826 18.64 7.87496 18.64 8.33329V16.6666C18.64 17.125 18.4755 17.5173 18.1465 17.8437C17.8175 18.1701 17.422 18.3333 16.96 18.3333H3.51997ZM8.55997 15.8333L13.6 12.5L8.55997 9.16663V15.8333ZM3.51997 5.83329V4.16663H16.96V5.83329H3.51997ZM6.03997 3.33329V1.66663H14.44V3.33329H6.03997Z"
      fill="currentColor"
    />
  </svg>
);

export const certificateIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z" />
  </svg>
);
export const trainerIcon = (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.918 14.0833L15.616 12.7917C16.232 12.2222 16.715 11.5486 17.065 10.7708C17.415 9.99306 17.59 9.16667 17.59 8.29167C17.59 7.41667 17.415 6.59722 17.065 5.83333C16.715 5.06944 16.232 4.40278 15.616 3.83333L16.918 2.5C17.702 3.23611 18.325 4.10417 18.787 5.10417C19.249 6.10417 19.48 7.16667 19.48 8.29167C19.48 9.41667 19.249 10.4792 18.787 11.4792C18.325 12.4792 17.702 13.3472 16.918 14.0833ZM14.23 11.4167L12.886 10.0833C13.138 9.84722 13.341 9.57986 13.495 9.28125C13.649 8.98264 13.726 8.65278 13.726 8.29167C13.726 7.93056 13.649 7.60069 13.495 7.30208C13.341 7.00347 13.138 6.73611 12.886 6.5L14.23 5.16667C14.678 5.56944 15.028 6.03819 15.28 6.57292C15.532 7.10764 15.658 7.68056 15.658 8.29167C15.658 8.90278 15.532 9.47569 15.28 10.0104C15.028 10.5451 14.678 11.0139 14.23 11.4167ZM7.72 11.625C6.796 11.625 6.005 11.2986 5.347 10.6458C4.689 9.99306 4.36 9.20833 4.36 8.29167C4.36 7.375 4.689 6.59028 5.347 5.9375C6.005 5.28472 6.796 4.95833 7.72 4.95833C8.644 4.95833 9.435 5.28472 10.093 5.9375C10.751 6.59028 11.08 7.375 11.08 8.29167C11.08 9.20833 10.751 9.99306 10.093 10.6458C9.435 11.2986 8.644 11.625 7.72 11.625ZM1 18.2917V15.9583C1 15.5 1.119 15.0694 1.357 14.6667C1.595 14.2639 1.924 13.9583 2.344 13.75C3.058 13.3889 3.863 13.0833 4.759 12.8333C5.655 12.5833 6.642 12.4583 7.72 12.4583C8.798 12.4583 9.785 12.5833 10.681 12.8333C11.577 13.0833 12.382 13.3889 13.096 13.75C13.516 13.9583 13.845 14.2639 14.083 14.6667C14.321 15.0694 14.44 15.5 14.44 15.9583V18.2917H1Z"
      fill="currentColor"
    />
  </svg>
);
export const ratingIcon = (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.188 12.9167L17.38 10.2083L19.9 10.4167L16.204 13.6042L17.296 18.3333L15.154 17.0417L14.188 12.9167ZM12.214 6.83333L11.332 4.79167L12.298 2.5L14.23 7.02083L12.214 6.83333ZM3.79296 18.3333L5.15796 12.4792L0.579956 8.54167L6.62796 8.02083L8.97996 2.5L11.332 8.02083L17.38 8.54167L12.802 12.4792L14.167 18.3333L8.97996 15.2292L3.79296 18.3333Z"
      fill="currentColor"
    />
  </svg>
);

export const aboutIcon = (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.88005 11.375V4.99996H9.40005V11.375L8.14005 10.2083L6.88005 11.375ZM11.0801 12.625V1.66663H13.6001V10.125L11.0801 12.625ZM2.68005 15.5V8.33329H5.20005V13L2.68005 15.5ZM2.68005 17.5416L8.09805 12.1666L11.0801 14.7083L15.7841 10.0416H14.4401V8.37496H18.6401V12.5416H16.9601V11.2083L11.1641 16.9583L8.18205 14.4166L5.03205 17.5416H2.68005Z"
      fill="currentColor"
    />
  </svg>
);
export const shareIcon = (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.68005 17.5V15.8333L4.36005 14.1667V17.5H2.68005ZM6.04005 17.5V12.5L7.72005 10.8333V17.5H6.04005ZM9.40005 17.5V10.8333L11.0801 12.5208V17.5H9.40005ZM12.7601 17.5V12.5208L14.4401 10.8542V17.5H12.7601ZM16.1201 17.5V9.16667L17.8001 7.5V17.5H16.1201ZM2.68005 13.1875V10.8333L8.56005 5L11.9201 8.33333L17.8001 2.5V4.85417L11.9201 10.6875L8.56005 7.35417L2.68005 13.1875Z"
      fill="currentColor"
    />
  </svg>
);

export const grievanceIcon = (
  <svg
    viewBox="0 0 19.00 19.00"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    transform="rotate(0)"
    stroke-width="0.00019"
    fill="currentColor"
  >
    <g
      id="SVGRepo_bgCarrier"
      stroke-width="0"
      transform="translate(0.7599999999999998,0.7599999999999998), scale(0.92)"
    ></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="#fff"
      stroke-width="0.038"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M14.032 5.286v7.276a1.112 1.112 0 0 1-1.108 1.108H8.75l-1.02 1.635a.273.273 0 0 1-.503 0l-1.02-1.635h-4.13a1.112 1.112 0 0 1-1.109-1.108V5.286a1.112 1.112 0 0 1 1.108-1.108h10.848a1.112 1.112 0 0 1 1.108 1.108zM8.206 11.34a.706.706 0 1 0-.706.705.706.706 0 0 0 .706-.705zm-1.26-1.83a.554.554 0 1 0 1.108 0V6.275a.554.554 0 1 0-1.108 0z"></path>
    </g>
  </svg>
);

export const saveIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="black"
      d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V7zm2 16H5V5h11.17L19 7.83zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3M6 6h9v4H6z"
    />
  </svg>
);

export const profileIcon = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.66992 18.9501L7.59992 15.6401C8.38992 15.1101 9.52992 15.1701 10.2399 15.7801L10.5699 16.0701C11.3499 16.7401 12.6099 16.7401 13.3899 16.0701L17.5499 12.5001C18.3299 11.8301 19.5899 11.8301 20.3699 12.5001L21.9999 13.9001"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const cameraIcon = (
  <svg viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 6.33333C1 5.59695 1.59695 5 2.33333 5H22.3294C23.0658 5 23.6628 5.59695 23.6628 6.33333V19.6667C23.6628 20.4031 23.0658 21 22.3294 21H2.33333C1.59695 21 1 20.4031 1 19.6667V6.33333Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M7.46785 1.75439C7.72653 1.28877 8.21731 1 8.74995 1H15.9129C16.4455 1 16.9363 1.28877 17.195 1.75439L18.888 4.80192C18.9374 4.89079 18.8731 5 18.7715 5H5.89134C5.78967 5 5.72541 4.89079 5.77478 4.80192L7.46785 1.75439Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M16.3311 13C16.3311 15.2091 14.5402 17 12.3311 17C10.1219 17 8.33105 15.2091 8.33105 13C8.33105 10.7909 10.1219 9 12.3311 9C14.5402 9 16.3311 10.7909 16.3311 13Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M4.08008 9H6.08008"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
export const deleteProfileIcon = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998"
      stroke="#FF0000"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
      stroke="#FF0000"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.8504 9.14001L18.2004 19.21C18.0904 20.78 18.0004 22 15.2104 22H8.79039C6.00039 22 5.91039 20.78 5.80039 19.21L5.15039 9.14001"
      stroke="#FF0000"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.3301 16.5H13.6601"
      stroke="#FF0000"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.5 12.5H14.5"
      stroke="#FF0000"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const leftArrowIcon = (
  <svg
    viewBox="0 0 15 15"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_22_1753"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="15"
      height="15"
    >
      <rect
        x="15"
        y="15"
        width="15"
        height="15"
        transform="rotate(180 15 15)"
        fill="currentColor"
      />
    </mask>
    <g mask="url(#mask0_22_1753)">
      <path
        d="M8.75 1.25L15 7.5L8.75 13.75L7.64063 12.6406L12.7813 7.5L7.64063 2.35938L8.75 1.25Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export const whiteRightIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path fill="white" d="M12.6 12L8 7.4L9.4 6l6 6l-6 6L8 16.6z" />
  </svg>
);
export const titleIcon = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 13H12"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 17H16"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const typeIcon = (
  <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 21V19"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 17L11 15"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 13V10C11 6.13 14.13 3 18 3H21"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1 3H4C7.87 3 11 6.13 11 10V11V13"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 1L1 3L3 5"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 1L21 3L19 5"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const positionIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 41" fill="none">
    <path
      d="M34.125 11.9582V29.0415C34.125 34.1665 31.6875 37.5832 26 37.5832H13C7.3125 37.5832 4.875 34.1665 4.875 29.0415V11.9582C4.875 6.83317 7.3125 3.4165 13 3.4165H26C31.6875 3.4165 34.125 6.83317 34.125 11.9582Z"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23.5625 7.6875V11.1042C23.5625 12.9833 25.025 14.5208 26.8125 14.5208H30.0625"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13 22.208H19.5"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13 29.0415H26"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const callSplitIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 37" fill="none">
    <path
      d="M16.5771 36V32.5"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.5771 29L16.5771 25.5"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.5771 22V16.75C16.5771 9.9775 21.453 4.5 27.4816 4.5H32.1549"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1 4.5H5.67332C11.7019 4.5 16.5777 9.9775 16.5777 16.75V18.5V22"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.11554 1L1 4.5L4.11554 8.00001"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.04 1L32.1556 4.5L29.04 8.00001"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const padmasanaIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-full"
    viewBox="0 0 40 35"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.88 9.20218C17.6726 10.3255 14.3775 10.7143 13.2714 11.06C12.1423 11.4056 10.7367 11.9456 10.7367 13.6522C10.7367 15.3588 10.5523 15.1644 10.368 16.3093C10.1836 17.4758 9.60756 18.3399 9.308 19.2688C9.00844 20.2193 9.35408 20.9105 8.98539 21.5586C8.63975 22.2067 8.27106 22.1634 7.69498 22.7467C7.1189 23.33 6.9576 23.5244 5.92066 25.2309C4.88372 26.9591 3.68548 27.5208 3.68548 27.5208C3.68548 27.5208 3.2707 27.2183 2.69462 27.2183C1.9342 27.2183 1.98029 27.1319 1.35812 27.5424C1.10465 27.7152 0.82813 27.6936 0.782044 27.888C0.735957 28.0608 0.805087 28.212 0.897259 28.2552C0.966388 28.2985 0.989432 28.2984 0.989432 28.2984C0.989432 28.2984 0.689871 28.6873 0.528569 28.9681C0.367267 29.2489 0.390311 29.4866 0.367267 29.6162C0.344224 29.7458 0.275095 29.789 0.275095 29.9402C0.275095 30.0914 0.390311 30.221 0.528569 30.2642C0.643785 30.3074 0.689871 30.3074 0.689871 30.3074C0.689871 30.3074 0.298138 30.5667 0.113793 30.8043C-0.0705518 31.0635 -0.00142242 31.2795 0.113793 31.4092C0.229009 31.5172 0.436397 31.4956 0.574655 31.4092C0.689871 31.3443 0.759 31.2795 0.759 31.2795C0.759 31.2795 0.666828 31.4956 0.851173 31.6684C1.03552 31.8412 1.35812 31.6252 1.51942 31.5172C1.68073 31.4092 1.63464 31.6468 1.38116 32.122C1.12769 32.5973 1.0816 33.5694 2.07246 34.347C3.08636 35.1031 3.38592 35.0815 6.28935 34.8439C11.1054 34.4334 15.4605 34.1094 20 32.5109C24.5395 34.0878 28.8716 34.4118 33.7107 34.8439C36.6141 35.1031 36.9367 35.1031 37.9275 34.347C38.9414 33.591 38.8493 32.6189 38.6188 32.122C38.3884 31.6468 38.3423 31.3876 38.4806 31.5172C38.6419 31.6252 38.9645 31.8412 39.1488 31.6684C39.3332 31.4956 39.241 31.2795 39.241 31.2795C39.241 31.2795 39.3101 31.3227 39.4253 31.4092C39.5406 31.474 39.771 31.5172 39.8862 31.4092C40.0014 31.3011 40.0706 31.0635 39.8862 30.8043C39.7019 30.5451 39.3101 30.3074 39.3101 30.3074C39.3101 30.3074 39.3562 30.3074 39.4714 30.2642C39.5866 30.221 39.7249 30.0698 39.7249 29.9402C39.7249 29.8106 39.6327 29.7674 39.6327 29.6162C39.6327 29.465 39.6327 29.2489 39.4714 28.9681C39.3101 28.6873 39.0106 28.2984 39.0106 28.2984C39.0106 28.2984 39.0106 28.2985 39.1027 28.2552C39.1719 28.212 39.264 28.0608 39.218 27.888C39.1719 27.7152 38.8954 27.7152 38.6419 27.5424C37.9967 27.1319 38.0658 27.2183 37.3054 27.2183C36.7293 27.2183 36.3145 27.5208 36.3145 27.5208C36.3145 27.5208 35.1163 26.9591 34.0793 25.2309C33.0424 23.5028 32.8811 23.33 32.305 22.7467C31.7289 22.1634 31.3603 22.2067 31.0146 21.5586C30.669 20.9105 31.0146 20.2193 30.692 19.2688C30.3924 18.3183 29.8164 17.4758 29.632 16.3093C29.4477 15.1428 29.2403 15.3372 29.2633 13.6522C29.2633 11.9673 27.8577 11.4056 26.7286 11.06C25.5995 10.7143 22.3043 10.3255 22.12 9.20218C21.9356 8.12207 22.2352 7.77644 22.673 6.80434C22.7652 6.58832 22.7882 6.86915 23.0417 6.67473C23.2952 6.45871 23.226 6.3075 23.5717 6.17788C23.9173 6.02667 23.9634 5.68103 23.9634 5.48661C23.9634 5.2922 24.3552 5.11938 24.2399 4.75214C24.1478 4.38491 23.9404 4.3417 23.733 4.40651C23.5486 4.44971 23.5026 4.55772 23.5026 4.55772C23.5026 4.55772 23.5256 4.49292 23.5486 4.3633C23.6408 4.19049 23.7099 4.01767 23.733 3.90966C23.7791 3.71524 24.0095 3.13198 23.3643 1.77105C22.696 0.431719 22.7652 0.863762 22.4656 0.518128C22.1661 0.172494 21.6821 0.0860857 21.1061 0.0212793C20.507 -0.043527 20.3917 0.0644836 19.7696 0.0212793C19.1474 -0.0219249 19.0091 -0.0219249 18.5713 0.280505C18.1566 0.561332 18.1796 0.712547 18.1796 0.712547C18.1796 0.712547 17.9953 0.647741 17.7879 0.604537C17.5574 0.561332 17.2348 0.669343 16.9814 1.12299C16.7279 1.57663 16.8431 1.68464 16.5435 2.2679C16.244 2.85116 16.1748 3.52082 16.3822 4.03927C16.4514 4.19049 16.4974 4.2985 16.5435 4.3633C16.5666 4.47131 16.5896 4.53612 16.5896 4.53612C16.5896 4.53612 16.5435 4.44971 16.3592 4.38491C16.1748 4.3417 15.9675 4.38491 15.8522 4.73054C15.7601 5.09778 16.1518 5.2922 16.1288 5.46501C16.1288 5.63783 16.1748 6.00506 16.5205 6.15628C16.8661 6.30749 16.797 6.45871 17.0505 6.65313C17.304 6.86915 17.304 6.56672 17.4192 6.78274C17.834 7.73323 18.1566 8.14367 17.9722 9.18058L17.88 9.20218ZM7.37237 28.1904C7.37237 28.1904 7.32629 28.0824 7.34933 27.996C7.34933 27.456 8.15584 26.9159 8.84713 26.7863C9.51538 26.6567 9.86103 26.7863 10.1606 26.6351C10.4832 26.4839 11.0593 25.8358 12.2575 26.1814C12.534 26.2679 12.7414 26.3327 12.9258 26.4191C13.1101 26.3759 13.2945 26.3111 13.4788 26.2679C13.4788 26.2462 13.4327 26.2246 13.4097 26.1814C13.2714 26.0302 13.7784 26.0518 14.0088 25.8574C14.124 25.7494 14.2392 25.7494 14.3084 25.7494C14.3084 25.7062 14.3544 25.6414 14.3775 25.5766C14.3084 25.3822 14.1471 25.4686 14.2853 25.2742C14.4236 25.0797 14.3314 25.1229 14.4005 24.7557C14.4697 24.4101 14.2623 24.3021 14.3544 24.086C14.3544 24.0428 14.4005 24.0212 14.4236 23.9996C14.2853 22.4227 13.7784 20.2409 13.1101 19.0311C13.1101 19.0311 12.9027 19.9816 12.534 20.6081C12.1653 21.213 11.958 21.9258 11.8888 22.3147C11.5432 24.1292 11.6354 23.4164 10.5062 24.9501C9.65364 26.1382 7.62585 27.2183 6.22022 28.2984C4.81459 29.3786 5.13719 29.2921 5.13719 29.2921C5.13719 29.2921 5.92066 28.8601 7.39542 28.1688L7.37237 28.1904ZM32.5585 28.1904C32.5585 28.1904 32.6046 28.0824 32.5815 27.996C32.5815 27.456 31.775 26.9159 31.0837 26.7863C30.4155 26.6567 30.0698 26.7863 29.7703 26.6351C29.4477 26.4839 28.8716 25.8358 27.6734 26.1814C27.3968 26.2679 27.1895 26.3327 27.0051 26.4191C26.7977 26.3759 26.6134 26.3111 26.429 26.2679C26.4521 26.2246 26.4751 26.203 26.5212 26.1598C26.6595 26.0086 26.1525 26.0302 25.9221 25.8358C25.8069 25.7278 25.6686 25.7278 25.5995 25.7278C25.5995 25.6846 25.5534 25.6414 25.5534 25.5766C25.6225 25.3822 25.7838 25.447 25.6456 25.2526C25.5073 25.0581 25.5995 25.1013 25.5303 24.7341C25.4612 24.3885 25.6686 24.2805 25.5764 24.0644C25.5764 24.0212 25.5303 23.9996 25.5073 23.978C25.6456 22.4011 26.1525 20.2409 26.8208 19.0311C26.8208 19.0311 27.0282 19.9816 27.3968 20.6081C27.7655 21.213 27.9729 21.9258 28.042 22.3147C28.3877 24.1292 28.2955 23.4164 29.4246 24.9501C30.2772 26.1382 32.305 27.2183 33.7107 28.2984C35.1163 29.3786 34.7937 29.2921 34.7937 29.2921C34.7937 29.2921 34.0102 28.8601 32.5355 28.1688L32.5585 28.1904Z"
      fill="black"
    />
  </svg>
);

export const rupeeIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 31" fill="none">
    <path
      d="M2.27273 0H25L22.7273 3.44444H15.3182C16.4091 4.44333 17.2273 5.61444 17.7045 6.88889H25L22.7273 10.3333H18.1818C17.6136 14.7594 13.0455 18.3072 7.27273 18.8756V18.9444H5.68182L19.3182 31H13.6364L0 18.9444V15.5H5.68182C9.68182 15.5 13 13.2611 13.5455 10.3333H0L2.27273 6.88889H12.8636C11.5909 4.85667 8.86364 3.44444 5.68182 3.44444H0L2.27273 0Z"
      fill="black"
    />
  </svg>
);
export const rupeeTrainerIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="none">
    <g clip-path="url(#clip0_692_227)">
      <path
        d="M10.8398 25.7324C11.2443 25.7324 11.5723 25.4045 11.5723 25C11.5723 24.5955 11.2443 24.2676 10.8398 24.2676C10.4353 24.2676 10.1074 24.5955 10.1074 25C10.1074 25.4045 10.4353 25.7324 10.8398 25.7324Z"
        fill="black"
      />
      <path
        d="M39.1602 25.7324C39.5647 25.7324 39.8926 25.4045 39.8926 25C39.8926 24.5955 39.5647 24.2676 39.1602 24.2676C38.7557 24.2676 38.4277 24.5955 38.4277 25C38.4277 25.4045 38.7557 25.7324 39.1602 25.7324Z"
        fill="black"
      />
      <path
        d="M25 49.2676C11.6016 49.2676 0.732422 38.3984 0.732422 25C0.732422 18.5645 3.29102 12.3926 7.8418 7.8418C17.373 -1.58203 32.7441 -1.48437 42.1582 8.04688C51.5039 17.5 51.5039 32.7051 42.1582 42.168C37.6172 46.7285 31.4355 49.2871 25 49.2676Z"
        fill="#F8BE32"
      />
      <path
        d="M25 44.8242C14.0527 44.8242 5.17578 35.9473 5.17578 25C5.17578 19.7461 7.26563 14.6973 10.9863 10.9766C18.7305 3.23242 31.2793 3.23242 39.0234 10.9766C46.7676 18.7207 46.7676 31.2695 39.0234 39.0137C35.3125 42.7441 30.2637 44.834 25 44.8242Z"
        fill="#FED947"
      />
      <path
        d="M39.0137 10.9766C35.3125 7.25586 30.2637 5.16602 25 5.17578C24.2676 5.17578 23.5352 5.21484 22.8027 5.29297C33.6816 6.51367 41.5234 16.3086 40.3125 27.1973C39.8145 31.6699 37.8125 35.8398 34.6289 39.0234C31.4551 42.2168 27.2852 44.2188 22.8125 44.707C23.5449 44.7852 24.2676 44.8242 25.0098 44.8242C35.957 44.8242 44.834 35.9473 44.834 25C44.8242 19.7461 42.7344 14.6973 39.0137 10.9766Z"
        fill="#FED030"
      />
      <path
        d="M10.8398 24.2676C10.4395 24.2676 10.1074 24.5996 10.1074 25C10.1074 25.4004 10.4395 25.7324 10.8398 25.7324C11.2402 25.7324 11.5723 25.4004 11.5723 25C11.5723 24.5996 11.2402 24.2676 10.8398 24.2676ZM39.1602 24.2676C38.7598 24.2676 38.4277 24.5996 38.4277 25C38.4277 25.4004 38.7598 25.7324 39.1602 25.7324C39.5605 25.7324 39.8926 25.4004 39.8926 25C39.8926 24.5996 39.5605 24.2676 39.1602 24.2676Z"
        fill="#3C3B41"
      />
      <path
        d="M32.1973 14.8535C32.1973 14.4531 31.8652 14.1211 31.4648 14.1211H18.5352C18.1348 14.1211 17.8027 14.4531 17.8027 14.8535C17.8027 15.2539 18.1348 15.5859 18.5352 15.5859H23.0566C25.3809 15.5859 27.3633 17.2656 27.7344 19.5605H18.5352C18.1348 19.5605 17.8027 19.8926 17.8027 20.293C17.8027 20.6934 18.1348 21.0254 18.5352 21.0254H27.7344C27.3633 23.3203 25.3809 25 23.0566 25H18.5352C18.5352 25 18.5352 25 18.5254 25C18.5156 25 18.4961 25 18.4863 25C18.4766 25 18.4668 25 18.457 25C18.4473 25 18.4375 25 18.418 25.0098C18.4082 25.0098 18.3984 25.0098 18.3789 25.0195C18.3691 25.0195 18.3594 25.0293 18.3496 25.0293C18.3398 25.0293 18.3203 25.0391 18.3105 25.0391C18.3008 25.0391 18.291 25.0488 18.2812 25.0488C18.2715 25.0488 18.2617 25.0586 18.2422 25.0586C18.2324 25.0684 18.2227 25.0684 18.2031 25.0781C18.1934 25.0781 18.1836 25.0879 18.1738 25.0879C18.1641 25.0977 18.1543 25.0977 18.1348 25.1074C18.125 25.1172 18.1152 25.1172 18.1055 25.127C18.0957 25.1367 18.0859 25.1367 18.0762 25.1465C18.0664 25.1562 18.0566 25.1563 18.0469 25.166C18.0371 25.1758 18.0273 25.1758 18.0273 25.1855C18.0176 25.1953 18.0078 25.2051 17.998 25.2148C17.998 25.2148 17.998 25.2148 17.9883 25.2148C17.9785 25.2246 17.9785 25.2246 17.9688 25.2344C17.959 25.2441 17.9492 25.2539 17.9395 25.2637C17.9297 25.2734 17.9297 25.2832 17.9199 25.293C17.9102 25.3027 17.9102 25.3125 17.9004 25.3223C17.8906 25.332 17.8906 25.3418 17.8809 25.3516C17.8711 25.3613 17.8711 25.3711 17.8613 25.3809C17.8516 25.3906 17.8516 25.4004 17.8418 25.4102C17.8418 25.4199 17.832 25.4297 17.832 25.4395C17.832 25.4492 17.8223 25.459 17.8223 25.4785C17.8223 25.4883 17.8125 25.498 17.8125 25.5078C17.8125 25.5176 17.8027 25.5273 17.8027 25.5469C17.8027 25.5566 17.793 25.5664 17.793 25.5859C17.793 25.5957 17.793 25.6152 17.7832 25.625C17.7832 25.6348 17.7832 25.6445 17.7832 25.6543C17.7832 25.6641 17.7832 25.6836 17.7832 25.6934C17.7832 25.7031 17.7832 25.7129 17.7832 25.7129C17.7832 25.7129 17.7832 25.7129 17.7832 25.7227C17.7832 25.7324 17.7832 25.752 17.7832 25.7617C17.7832 25.7715 17.7832 25.7812 17.7832 25.791C17.7832 25.8008 17.7832 25.8203 17.793 25.8301C17.793 25.8398 17.793 25.8496 17.8027 25.8594C17.8027 25.8691 17.8125 25.8789 17.8125 25.8984C17.8125 25.9082 17.8223 25.918 17.8223 25.9375C17.8223 25.9473 17.832 25.957 17.832 25.9766C17.832 25.9863 17.8418 25.9961 17.8418 26.0059C17.8516 26.0156 17.8516 26.0352 17.8613 26.0449C17.8613 26.0547 17.8711 26.0645 17.8711 26.0742C17.8809 26.084 17.8809 26.0938 17.8906 26.1133C17.9004 26.123 17.9004 26.1328 17.9102 26.1328C17.9199 26.1426 17.9297 26.1523 17.9297 26.1621C17.9395 26.1719 17.9395 26.1816 17.9492 26.1914C17.959 26.2012 17.959 26.2109 17.9688 26.2109C17.9785 26.2207 17.9883 26.2305 17.998 26.2402C17.998 26.2402 17.998 26.2402 17.998 26.25L27.7832 35.6641C28.0762 35.9473 28.5352 35.9375 28.8184 35.6445C29.1016 35.3516 29.0918 34.8926 28.7988 34.6094L20.3516 26.4648H23.0566C26.1914 26.4648 28.8281 24.1309 29.209 21.0254H31.4648C31.8652 21.0254 32.1973 20.6934 32.1973 20.293C32.1973 19.8926 31.8652 19.5605 31.4648 19.5605H29.209C29.0234 18.0078 28.252 16.5918 27.0605 15.5859H31.4648C31.875 15.5859 32.1973 15.2539 32.1973 14.8535ZM42.6758 7.32422C32.9102 -2.44141 17.0898 -2.44141 7.32422 7.32422C-2.44141 17.0898 -2.44141 32.9102 7.32422 42.6758C17.0898 52.4414 32.9199 52.4414 42.6758 42.6758C52.4316 32.9102 52.4414 17.0898 42.6758 7.32422ZM41.6406 41.6406C32.4512 50.8301 17.5488 50.8398 8.35938 41.6504C-0.830078 32.4609 -0.839844 17.5586 8.34961 8.36914L8.35938 8.35938C17.5488 -0.830078 32.4512 -0.839844 41.6406 8.34961C50.8301 17.5391 50.8398 32.4414 41.6406 41.6406ZM39.9121 10.0879C31.6699 1.8457 18.3203 1.8457 10.0781 10.0879C1.83594 18.3301 1.83594 31.6797 10.0781 39.9219C18.3203 48.1641 31.6699 48.1641 39.9121 39.9219C48.1543 31.6797 48.1543 18.3203 39.9121 10.0879ZM25 44.6289C14.1797 44.6289 5.37109 35.8203 5.37109 25C5.37109 14.1797 14.1797 5.37109 25 5.37109C35.8203 5.37109 44.6289 14.1797 44.6289 25C44.6289 35.8203 35.8203 44.6289 25 44.6289Z"
        fill="#3C3B41"
      />
    </g>
    <defs>
      <clipPath id="clip0_692_227">
        <rect width="50" height="50" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const whiteRupeeIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="white"
      d="M8 3h10l-1 2h-3.26c.48.58.84 1.26 1.05 2H18l-1 2h-2a5.56 5.56 0 0 1-4.8 4.96V14h-.7l6 7H13l-6-7v-2h2.5c1.76 0 3.22-1.3 3.46-3H7l1-2h4.66C12.1 5.82 10.9 5 9.5 5H7z"
    />
  </svg>
);
export const darkStarIcon = (
  <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.36656 2.15235L9.43906 4.31084C9.58531 4.61131 9.97531 4.89952 10.3044 4.9547L12.2483 5.2797C13.4914 5.48819 13.7839 6.39574 12.8881 7.29102L11.3769 8.81178C11.1209 9.06933 10.9808 9.56602 11.06 9.92169L11.4927 11.8042C11.8339 13.2943 11.0478 13.8707 9.73765 13.092L7.91562 12.0066C7.58656 11.8104 7.04421 11.8104 6.70906 12.0066L4.88703 13.092C3.58296 13.8707 2.79078 13.2882 3.13203 11.8042L3.56468 9.92169C3.6439 9.56602 3.50374 9.06933 3.24781 8.81178L1.73656 7.29102C0.846869 6.39574 1.13328 5.48819 2.3764 5.2797L4.32031 4.9547C4.64328 4.89952 5.03328 4.61131 5.17953 4.31084L6.25203 2.15235C6.83703 0.981119 7.78765 0.981119 8.36656 2.15235Z"
      fill="#FFC71D"
      stroke="#FFC71D"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const StarIcon = (
  <svg viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.86656 2.15235L9.93906 4.31084C10.0853 4.61131 10.4753 4.89952 10.8044 4.9547L12.7483 5.2797C13.9914 5.48819 14.2839 6.39574 13.3881 7.29102L11.8769 8.81178C11.6209 9.06933 11.4808 9.56602 11.56 9.92169L11.9927 11.8042C12.3339 13.2943 11.5478 13.8707 10.2376 13.092L8.41562 12.0066C8.08656 11.8104 7.54421 11.8104 7.20906 12.0066L5.38703 13.092C4.08296 13.8707 3.29078 13.2882 3.63203 11.8042L4.06468 9.92169C4.1439 9.56602 4.00374 9.06933 3.74781 8.81178L2.23656 7.29102C1.34687 6.39574 1.63328 5.48819 2.8764 5.2797L4.82031 4.9547C5.14328 4.89952 5.53328 4.61131 5.67953 4.31084L6.75203 2.15235C7.33703 0.981119 8.28765 0.981119 8.86656 2.15235Z"
      fill="white"
      stroke="#030303"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const contentIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 41" fill="none">
    <path
      d="M34.125 11.9582V29.0415C34.125 34.1665 31.6875 37.5832 26 37.5832H13C7.3125 37.5832 4.875 34.1665 4.875 29.0415V11.9582C4.875 6.83317 7.3125 3.4165 13 3.4165H26C31.6875 3.4165 34.125 6.83317 34.125 11.9582Z"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23.5625 7.6875V11.1042C23.5625 12.9833 25.025 14.5208 26.8125 14.5208H30.0625"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13 22.208H19.5"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13 29.0415H26"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const pathLineIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 37" fill="none">
    <path
      d="M16.5771 36V32.5"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.5771 29L16.5771 25.5"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.5771 22V16.75C16.5771 9.9775 21.453 4.5 27.4816 4.5H32.1549"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1 4.5H5.67332C11.7019 4.5 16.5777 9.9775 16.5777 16.75V18.5V22"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.11554 1L1 4.5L4.11554 8.00001"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.04 1L32.1556 4.5L29.04 8.00001"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const uploadFile = (
  <svg
    viewBox="0 0 28 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="identity-file"
  >
    <path
      d="M10.5003 18.4167V11.9167L8.16699 14.0834"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.5 11.9167L12.8333 14.0834"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M25.6663 10.8334V16.2501C25.6663 21.6667 23.333 23.8334 17.4997 23.8334H10.4997C4.66634 23.8334 2.33301 21.6667 2.33301 16.2501V9.75008C2.33301 4.33341 4.66634 2.16675 10.4997 2.16675H16.333"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M25.6663 10.8334H20.9997C17.4997 10.8334 16.333 9.75008 16.333 6.50008V2.16675L25.6663 10.8334Z"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const addCertificateIcon = (
  <svg
    viewBox="0 0 34 34"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 17H25.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17 25.5V8.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const transactionIcon = (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.2929 3.29289C15.6834 2.90237 16.3166 2.90237 16.7071 3.29289L22.3657 8.95147C23.1216 9.70743 22.5862 11 21.5172 11H2C1.44772 11 1 10.5523 1 10C1 9.44772 1.44772 9 2 9H19.5858L15.2929 4.70711C14.9024 4.31658 14.9024 3.68342 15.2929 3.29289ZM4.41421 15H22C22.5523 15 23 14.5523 23 14C23 13.4477 22.5523 13 22 13H2.48284C1.41376 13 0.878355 14.2926 1.63431 15.0485L7.29289 20.7071C7.68342 21.0976 8.31658 21.0976 8.70711 20.7071C9.09763 20.3166 9.09763 19.6834 8.70711 19.2929L4.41421 15Z"
      fill="currentColor"
    />
  </svg>
);

export const crossRemove = (
  <svg viewBox="0 0 46 46" fill="white" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.1979 32.0521C18.3828 37.237 26.8672 37.237 32.0521 32.0521C37.237 26.8672 37.237 18.3829 32.0521 13.198C26.8672 8.01306 18.3828 8.01306 13.1979 13.198C8.01302 18.3829 8.01302 26.8672 13.1979 32.0521Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.8545 18.8541L26.3962 26.3958"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.8538 26.3958L26.3955 18.8541"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const lockIcon = (
  <svg viewBox="0 0 32 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99997 15.6863V12.5491C7.99997 7.35694 9.3333 3.13733 16 3.13733C22.6666 3.13733 24 7.35694 24 12.5491V15.6863"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 29.0197C17.841 29.0197 19.3334 27.2639 19.3334 25.0981C19.3334 22.9323 17.841 21.1765 16 21.1765C14.1591 21.1765 12.6667 22.9323 12.6667 25.0981C12.6667 27.2639 14.1591 29.0197 16 29.0197Z"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.6667 34.5099H9.33335C4.00002 34.5099 2.66669 32.9413 2.66669 26.6668V23.5295C2.66669 17.255 4.00002 15.6864 9.33335 15.6864H22.6667C28 15.6864 29.3334 17.255 29.3334 23.5295V26.6668C29.3334 32.9413 28 34.5099 22.6667 34.5099Z"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const leftArrow = (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="mask0_16_5848" maskUnits="userSpaceOnUse" x="0" y="0">
      <rect width="20" height="20" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_16_5848)">
      <path
        d="M8.33333 18.3333L0 9.99996L8.33333 1.66663L9.8125 3.14579L2.95833 9.99996L9.8125 16.8541L8.33333 18.3333Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export const rightArrow = (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_16_5851"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect
        x="20"
        y="20"
        width="20"
        height="20"
        transform="rotate(180 20 20)"
        fill="currentColor"
      />
    </mask>
    <g mask="url(#mask0_16_5851)">
      <path
        d="M11.6667 1.66671L20 10L11.6667 18.3334L10.1875 16.8542L17.0417 10L10.1875 3.14587L11.6667 1.66671Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export const infoIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
  </svg>
);

export const errorIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" />
  </svg>
);

export const fillHeartIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.5 47.5" id="heart">
    <defs>
      <clipPath id="a">
        <path d="M0 38h38V0H0v38Z"></path>
      </clipPath>
    </defs>
    <g clipPath="url(#a)" transform="matrix(1.25 0 0 -1.25 0 47.5)">
      <path
        fill="#dd2e44"
        d="M3.067 25.68c0 8.799 12.184 12.06 15.933 1.874 3.749 10.186 15.933 6.925 15.933-1.874C34.933 16.12 19 3.999 19 3.999S3.067 16.12 3.067 25.68"
      ></path>
    </g>
  </svg>
);

export const flatHeartIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" id="heart">
    <path d="M349.6 64c-36.4 0-70.718 16.742-93.6 43.947C233.117 80.742 198.8 64 162.4 64 97.918 64 48 114.221 48 179.095c0 79.516 70.718 143.348 177.836 241.694L256 448l30.164-27.211C393.281 322.442 464 258.61 464 179.095 464 114.221 414.082 64 349.6 64zm-80.764 329.257l-4.219 3.873-8.617 7.773-8.616-7.772-4.214-3.869c-50.418-46.282-93.961-86.254-122.746-121.994C92.467 236.555 80 208.128 80 179.095c0-22.865 8.422-43.931 23.715-59.316C118.957 104.445 139.798 96 162.4 96c26.134 0 51.97 12.167 69.11 32.545L256 157.661l24.489-29.116C297.63 108.167 323.465 96 349.6 96c22.603 0 43.443 8.445 58.686 23.778C423.578 135.164 432 156.229 432 179.095c0 29.033-12.467 57.459-40.422 92.171-28.784 35.74-72.325 75.709-122.742 121.991z"></path>
  </svg>
);

export const shareItemIcon = (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 11.5L13 14.5M13 5.5L7 8.5M16 19C14.3431 19 13 17.6569 13 16C13 14.3431 14.3431 13 16 13C17.6569 13 19 14.3431 19 16C19 17.6569 17.6569 19 16 19ZM4 13C2.34315 13 1 11.6569 1 10C1 8.34315 2.34315 7 4 7C5.65685 7 7 8.34315 7 10C7 11.6569 5.65685 13 4 13ZM16 7C14.3431 7 13 5.65685 13 4C13 2.34315 14.3431 1 16 1C17.6569 1 19 2.34315 19 4C19 5.65685 17.6569 7 16 7Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const removeFavoritesIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    viewBox="0 0 256 256"
    xmlSpace="preserve"
  >
    <defs></defs>
    <g
      style={{
        stroke: "none",
        strokeWidth: 0,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "none",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
    >
      <circle
        cx={45}
        cy={45}
        r={45}
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "rgb(230,62,50)",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform="  matrix(1 0 0 1 0 0) "
      />
      <path
        d="M 70.216 47 H 19.784 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 50.432 c 1.104 0 2 0.896 2 2 S 71.32 47 70.216 47 z"
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "rgb(255,255,255)",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform=" matrix(1 0 0 1 0 0) "
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const externalLinkIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="#ABAEB6">
    <path d="M 9 2 L 9 3 L 12.292969 3 L 6.023438 9.273438 L 6.726563 9.976563 L 13 3.707031 L 13 7 L 14 7 L 14 2 Z M 4 4 C 2.894531 4 2 4.894531 2 6 L 2 12 C 2 13.105469 2.894531 14 4 14 L 10 14 C 11.105469 14 12 13.105469 12 12 L 12 7 L 11 8 L 11 12 C 11 12.550781 10.550781 13 10 13 L 4 13 C 3.449219 13 3 12.550781 3 12 L 3 6 C 3 5.449219 3.449219 5 4 5 L 8 5 L 9 4 Z"></path>
  </svg>
);

export const premiumIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
    <path d="m387-412 35-114-92-74h114l36-112 36 112h114l-93 74 35 114-92-71-93 71ZM240-40v-309q-38-42-59-96t-21-115q0-134 93-227t227-93q134 0 227 93t93 227q0 61-21 115t-59 96v309l-240-80-240 80Zm240-280q100 0 170-70t70-170q0-100-70-170t-170-70q-100 0-170 70t-70 170q0 100 70 170t170 70ZM320-159l160-41 160 41v-124q-35 20-75.5 31.5T480-240q-44 0-84.5-11.5T320-283v124Zm160-62Z" />
  </svg>
);
export const whitePremiumIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="white"
      d="m12 11.925l-1.7 1.3q-.15.125-.3.013t-.1-.288l.65-2.1l-1.75-1.4q-.125-.125-.075-.287T8.95 9h2.15l.65-2.05q.05-.175.25-.175t.25.175L12.9 9h2.125q.175 0 .238.163t-.063.287l-1.775 1.4l.65 2.1q.05.175-.1.288t-.3-.013zM12 21l-4.675 1.55q-.5.175-.913-.125t-.412-.8v-6.35q-.95-1.05-1.475-2.4T4 10q0-3.35 2.325-5.675T12 2t5.675 2.325T20 10q0 1.525-.525 2.875T18 15.275v6.35q0 .5-.413.8t-.912.125zm0-5q2.5 0 4.25-1.75T18 10t-1.75-4.25T12 4T7.75 5.75T6 10t1.75 4.25T12 16"
    />
  </svg>
);
export const exitArrow = (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5638 7.16534L4.22922 14.4999L11.5638 21.8345"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24.7709 14.5H4.43463"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const sendIcon = (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.3218 8.13144L1.31013 9.3326C0.904846 9.35177 0.551683 9.61482 0.417263 9.99764C0.284899 10.3815 0.398741 10.8073 0.705012 11.0738L7.57344 17.0928L9.39498 26.0257C9.45612 26.3325 9.65786 26.5928 9.93974 26.7285C10.2216 26.8642 10.5509 26.8597 10.8289 26.7162C10.9635 26.6374 11.0777 26.5281 11.1623 26.3971L22.2084 9.66707C22.4113 9.35312 22.4214 8.952 22.2345 8.62828C22.0476 8.30455 21.6952 8.1127 21.3218 8.13144ZM10.8097 23.2763L9.54662 17.1038L18.1738 12.1229L10.8097 23.2763ZM3.83672 11.1982L8.55069 15.3784L17.221 10.3726L3.83672 11.1982Z"
      fill="#231F20"
    />
  </svg>
);

export const cancelIcon = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.17188 9.17163L14.8287 14.8285"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.17127 14.8285L14.8281 9.17163"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const rightArrowIcon = (
  <svg viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.4359 7.16528L24.7705 14.4999L17.4359 21.8344"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.22918 14.5H24.5654"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const attachmentIcon = (
  <svg fill="none" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 4.5V0H1V4.5C1 5.32843 1.67157 6 2.5 6C3.32843 6 4 5.32843 4 4.5V1.5C4 1.22386 3.77614 1 3.5 1C3.22386 1 3 1.22386 3 1.5V5H2V1.5C2 0.671573 2.67157 0 3.5 0C4.32843 0 5 0.671573 5 1.5V4.5C5 5.88071 3.88071 7 2.5 7C1.11929 7 0 5.88071 0 4.5Z"
      fill="black"
    />
    <path
      clip-rule="evenodd"
      d="M12.5 0H6V4.5C6 6.433 4.433 8 2.5 8H1V13.5C1 14.3284 1.67157 15 2.5 15H12.5C13.3284 15 14 14.3284 14 13.5V1.5C14 0.671573 13.3284 0 12.5 0ZM11 4H7V5H11V4ZM11 7H7V8H11V7ZM4 10H11V11H4V10Z"
      fill="black"
      fill-rule="evenodd"
    />
  </svg>
);
export const myPosts = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
    <path
      d="M720-120H280v-520l280-280 50 50q7 7 11.5 19t4.5 23v14l-44 174h258q32 0 56 24t24 56v80q0 7-2 15t-4 15L794-168q-9 20-30 34t-44 14Zm-360-80h360l120-280v-80H480l54-220-174 174v406Zm0-406v406-406Zm-80-34v80H160v360h120v80H80v-520h200Z"
      fill="currentColor"
    />
  </svg>
);
export const draftIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
    <path d="M160-400v-80h280v80H160Zm0-160v-80h440v80H160Zm0-160v-80h440v80H160Zm360 560v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T863-380L643-160H520Zm300-263-37-37 37 37ZM580-220h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z" />
  </svg>
);
export const serviceCategoryIcon = (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M4 11h6a1 1 0 001-1V4a1 1 0 00-1-1H4a1 1 0 00-1 1v6a1 1 0 001 1zm10 0h6a1 1 0 001-1V4a1 1 0 00-1-1h-6a1 1 0 00-1 1v6a1 1 0 001 1zM4 21h6a1 1 0 001-1v-6a1 1 0 00-1-1H4a1 1 0 00-1 1v6a1 1 0 001 1zm13 0c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4z" />
  </svg>
);

export const myLocationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 -960 960 960"
  >
    <path d="M480-360q56 0 101-27.5t71-72.5q-35-29-79-44.5T480-520q-49 0-93 15.5T308-460q26 45 71 72.5T480-360Zm0-200q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0 374q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
  </svg>
);
export const trainerAvailabilityIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fill="currentColor"
      d="M6 12.917A7 7 0 0 1 12.917 6A6.002 6.002 0 0 0 1 7a6 6 0 0 0 5 5.917m3.354-8.27a.5.5 0 0 1 0 .707l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L6 7.293l2.646-2.647a.5.5 0 0 1 .708 0M13 19a6 6 0 1 0 0-12a6 6 0 0 0 0 12m-1.646-8.354L13 12.293l1.646-1.647a.5.5 0 0 1 .708.708L13.707 13l1.647 1.646a.5.5 0 0 1-.708.708L13 13.707l-1.646 1.647a.5.5 0 0 1-.708-.708L12.293 13l-1.647-1.646a.5.5 0 0 1 .708-.708"
    />
  </svg>
);
export const addPostIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
    <path d="M440-280h80v-160h160v-80H520v-160h-80v160H280v80h160v160Zm40 200q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
  </svg>
);
export const animateSpinIcon = (
  <svg
    className="animate-spin"
    viewBox="0 0 100 101"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
      fill="#E5E7EB"
    />
    <path
      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
      fill="currentColor"
    />
  </svg>
);

export const vpServiceIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2656.7493 1570.6924">
    <path
      d="M2009.9493,1485.364c-142.1012-6.7307-287.0159-56.0863-412.5337-131.6266
	c155.9614,14.6146,316.608-5.3912,460.1281-61.0167c88.8953-39.0043,172.1074-92.7838,246.2258-157.385
	c109.6709,33.8163,213.9905,86.5568,304.6047,154.1068c-82.0212-73.043-177.5359-133.0031-279.9077-176.3229
	c81.4104-75.7308,150.6865-164.752,202.7981-261.4777c-61.0193,92.9056-140.8367,179.489-232.3518,249.5391
	c-89.6096-34.6779-183.8657-56.6301-278.5179-63.5557c67.7562-65.87,125.6564-142.8809,171.9276-226.6155
	c114.6228-5.7328,230.6895,8.1475,338.9421,40.6321c-102.0571-40.5851-212.3181-64.2612-323.3333-69.9551
	c50.5999-99.0078,85.2515-206.3544,101.1377-315.0702c-25.564,108.1729-70.9543,216.8336-132.9917,313.9593
	c-96.0662-1.9384-192.1453,9.671-283.4579,35.5361c41.1404-85.0716,69.2094-177.2412,84.0509-271.7518
	c105.7493-44.5904,219.5647-71.2443,332.3987-77.7437c-109.783-3.2318-221.4924,12.2312-327.7595,44.8502
	c13.6852-110.3432,9.5323-223.0672-12.7218-330.66c12.9745,110.3926,7.4856,228.0248-17.5916,340.5111
	c-90.9353,31.035-177.25,74.8053-254.2094,130.3414c9.5634-94.0122,4.4159-190.2233-13.9622-284.1104
	c84.1212-78.0696,181.9559-142.0431,285.7631-186.7421c-104.2679,34.511-203.9518,87.2487-292.6543,154.2459
	c-24.8788-108.3694-67.3353-212.8749-125.0468-306.3677c49.949,99.2975,85.0233,211.713,99.931,325.9923
	c-74.8367,60.2652-140.9758,130.9172-194.2996,209.4258c-23.1674-91.6136-60.9104-180.2617-110.2913-262.2011
	c52.347-102.1328,122.4008-195.7096,204.6598-273.217c-86.1764,68.0914-161.8114,151.7425-222.2494,245.0374
	c-60.4435-93.3247-136.0826-177.0069-222.2899-245.123c80.8988,76.2256,152.3065,169.8654,205.4009,272.154
	c-49.7122,82.2264-87.6978,171.2387-110.9546,263.2504c-53.1033-78.1652-118.8905-148.5583-193.3175-208.6669
	c14.2583-113.8769,48.0826-225.7702,98.8712-326.7375c-57.6901,93.459-100.1536,197.9338-125.0386,306.2737
	c-88.7169-67.0236-188.4153-119.7889-292.7211-154.3125c102.0902,43.9597,201.2183,107.5296,286.0958,185.4901
	c-18.5903,94.2702-23.8416,190.9061-14.2259,285.3229c-76.6343-55.2886-162.5297-98.9362-253.0276-129.9641
	c-25.5496-111.8861-32.0351-228.5999-18.8423-340.8489c-22.2465,107.5541-26.416,220.2514-12.7458,330.5688
	c-106.29-32.6384-218.0227-48.123-327.8457-44.89c110.969,6.3917,225.8602,32.224,332.2831,76.4532
	c14.7727,94.9432,42.8898,187.5472,84.2183,272.9813c-90.9229-25.7435-186.5661-37.3809-282.2183-35.5856
	c-62.2762-96.3998-108.2892-203.857-134.2831-313.8489c15.8809,108.6765,50.5076,216.0037,101.084,314.9925
	c-111.0434,5.6832-221.334,29.3474-323.4277,69.9471c106.4628-31.9473,223.261-46.9681,338.3925-41.8051
	c46.3547,84.1648,104.4483,161.5676,172.5041,227.7141c-94.2444,6.9065-188.0999,28.6832-277.3691,63.085
	c-91.4918-69.2865-171.4821-154.5259-233.5276-248.9939c52.0923,96.6908,121.3388,185.7024,202.7211,261.4232
	c-102.4022,43.3196-197.9477,103.2783-279.9986,176.3475c89.115-66.4329,193.7321-120.4952,303.6866-155.021
	c74.5413,65.1544,158.3182,119.3541,247.8623,158.5361c140.0854,57.7041,302.2555,76.309,458.1652,61.2852
	c-134.201,79.9629-289.2568,128.3739-442.9421,131.9347c-200.9429-3.236-405.5503-76.549-566.772-196.735
	c162.9435,145.1073,379.1075,238.6549,596.5984,252.4628c220.8058,9.2074,457.3292-75.8114,632.6653-209.0782l50.639-43.302
	l0.062-0.0231l0.0662-0.0005l0.0619,0.0219l0.051,0.042l0.0337,0.0568l0.0117,0.0651l-0.011,0.0649l-0.0323,0.0577l-0.1467,0.1254
	l50.7356,43.3844c178.2162,135.4559,409.8608,213.6943,633.254,209.072c217.2887-14.0143,433.1984-107.4668,596.0104-252.4564
	C2441.1091,1414.1334,2219.2419,1495.2773,2009.9493,1485.364z M503.7448,811.9597
	c87.2892,7.5098,172.8092,26.9542,251.2521,59.7867c19.7851,8.281,39.2906,17.5195,58.4814,27.5854
	c46.9256,70.0448,105.0323,134.52,170.1791,191.1272c-79.6068-26.949-162.3464-44.3833-245.1522-51.0488
	c-28.8402-17.7667-56.5455-37.1395-82.7947-58.1489C598.7372,931.8704,547.7111,874.5908,503.7448,811.9597z M590.9569,1229.8969
	c-70.4297-26.9264-137.9697-63.2994-200.7052-107.1163c84.5937-22.7976,171.606-33.7756,256.5482-29.7522
	c21.4242,1.0148,42.9125,3.0248,64.3891,5.9199c100.0723,73.1901,218.7527,126.8286,341.1219,158.4658
	C898.8536,1286.655,736.5919,1279.1143,590.9569,1229.8969z M859.5106,852.7266c-21.0248-26.5593-40.4332-54.2392-57.9139-82.9594
	c-36.6439-65.8981-65.0027-137.1753-84.896-211.0665c79.4566,36.9117,153.168,84.4327,215.6515,142.1144
	c15.7596,14.5485,30.9284,29.9008,45.5193,45.9237c20.1391,81.8699,52.6894,162.3304,94.5468,237.8052
	C1006.8302,931.9933,935.0423,887.3115,859.5106,852.7266z M1037.0677,718.6882c-10.6729-32.1484-19.4435-64.7972-26.0475-97.7643
	c-11.896-74.457-14.1653-151.1348-7.5867-227.3737c62.04,61.8612,115.0536,131.7275,154.04,207.301
	c9.8333,19.0613,18.8367,38.6758,27.0674,58.7228c-9.077,83.8203-6.0082,170.5613,7.5111,255.8005
	C1148.3922,843.5602,1096.2158,777.0206,1037.0677,718.6882z M1328.1277,891.2934
	c-16.4648-82.4158-42.7369-162.7877-78.3671-237.8325c0.9663-33.8597,3.8912-67.5393,8.9608-100.7769
	c14.2878-74.0353,38.3801-146.8652,70.637-216.2562c37.1412,79.3495,63.0613,163.134,73.8492,247.4841
	c2.7211,21.2748,4.4724,42.7858,5.3512,64.439C1371.3605,724.0117,1344.5768,806.5711,1328.1277,891.2934z M2041.6022,1092.7075
	c75.3912,1.214,151.2982,12.2936,225.2362,32.0112c-71.6941,50.3553-149.7046,90.4313-230.9,115.7025
	c-135.8326,42.2765-288.8884,45.4613-432.6729,17.4064c120.761-31.5608,236.7617-84.8358,337.5344-156.4452
	C1974.313,1096.4545,2007.9886,1093.4863,2041.6022,1092.7075z M1931.386,860.619
	c71.2604-24.6444,146.3787-40.1947,222.6018-46.9547c-50.1479,71.8397-109.7472,136.1798-177.4028,187.6974
	c-17.064,12.9938-34.8168,25.2665-53.1301,36.8537c-84.1233,5.616-169.0138,23.7002-250.6102,51.8156
	c63.1412-55.4666,119.6102-118.4048,166.7859-186.7838C1869.4369,887.1541,1900.0664,872.8471,1931.386,860.619z
	 M1471.9363,664.9132c12.4883-31.4873,26.7562-62.1356,42.8877-91.6347c38.7473-64.6839,86.2961-124.8814,140.3409-179.055
	c7.7617,87.2671,3.4635,174.8639-15.2487,257.8166c-4.7197,20.9225-10.4304,41.7354-17.011,62.3831
	c-60.8326,58.3755-114.2377,126.7957-158.6722,200.7825C1476.9486,832.129,1479.7504,747.6185,1471.9363,664.9132z
	 M1676.7958,751.6627c22.5042-25.317,46.3939-49.2369,71.6426-71.4396c58.5337-47.5306,123.8037-87.8352,193.1177-120.2573
	c-22.5537,84.6589-56.5522,165.503-102.5082,237.0531c-11.5909,18.0465-24.0758,35.6507-37.3209,52.8026
	c-77.1295,34.0493-150.715,80.0771-217.7748,134.4047C1624.3151,910.5086,1655.8523,832.053,1676.7958,751.6627z"
    />
  </svg>
);

export const termsAndConditionIcon = (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <rect stroke="none" fill="currentColor" opacity="0" />
    <g transform="matrix(0.91 0 0 0.91 12 12)">
      <path
        transform=" translate(-12.5, -12)"
        d="M 5 1 C 3.9 1 3 1.9 3 3 L 3 17 L 5 17 L 5 3 L 17 3 L 17 1 L 5 1 z M 9 5 C 7.9 5 7 5.9 7 7 L 7 21 C 7 22.1 7.9 23 9 23 L 20 23 C 21.1 23 22 22.1 22 21 L 22 7 C 22 5.895 21.105 5 20 5 L 9 5 z M 11 9 L 18 9 L 18 11 L 11 11 L 11 9 z M 11 13 L 18 13 L 18 15 L 11 15 L 11 13 z M 11 17 L 18 17 L 18 19 L 11 19 L 11 17 z"
        stroke-linecap="round"
      />
    </g>
  </svg>
);

export const privacyPolicyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    >
      <path d="M20 12V5.749a.6.6 0 0 0-.176-.425l-3.148-3.148A.6.6 0 0 0 16.252 2H4.6a.6.6 0 0 0-.6.6v18.8a.6.6 0 0 0 .6.6H13M8 10h8M8 6h4m-4 8h3" />
      <path d="M16 2v3.4a.6.6 0 0 0 .6.6H20m-.008 9.125l2.556.649c.266.068.453.31.445.584C22.821 22.116 19.5 23 19.5 23s-3.321-.884-3.493-6.642a.59.59 0 0 1 .445-.584l2.556-.649c.323-.082.661-.082.984 0" />
    </g>
  </svg>
);

export const googleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    fill="currentColor"
  >
    <path d="M 15.003906 3 C 8.3749062 3 3 8.373 3 15 C 3 21.627 8.3749062 27 15.003906 27 C 25.013906 27 27.269078 17.707 26.330078 13 L 25 13 L 22.732422 13 L 15 13 L 15 17 L 22.738281 17 C 21.848702 20.448251 18.725955 23 15 23 C 10.582 23 7 19.418 7 15 C 7 10.582 10.582 7 15 7 C 17.009 7 18.839141 7.74575 20.244141 8.96875 L 23.085938 6.1289062 C 20.951937 4.1849063 18.116906 3 15.003906 3 z" />
  </svg>
);

export const facebookIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    fill="currentColor"
  >
    <path d="M25,3C12.85,3,3,12.85,3,25c0,11.03,8.125,20.137,18.712,21.728V30.831h-5.443v-5.783h5.443v-3.848 c0-6.371,3.104-9.168,8.399-9.168c2.536,0,3.877,0.188,4.512,0.274v5.048h-3.612c-2.248,0-3.033,2.131-3.033,4.533v3.161h6.588 l-0.894,5.783h-5.694v15.944C38.716,45.318,47,36.137,47,25C47,12.85,37.15,3,25,3z" />
  </svg>
);

export const appleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    fill="currentColor"
  >
    <path d="M32.887 2c.17 2.459-.632 4.439-1.815 5.891-1.74 2.136-4.306 3.132-5.819 2.836-.284-1.707.421-3.885 1.856-5.64C28.461 3.434 30.46 2.155 32.887 2zM25.579 12.92c1.726 0 3.595-1.749 6.672-1.749 1.387 0 5.363.419 7.555 3.791-.871.631-4.088 2.656-4.088 7.264 0 5.43 4.398 7.309 5.065 7.653-.241.897-1.4 4.009-3.355 6.445-.605.754-2.423 3.649-5.138 3.649-2.465 0-3.403-1.526-6.248-1.526-3.24 0-3.395 1.553-6.547 1.553-.662 0-1.633-.299-2.403-.976-2.733-2.406-7.239-8.625-7.239-16.381 0-7.664 5.083-11.343 9.54-11.343C22.197 11.299 23.795 12.92 25.579 12.92z" />
  </svg>
);

export const moreIcon = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 12H8.01"
      stroke="#323232"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 12H12.01"
      stroke="#323232"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 12H16.01"
      stroke="#323232"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="#323232"
      stroke-width="2"
    />
  </svg>
);

export const postIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="17" cy="7" r="3" />
      <circle cx="7" cy="17" r="3" />
      <path d="M14 14h6v5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zM4 4h6v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z" />
    </g>
  </svg>
);
export const phoneCallIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fill="none">
      <path d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
      <path
        fill="white"
        d="M6.857 2.445C8 3.278 8.89 4.415 9.65 5.503l.442.644l.417.615a1.504 1.504 0 0 1-.256 1.986l-1.951 1.449a.48.48 0 0 0-.142.616c.442.803 1.228 1.999 2.128 2.899c.901.9 2.153 1.738 3.012 2.23a.483.483 0 0 0 .644-.162l1.27-1.933a1.503 1.503 0 0 1 2.056-.332l.663.459c1.239.86 2.57 1.837 3.588 3.14a1.47 1.47 0 0 1 .189 1.484c-.837 1.953-2.955 3.616-5.158 3.535l-.3-.017l-.233-.02l-.258-.03l-.281-.038l-.305-.05a11.66 11.66 0 0 1-.16-.03l-.336-.072a12.399 12.399 0 0 1-.176-.04l-.366-.094l-.385-.11l-.402-.13c-1.846-.626-4.189-1.856-6.593-4.26c-2.403-2.403-3.633-4.746-4.259-6.592l-.13-.402l-.11-.385l-.094-.366l-.078-.346a11.79 11.79 0 0 1-.063-.326l-.05-.305l-.04-.281l-.029-.258l-.02-.233l-.016-.3c-.081-2.196 1.6-4.329 3.544-5.162a1.47 1.47 0 0 1 1.445.159m8.135 3.595l.116.013a3.5 3.5 0 0 1 2.858 2.96a1 1 0 0 1-1.958.393l-.023-.115a1.5 1.5 0 0 0-1.07-1.233l-.155-.035a1 1 0 0 1 .232-1.983M15 3a6 6 0 0 1 6 6a1 1 0 0 1-1.993.117L19 9a3.998 3.998 0 0 0-3.738-3.991L15 5a1 1 0 1 1 0-2"
      />
    </g>
  </svg>
);
export const emailIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="white"
      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 4l-8 5l-8-5V6l8 5l8-5z"
    />
  </svg>
);
export const whiteClockIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="white"
      d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m4.2 14.2L11 13V7h1.5v5.2l4.5 2.7z"
    />
  </svg>
);
export const addressIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="white"
      d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7"
    />
  </svg>
);
export const expertIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M15.09 12.79a1 1 0 0 0-.086-1.638L15 5.33L14 6v5.15a1.001 1.001 0 0 0-.092 1.629l-.378.502a2.48 2.48 0 0 0-.53 1.498v1.222h.815a.88.88 0 0 0 .853-.664l.331-1.336v2h1v-1.21a2.486 2.486 0 0 0-.534-1.505zM8 0L0 4l8 5l8-5z"
    />
    <path
      fill="currentColor"
      d="M8 10L3 6.67v1.71C3 9.29 5.94 12 8 12s5-2.71 5-3.62V6.67z"
    />
  </svg>
);
export const customerServiceIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M18.72 14.76c.35-.85.54-1.76.54-2.76c0-.72-.11-1.41-.3-2.05c-.65.15-1.33.23-2.04.23A9.07 9.07 0 0 1 9.5 6.34a9.2 9.2 0 0 1-4.73 4.88c-.04.25-.04.52-.04.78A7.27 7.27 0 0 0 12 19.27c1.05 0 2.06-.23 2.97-.64c.57 1.09.83 1.63.81 1.63c-1.64.55-2.91.82-3.78.82c-2.42 0-4.73-.95-6.43-2.66a9 9 0 0 1-2.24-3.69H2v-4.55h1.09a9.09 9.09 0 0 1 15.33-4.6a9 9 0 0 1 2.47 4.6H22v4.55h-.06L18.38 18l-5.3-.6v-1.67h4.83zm-9.45-2.99c.3 0 .59.12.8.34a1.136 1.136 0 0 1 0 1.6c-.21.21-.5.33-.8.33c-.63 0-1.14-.5-1.14-1.13s.51-1.14 1.14-1.14m5.45 0c.63 0 1.13.51 1.13 1.14s-.5 1.13-1.13 1.13s-1.14-.5-1.14-1.13a1.14 1.14 0 0 1 1.14-1.14"
    />
  </svg>
);
export const costIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M2 5v14h20V5zm5 12a3 3 0 0 0-3-3v-4a3 3 0 0 0 3-3h10a3 3 0 0 0 3 3v4a3 3 0 0 0-3 3zm5-8c1.1 0 2 1.3 2 3s-.9 3-2 3s-2-1.3-2-3s.9-3 2-3"
    />
  </svg>
);
export const healthIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M15.25 2h-6.5A6.76 6.76 0 0 0 2 8.75v6.5A6.75 6.75 0 0 0 8.75 22h6.5A6.75 6.75 0 0 0 22 15.25v-6.5A6.76 6.76 0 0 0 15.25 2m5.25 10.5h-2.94l-2.7 4.52a1 1 0 0 1-.86.48h-.06a1 1 0 0 1-.86-.59L9.87 9.67l-2 3.35a1 1 0 0 1-.86.48h-3.5v-2h2.93l2.71-4.51a1 1 0 0 1 1.77.11l3.22 7.24l2-3.35a1 1 0 0 1 .86-.49h3.5z"
    />
  </svg>
);
export const HomeIconForPublic = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="white"
      d="M19.5 10a.5.5 0 0 0-1 0zm-14 0a.5.5 0 0 0-1 0zm15.146 2.354a.5.5 0 0 0 .708-.708zM12 3l.354-.354a.5.5 0 0 0-.708 0zm-9.354 8.646a.5.5 0 0 0 .708.708zM7 21.5h10v-1H7zM19.5 19v-9h-1v9zm-14 0v-9h-1v9zm15.854-7.354l-9-9l-.708.708l9 9zm-9.708-9l-9 9l.708.708l9-9zM17 21.5a2.5 2.5 0 0 0 2.5-2.5h-1a1.5 1.5 0 0 1-1.5 1.5zm-10-1A1.5 1.5 0 0 1 5.5 19h-1A2.5 2.5 0 0 0 7 21.5z"
    />
  </svg>
);

export const downArrowIcon = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.92 8.94995L13.4 15.47C12.63 16.24 11.37 16.24 10.6 15.47L4.08002 8.94995"
      stroke="#6B6868"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const addressLabel = (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M607.7 64.2c-102.9 0-186.3 83.4-186.3 186.3 0 30 15.9 66.6 38.3 103.3 15.2 24.8 33.3 49.7 51.7 72.6C559 486 607.7 533 607.7 533s17.7-17.1 42.3-43.8c14-15.3 30.3-33.6 46.7-53.8 47.9-58.7 97.3-132 97.3-184.9 0-102.9-83.4-186.3-186.3-186.3z m77.8 353.2c-8 10-16.1 19.6-23.9 28.6-7.8 9-15.4 17.5-22.5 25.3-12.5 13.7-23.4 25.1-31.4 33.3-12.5-12.8-32.3-33.5-53.8-58.5-7.8-9-15.8-18.5-23.8-28.5-13.5-16.7-25.5-32.7-36.1-48-10.1-14.6-18.8-28.4-26.1-41.5-17.6-31.6-26.6-57.8-26.6-77.8 0-44.4 17.3-86.2 48.7-117.6C521.4 101.3 563.2 84 607.6 84c44.4 0 86.2 17.3 117.6 48.7 31.4 31.4 48.7 73.2 48.7 117.6 0 20-8.9 46.1-26.5 77.6-14.8 26.9-35.6 56.9-61.9 89.5z"
        fill="#887c7c"
      ></path>
      <path
        d="M607.7 183.1c36.9 0 67 30.1 67 67s-30.1 67-67 67-67-30.1-67-67 30-67 67-67m0-20c-48 0-87 38.9-87 87 0 48 38.9 87 87 87 48 0 87-38.9 87-87s-39-87-87-87z"
        fill="#887c7c"
      ></path>
      <path
        d="M927.9 352.4l-195.7 70.3-35.6 12.8c-16.4 20.1-32.7 38.5-46.7 53.8l1.9 0.9v416.6l-12.7-5.9-46.3-21.6-212.2-98.9-8.6-4v-415l139.4 65c-18.4-23-36.5-47.8-51.7-72.6l-77.6-36.2-3.7-1.7-8.6-4-7.8-3.7-2.2 0.8L64 415.3v511.8L362 820l230.8 107.6 46.3 21.6 22.7 10.6L960 852.7V340.9l-32.1 11.5zM352 776.9l-4.9 1.8L108 864.6V446.2l244-87.7v418.4z m564 44.9l-244.2 87.7V491.1l5.1-1.8L916 403.4v418.4z"
        fill="#39393A"
      ></path>
    </g>
  </svg>
);

export const locationIcon = (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#e7e4e4"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z"
        stroke="#f1eaea"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
      <path
        d="M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z"
        stroke="#f1eaea"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </g>
  </svg>
);

export const watchIcon = (
  <svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.0102 8.86317C15.006 12.5432 12.0159 15.5264 8.33587 15.5222C4.65588 15.5179 1.67265 12.5278 1.67689 8.84781C1.68113 5.16782 4.67123 2.18459 8.35123 2.18883C12.0312 2.19307 15.0145 5.18318 15.0102 8.86317Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.8147 10.9783L8.74945 9.74257C8.3897 9.52882 8.09695 9.01515 8.09744 8.59515L8.10059 5.86182"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const doneIcon = (
  <svg
    fill="#0c9103"
    viewBox="-2.4 -2.4 28.80 28.80"
    id="d9090658-f907-4d85-8bc1-743b70378e93"
    data-name="Livello 1"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#0c9103"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="#CCCCCC"
      stroke-width="0.048"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        id="70fa6808-131f-4233-9c3a-fc089fd0c1c4"
        data-name="done circle"
        d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0ZM11.52,17L6,12.79l1.83-2.37L11.14,13l4.51-5.08,2.24,2Z"
      ></path>
    </g>
  </svg>
);
export const menu = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="none"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M3 5h18M3 12h18M3 19h18"
    />
  </svg>
);
export const cancelPublicIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="none"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M19 5L5 19M5 5l14 14"
      color="white"
    />
  </svg>
);
export const unlimitedAccessbg = (
  <svg viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="26.8202"
      cy="27.0876"
      r="26.4208"
      fill="#ffff"
      fill-opacity="0.16"
    />
  </svg>
);
export const unlimitedAccessIcon = (
  <svg viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 4.89986C0 2.19374 2.19374 0 4.89986 0H17.4886C20.1947 0 22.3884 2.19374 22.3884 4.89986V17.4886C22.3884 20.1947 20.1947 22.3884 17.4886 22.3884H4.89986C2.19374 22.3884 0 20.1947 0 17.4886V4.89986ZM4.89986 4.19988C4.51327 4.19988 4.19988 4.51327 4.19988 4.89986V17.4886C4.19988 17.8751 4.51327 18.1885 4.89986 18.1885H17.4886C17.8751 18.1885 18.1885 17.8751 18.1885 17.4886V4.89986C18.1885 4.51327 17.8751 4.19988 17.4886 4.19988H4.89986Z"
      fill="#5979F2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 31.5114C0 28.8053 2.19374 26.6116 4.89986 26.6116H17.4886C20.1947 26.6116 22.3884 28.8053 22.3884 31.5114V44.1001C22.3884 46.8062 20.1947 49 17.4886 49H4.89986C2.19374 49 0 46.8062 0 44.1001V31.5114ZM4.89986 30.8115C4.51327 30.8115 4.19988 31.1248 4.19988 31.5114V44.1001C4.19988 44.4867 4.51327 44.8001 4.89986 44.8001H17.4886C17.8751 44.8001 18.1885 44.4867 18.1885 44.1001V31.5114C18.1885 31.1248 17.8751 30.8115 17.4886 30.8115H4.89986Z"
      fill="#1E2538"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.6101 4.89986C26.6101 2.19374 28.8038 0 31.51 0H44.0987C46.8048 0 48.9985 2.19374 48.9985 4.89986V17.4886C48.9985 20.1947 46.8048 22.3884 44.0987 22.3884H31.51C28.8038 22.3884 26.6101 20.1947 26.6101 17.4886V4.89986ZM31.51 4.19988C31.1234 4.19988 30.81 4.51327 30.81 4.89986V17.4886C30.81 17.8751 31.1234 18.1885 31.51 18.1885H44.0987C44.4853 18.1885 44.7986 17.8751 44.7986 17.4886V4.89986C44.7986 4.51327 44.4853 4.19988 44.0987 4.19988H31.51Z"
      fill="#1E2538"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.6101 31.5114C26.6101 28.8053 28.8038 26.6116 31.51 26.6116H44.0987C46.8048 26.6116 48.9985 28.8053 48.9985 31.5114V44.1001C48.9985 46.8062 46.8048 49 44.0987 49H31.51C28.8038 49 26.6101 46.8062 26.6101 44.1001V31.5114ZM31.51 30.8115C31.1234 30.8115 30.81 31.1248 30.81 31.5114V44.1001C30.81 44.4867 31.1234 44.8001 31.51 44.8001H44.0987C44.4853 44.8001 44.7986 44.4867 44.7986 44.1001V31.5114C44.7986 31.1248 44.4853 30.8115 44.0987 30.8115H31.51Z"
      fill="#5979F2"
    />
  </svg>
);
export const guidanceIcon = (
  <svg viewBox="0 0 56 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.8567 28.5713C29.0401 28.5713 29.9995 29.5307 29.9995 30.7141V44.9996C29.9995 46.183 29.0401 47.1424 27.8567 47.1424C26.6732 47.1424 25.7139 46.183 25.7139 44.9996V30.7141C25.7139 29.5307 26.6732 28.5713 27.8567 28.5713Z"
      fill="#5979F2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.857 21.4285C25.8846 21.4285 24.2856 23.0274 24.2856 24.9998C24.2856 26.9722 25.8846 28.5712 27.857 28.5712C29.8294 28.5712 31.4284 26.9722 31.4284 24.9998C31.4284 23.0274 29.8294 21.4285 27.857 21.4285ZM20 24.9998C20 20.6605 23.5177 17.1428 27.857 17.1428C32.1963 17.1428 35.714 20.6605 35.714 24.9998C35.714 29.3391 32.1963 32.8568 27.857 32.8568C23.5177 32.8568 20 29.3391 20 24.9998Z"
      fill="#1E2538"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.556 9.67249C35.1314 8.63839 36.4363 8.26661 37.4704 8.84209C43.2202 12.0419 47.1425 18.0585 47.1425 25C47.1425 31.9414 43.2202 37.958 37.4704 41.1578C36.4363 41.7333 35.1314 41.3616 34.556 40.3275C33.9805 39.2934 34.3523 37.9885 35.3864 37.413C39.8844 34.9098 42.8568 30.2671 42.8568 25C42.8568 19.7328 39.8844 15.0901 35.3864 12.5869C34.3523 12.0114 33.9805 10.7066 34.556 9.67249Z"
      fill="#1E2538"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.1579 9.67249C20.5824 8.63839 19.2776 8.26661 18.2435 8.84209C12.4937 12.0419 8.57139 18.0585 8.57139 25C8.57139 31.9414 12.4937 37.958 18.2435 41.1578C19.2776 41.7333 20.5824 41.3616 21.1579 40.3275C21.7334 39.2934 21.3616 37.9885 20.3275 37.413C15.8295 34.9098 12.857 30.2671 12.857 25C12.857 19.7328 15.8295 15.0901 20.3275 12.5869C21.3616 12.0114 21.7334 10.7066 21.1579 9.67249Z"
      fill="#1E2538"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M37.3958 1.13351C37.9535 0.0896893 39.2517 -0.304423 40.2956 0.253236C49.4487 5.14331 55.7141 14.3512 55.7141 25C55.7141 35.6488 49.4487 44.8567 40.2956 49.7468C39.2517 50.3044 37.9535 49.9103 37.3958 48.8665C36.8382 47.8227 37.2323 46.5244 38.2761 45.9668C46.2027 41.732 51.4285 33.8849 51.4285 25C51.4285 16.1151 46.2027 8.268 38.2761 4.03325C37.2323 3.47559 36.8382 2.17733 37.3958 1.13351Z"
      fill="#5979F2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.3181 1.13351C17.7604 0.0896893 16.4621 -0.304423 15.4183 0.253236C6.26513 5.14331 -0.000247955 14.3512 -0.000247955 25C-0.000247955 35.6488 6.26513 44.8567 15.4183 49.7468C16.4621 50.3044 17.7604 49.9103 18.3181 48.8665C18.8757 47.8227 18.4816 46.5244 17.4378 45.9668C9.51122 41.732 4.28539 33.8849 4.28539 25C4.28539 16.1151 9.51122 8.268 17.4378 4.03325C18.4816 3.47559 18.8757 2.17733 18.3181 1.13351Z"
      fill="#5979F2"
    />
  </svg>
);
export const protectIcon = (
  <svg viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.6236 51.5991C30.8482 51.7597 31.15 51.7597 31.3747 51.5991L42.2741 43.8089C45.8363 41.2629 47.9503 37.1536 47.9503 32.775V15.6855H47.8054C41.7556 15.6855 35.8685 13.7536 30.9991 10.1784C26.1297 13.7536 20.2427 15.6855 14.1928 15.6855H14.048V32.775C14.048 37.1536 16.1619 41.2629 19.7242 43.8089L30.6236 51.5991ZM32.9377 6.78946C37.2099 10.0465 42.4333 11.8105 47.8054 11.8105H48.5261C50.3482 11.8105 51.8253 13.2876 51.8253 15.1096V32.775C51.8253 38.4047 49.1074 43.688 44.5273 46.9615L33.6279 54.7517C32.0555 55.8755 29.9427 55.8755 28.3704 54.7517L17.4709 46.9615C12.8909 43.688 10.173 38.4047 10.173 32.775V15.1096C10.173 13.2876 11.65 11.8105 13.4721 11.8105H14.1928C19.5649 11.8105 24.7884 10.0465 29.0605 6.78946C30.2055 5.91653 31.7927 5.91653 32.9377 6.78946Z"
      fill="#4E71F4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.9996 41.1333L37.6573 37.1602C38.6338 36.5776 39.2318 35.5243 39.2318 34.3873V22.9304H22.7674V34.3873C22.7674 35.5243 23.3654 36.5776 24.3418 37.1602L30.9996 41.1333ZM32.6543 44.6583C31.635 45.2666 30.3641 45.2666 29.3448 44.6583L22.3561 40.4878C20.208 39.2059 18.8924 36.8888 18.8924 34.3873V22.2846C18.8924 20.5012 20.3381 19.0554 22.1216 19.0554H39.8776C41.661 19.0554 43.1068 20.5012 43.1068 22.2846V34.3873C43.1068 36.8888 41.7911 39.2059 39.6431 40.4878L32.6543 44.6583Z"
      fill="#1E2538"
    />
  </svg>
);
export const rightTickIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
    <path
      fill="white"
      fill-rule="evenodd"
      d="M14.707 3L5.5 12.207L.293 7L1 6.293l4.5 4.5l8.5-8.5z"
      clip-rule="evenodd"
    />
  </svg>
);
export const rightChevronIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="white"
      d="M16.116 39.634a1.25 1.25 0 0 1 0-1.768L29.982 24L16.116 10.134a1.25 1.25 0 0 1 1.768-1.768l14.75 14.75a1.25 1.25 0 0 1 0 1.768l-14.75 14.75a1.25 1.25 0 0 1-1.768 0"
    />
  </svg>
);
export const leftChevronIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="white"
      d="M31.884 8.366a1.25 1.25 0 0 1 0 1.768L18.018 24l13.866 13.866a1.25 1.25 0 0 1-1.768 1.768l-14.75-14.75a1.25 1.25 0 0 1 0-1.768l14.75-14.75a1.25 1.25 0 0 1 1.768 0"
    />
  </svg>
);
export const straightLineIcon = (
  <svg viewBox="0 0 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 0V32" stroke="white" />
  </svg>
);
export const publicFacebookIcon = (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_205_1933)">
      <path
        d="M48 24C48 10.7453 37.2547 0 24 0C10.7453 0 0 10.7453 0 24C0 35.255 7.74912 44.6995 18.2026 47.2934V31.3344H13.2538V24H18.2026V20.8397C18.2026 12.671 21.8995 8.8848 29.9194 8.8848C31.44 8.8848 34.0637 9.18336 35.137 9.48096V16.129C34.5706 16.0694 33.5866 16.0397 32.3645 16.0397C28.4294 16.0397 26.9088 17.5306 26.9088 21.4061V24H34.7482L33.4013 31.3344H26.9088V47.8243C38.7926 46.3891 48.001 36.2707 48.001 24H48Z"
        fill="#5979F2"
      />
      <path
        d="M33.4003 31.3344L34.7472 24H26.9078V21.406C26.9078 17.5305 28.4285 16.0396 32.3635 16.0396C33.5856 16.0396 34.5696 16.0694 35.136 16.1289V9.48093C34.0627 9.18237 31.439 8.88477 29.9184 8.88477C21.8986 8.88477 18.2016 12.671 18.2016 20.8396V24H13.2528V31.3344H18.2016V47.2934C20.0582 47.7542 22.0003 48 23.999 48C24.983 48 25.9536 47.9395 26.9069 47.8243V31.3344H33.3994H33.4003Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_205_1933">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const telegramIcon = (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_205_1938)">
      <path
        d="M47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5C36.9787 0.5 47.5 11.0213 47.5 24Z"
        stroke="#5979F2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8638 23.7466C17.8603 20.6984 22.5257 18.6888 24.8601 17.7179C31.5251 14.9456 32.91 14.4641 33.8127 14.4482C34.0113 14.4447 34.4552 14.4939 34.7427 14.7272C34.9855 14.9242 35.0523 15.1904 35.0843 15.3771C35.1163 15.5639 35.1561 15.9895 35.1244 16.3219C34.7633 20.1169 33.2004 29.3263 32.4053 33.5767C32.0689 35.3752 31.4065 35.9783 30.7652 36.0373C29.3714 36.1655 28.3131 35.1162 26.9632 34.2313C24.8509 32.8467 23.6576 31.9847 21.6072 30.6336C19.2377 29.0721 20.7738 28.2139 22.1242 26.8113C22.4776 26.4442 28.6183 20.8587 28.7372 20.352C28.7521 20.2886 28.7659 20.0524 28.6255 19.9277C28.4852 19.803 28.2781 19.8456 28.1286 19.8795C27.9168 19.9276 24.5423 22.158 18.0053 26.5707C17.0475 27.2284 16.1799 27.5489 15.4026 27.5321C14.5457 27.5135 12.8973 27.0475 11.6719 26.6492C10.1689 26.1606 8.97432 25.9023 9.07834 25.0726C9.13252 24.6404 9.72767 24.1984 10.8638 23.7466Z"
        fill="#5979F2"
      />
    </g>
    <defs>
      <clipPath id="clip0_205_1938">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const xIcon = (
  <svg
    className="svg-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
  </svg>
);
export const noDataIcon = (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path
        d="M983 4607 l-413 -412 0 -1723 c0 -1709 0 -1722 20 -1742 18 -18 33
 -20 155 -20 l134 0 3 -142 c3 -141 3 -143 28 -155 37 -19 2583 -19 2620 0 16
 8 26 23 28 40 7 61 97 57 -1294 57 l-1274 0 0 100 0 100 1115 0 c1102 0 1115
 0 1135 20 24 24 25 38 4 68 l-15 22 -1275 0 -1274 0 0 1650 0 1650 383 0 c285
 0 386 3 395 12 9 9 12 110 12 395 l0 383 1120 0 1120 0 0 -1698 c0 -1307 3
 -1701 12 -1710 17 -17 64 -15 82 4 14 14 16 169 16 1555 l0 1539 100 0 100 0
 0 -1683 c0 -1296 3 -1686 12 -1695 20 -20 65 -14 82 10 14 20 16 200 16 1723
 0 1349 -3 1705 -13 1725 -12 25 -14 25 -155 28 l-142 3 0 134 c0 122 -2 137
 -20 155 -20 20 -33 20 -1212 20 l-1193 0 -412 -413z m377 -82 l0 -295 -297 0
 -298 0 295 295 c162 162 296 295 297 295 2 0 3 -133 3 -295z"
      />
      <path
        d="M1816 4654 c-20 -19 -20 -44 -2 -70 14 -18 35 -19 738 -22 398 -2
 742 0 766 3 52 8 73 39 54 80 l-12 25 -764 0 c-682 0 -766 -2 -780 -16z"
      />
      <path
        d="M1820 4350 c-24 -24 -26 -53 -4 -74 14 -14 98 -16 774 -16 827 0 790
 -3 790 55 0 57 22 55 -792 55 -735 0 -748 0 -768 -20z"
      />
      <path
        d="M2530 4047 c-28 -14 -37 -46 -20 -76 11 -21 17 -21 430 -21 413 0
 419 0 430 21 6 11 10 30 8 42 -6 44 -29 47 -438 47 -290 0 -391 -3 -410 -13z"
      />
      <path
        d="M2542 3743 c-32 -6 -49 -45 -34 -78 l12 -25 419 0 c405 0 421 1 431
 19 5 11 10 28 10 39 0 46 -10 47 -424 48 -215 1 -401 0 -414 -3z"
      />
      <path
        d="M2322 3389 c-397 -35 -761 -285 -941 -646 -85 -170 -121 -328 -121
 -530 0 -562 383 -1029 942 -1149 60 -13 126 -18 238 -18 133 0 170 4 260 26
 126 32 241 79 346 142 l77 47 52 -51 c51 -50 53 -55 57 -114 2 -33 12 -79 23
 -101 12 -27 153 -175 418 -442 451 -453 445 -448 577 -447 89 1 152 26 213 87
 60 60 82 117 82 212 -1 62 -6 90 -23 125 -32 64 -790 830 -852 861 -27 13 -72
 24 -112 27 -64 4 -68 6 -117 56 l-51 52 49 82 c233 389 225 876 -21 1254 -238
 364 -655 565 -1096 527z m310 -123 c363 -70 670 -329 802 -679 48 -127 61
 -211 60 -377 -1 -133 -4 -169 -26 -251 -53 -198 -144 -357 -282 -495 -327
 -327 -825 -406 -1240 -197 -129 65 -281 195 -377 323 -56 76 -144 259 -169
 355 -31 114 -38 347 -16 469 80 423 405 757 826 847 106 22 318 25 422 5z
 m754 -1896 l62 -60 63 0 c42 0 76 -7 103 -20 27 -12 174 -153 423 -402 342
 -344 382 -388 393 -428 32 -118 -42 -230 -163 -246 -90 -13 -113 6 -524 418
 -250 250 -377 385 -387 410 -9 21 -16 66 -16 100 l0 62 -62 63 -62 63 49 50
 c27 27 51 50 54 50 2 0 32 -27 67 -60z"
      />
      <path
        d="M2345 3069 c-363 -37 -661 -299 -746 -656 -18 -74 -20 -110 -17 -228
 4 -124 8 -151 37 -235 127 -375 472 -610 864 -587 374 22 674 266 779 634 30
 105 32 322 4 428 -21 82 -81 215 -125 279 -176 255 -485 397 -796 365z m311
 -139 c125 -40 227 -103 315 -197 149 -156 218 -343 206 -558 -21 -382 -320
 -681 -702 -702 -140 -8 -240 13 -374 79 -91 44 -116 62 -190 137 -152 152
 -211 288 -218 501 -6 153 9 227 72 355 50 103 109 179 192 248 69 57 185 119
 268 142 126 37 309 35 431 -5z"
      />
      <path
        d="M2100 2550 c-11 -11 -20 -28 -20 -37 0 -9 62 -79 137 -155 l137 -138
 -137 -138 c-140 -142 -154 -164 -119 -195 39 -36 61 -23 202 118 l135 135 135
 -135 c137 -137 166 -155 198 -123 32 32 14 61 -118 193 -71 71 -130 134 -130
 140 0 6 59 69 130 140 113 113 130 134 130 162 0 33 -21 53 -56 53 -10 0 -80
 -62 -156 -137 l-138 -137 -138 137 c-75 75 -145 137 -155 137 -9 0 -26 -9 -37
 -20z"
      />
    </g>
  </svg>
);
export const rightArrowBlackIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="black"
      fill-rule="evenodd"
      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
    />
  </svg>
);
export const homeIcon = (
  <svg
    viewBox="0 0 31 31"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5759 0.861278L14.5825 0.855908L14.5889 0.850318C15.1238 0.383227 15.8762 0.383227 16.4111 0.850318L16.4175 0.855908L16.4241 0.861278L29.8575 11.8086C30.2564 12.1337 30.4899 12.6124 30.4997 13.0751L28.4376 28.8298L28.4333 28.8622V28.8947C28.4333 29.7852 27.7185 30.5 26.8667 30.5H21.7C20.8482 30.5 20.1333 29.7852 20.1333 28.8947V24.6842C20.1333 21.8675 17.8185 19.74 15.0444 19.9755L15.0444 19.9754L15.0384 19.976C12.5688 20.2156 10.8667 22.4728 10.8667 24.8947V28.8947C10.8667 29.7852 10.1518 30.5 9.3 30.5H4.13333C3.28149 30.5 2.56667 29.7852 2.56667 28.8947V28.8622L2.56244 28.8298L0.500318 13.0751C0.510076 12.6124 0.743641 12.1337 1.14253 11.8086L14.5759 0.861278Z"
      fill="white"
      stroke="currentColor"
    />
  </svg>
);

export const activeHomeIcon = (
  <svg
    viewBox="0 0 31 31"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5759 0.861278L14.5825 0.855908L14.5889 0.850318C15.1238 0.383227 15.8762 0.383227 16.4111 0.850318L16.4175 0.855908L16.4241 0.861278L29.8575 11.8086C30.2564 12.1337 30.4899 12.6124 30.4997 13.0751L28.4376 28.8298L28.4333 28.8622V28.8947C28.4333 29.7852 27.7185 30.5 26.8667 30.5H21.7C20.8482 30.5 20.1333 29.7852 20.1333 28.8947V24.6842C20.1333 21.8675 17.8185 19.74 15.0444 19.9755L15.0444 19.9754L15.0384 19.976C12.5688 20.2156 10.8667 22.4728 10.8667 24.8947V28.8947C10.8667 29.7852 10.1518 30.5 9.3 30.5H4.13333C3.28149 30.5 2.56667 29.7852 2.56667 28.8947V28.8622L2.56244 28.8298L0.500318 13.0751C0.510076 12.6124 0.743641 12.1337 1.14253 11.8086L14.5759 0.861278Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
);

export const serviceActiveIcon = (
  <svg viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.84375 5.08594L11.3831 6.78125L14.2895 12.3516L13.8051 13.5625L12.5941 14.2891L7.50794 12.1094L4.84375 5.08594Z"
      fill="currentColor"
    />
    <path
      d="M5.08984 26.1505L6.61437 19.5695L12.1074 16.5192L13.3306 16.9719L14.0885 18.1635L12.0419 23.3045L8.47684 25.1875L5.08984 26.1505Z"
      fill="currentColor"
    />
    <path
      d="M15.7119 30.2734L13.5633 27.6094L12.4298 24.6974L13.079 21.5547L14.29 18.2881L15.7119 18.2881L16.712 18.2881L18.6495 23.7344L17.6807 27.6094L15.7119 30.2734Z"
      fill="currentColor"
    />
    <path
      d="M26.0254 4.94523L25.5429 8.33346L24.1867 11.1486L21.4457 12.8177L18.2309 14.1605L17.2609 13.1208L16.5788 12.3896L19.2398 7.25774L22.7343 5.32285L26.0254 4.94523Z"
      fill="currentColor"
    />
    <path
      d="M30.5215 15.4986L27.8573 17.647L24.9452 18.7805L21.8023 18.1314L18.5356 16.9205L18.5356 15.4986L18.5356 14.4986L23.9821 12.5611L27.8573 13.5298L30.5215 15.4986Z"
      fill="currentColor"
    />
    <path
      d="M26.1748 25.5706L22.7669 25.2532L19.8891 24.0354L18.0888 21.3788L16.5914 18.2331L17.5828 17.2139L18.2801 16.497L23.5354 18.9056L25.6377 22.3018L26.1748 25.5706Z"
      fill="currentColor"
    />
    <path
      d="M0.726563 15.5L6.02599 12.0289L12.1474 13.4452L12.7521 14.6008L12.7521 16.4687L6.53933 18.6484L0.726563 15.5Z"
      fill="currentColor"
    />
    <path
      d="M15.3115 0.484375L18.5827 6.3873L16.5862 12.2632L15.3865 12.7283L14.0354 12.3378L12.108 7.16517L15.3115 0.484375Z"
      fill="currentColor"
    />
    <ellipse
      cx="15.5001"
      cy="15.5"
      rx="2.42199"
      ry="2.42188"
      fill="currentColor"
    />
    <path
      d="M30.9583 15.686C30.985 15.6264 31 15.5625 31 15.4956C31 15.3682 30.9491 15.2462 30.8561 15.1575C30.7273 15.0326 27.7153 12.1719 23.8731 12.0299C26.4936 9.21233 26.5959 5.0593 26.5997 4.87959C26.6017 4.7522 26.5523 4.62966 26.4617 4.53908C26.3716 4.44898 26.2514 4.40781 26.1221 4.40152C25.9424 4.40442 21.7921 4.50711 18.9705 7.12322C18.8295 3.2768 15.9633 0.272703 15.8384 0.143375C15.8374 0.142406 15.8354 0.142406 15.835 0.141438C15.7492 0.0547344 15.631 0 15.4998 0C15.3665 0 15.2474 0.0566719 15.1621 0.145797C15.0318 0.280453 12.1744 3.28406 12.0349 7.12806C9.31981 4.6035 5.37633 4.41702 4.9302 4.40345C4.79602 4.39037 4.657 4.42913 4.55382 4.5323C4.55285 4.53278 4.55285 4.53375 4.55237 4.53472C4.54995 4.53666 4.54607 4.53762 4.54413 4.53956C4.45355 4.63014 4.40414 4.7522 4.40608 4.88008C4.40996 5.06027 4.51216 9.21863 7.1313 12.0304C3.28761 12.1704 0.273685 15.0331 0.143866 15.158C0.052315 15.2467 0 15.3687 0 15.4961C0 15.6235 0.0518306 15.7456 0.143866 15.8342C0.273685 15.9592 3.28567 18.8243 7.12791 18.9662C4.51168 21.7843 4.40996 25.9368 4.40608 26.117C4.40608 26.1194 4.40802 26.1223 4.40802 26.1252L4.40753 26.1267C4.40753 26.1398 4.41383 26.1504 4.4148 26.163C4.41964 26.2124 4.42497 26.2614 4.44435 26.3064C4.45791 26.3389 4.48116 26.364 4.50102 26.3921C4.51652 26.4135 4.52573 26.4386 4.54462 26.457C4.54462 26.457 4.54607 26.4575 4.54656 26.4585C4.59015 26.5016 4.64198 26.536 4.69963 26.5597C4.7127 26.5651 4.72821 26.5641 4.74225 26.5685C4.78682 26.582 4.83138 26.5961 4.87982 26.5961C4.88273 26.5961 4.88515 26.5946 4.88854 26.5946C5.0886 26.5907 9.22487 26.4779 12.0353 23.869C12.1768 27.715 15.0381 30.7273 15.1626 30.8566C15.2508 30.9482 15.3728 31 15.5002 31C15.5647 31 15.6272 30.9864 15.6853 30.9617C15.7429 30.9375 15.7943 30.9012 15.8369 30.8571C15.8379 30.8571 15.8384 30.8566 15.8384 30.8566C15.9628 30.7273 18.8261 27.7169 18.97 23.8724C21.7257 26.427 25.7486 26.5849 26.0931 26.5936C26.1042 26.5941 26.1158 26.6004 26.1279 26.6004C26.2481 26.6004 26.3682 26.5544 26.4602 26.4629C26.5077 26.4154 26.5416 26.3597 26.5644 26.3011C26.5663 26.2987 26.5653 26.2958 26.5663 26.2928C26.5862 26.2391 26.5973 26.1834 26.5973 26.1272C26.5973 26.1238 26.5992 26.1204 26.5992 26.117C26.5954 25.9373 26.4932 21.7843 23.8774 18.9667C27.6325 18.8257 30.5854 16.0919 30.8358 15.8536C30.8886 15.8061 30.9317 15.7514 30.9583 15.686ZM19.421 7.99364C21.0844 6.33127 23.4221 5.7103 24.8564 5.47877L23.4429 6.89459C23.2593 7.07817 23.2603 7.37558 23.4439 7.55916C23.5354 7.6507 23.656 7.69623 23.7762 7.69623C23.8963 7.69623 24.0164 7.65022 24.1085 7.55819L25.5239 6.13945C25.2928 7.57175 24.6723 9.9108 23.0084 11.5756C22.7759 11.8081 22.5361 12.0009 22.3264 12.1631L18.1606 13.8909C17.9033 13.4598 17.541 13.097 17.1104 12.8384L18.8387 8.67128C19.0397 8.41166 19.2316 8.18691 19.421 7.99364ZM16.329 17.5005C15.8025 17.7209 15.2033 17.7233 14.668 17.4971C14.1391 17.2878 13.7128 16.8625 13.4939 16.3191C13.3854 16.0691 13.3306 15.7921 13.3306 15.4961C13.3306 15.1992 13.3854 14.9246 13.4982 14.6674C13.7143 14.135 14.1415 13.7073 14.6792 13.4908C14.9369 13.3813 15.2135 13.3261 15.5007 13.3261C15.7875 13.3261 16.066 13.3818 16.3339 13.4937C16.8638 13.7088 17.2886 14.1336 17.5032 14.6693C17.5042 14.6703 17.5032 14.6712 17.5042 14.6722C17.5042 14.6737 17.5061 14.6751 17.5071 14.6766C17.6142 14.9299 17.6708 15.2133 17.6708 15.4961C17.6708 15.7829 17.6151 16.0619 17.5042 16.3254C17.2838 16.8572 16.8561 17.2849 16.329 17.5005ZM15.0299 1.79945V3.86628C15.0299 4.12542 15.2406 4.33612 15.4998 4.33612C15.7589 4.33612 15.9696 4.12542 15.9696 3.86628V1.79316C16.8193 2.96534 18.037 5.05494 18.037 7.41772C18.037 7.74225 18.0051 8.0445 17.9726 8.30655L16.2414 12.4819C15.7536 12.3627 15.2416 12.3637 14.7644 12.4804L13.0342 8.30848C13.0012 8.04547 12.9693 7.74225 12.9693 7.4182C12.9688 5.06462 14.1812 2.97503 15.0299 1.79945ZM5.47999 6.1225L6.95547 7.59791C7.04702 7.68945 7.16763 7.73547 7.28776 7.73547C7.40789 7.73547 7.52802 7.68945 7.62006 7.59791C7.80365 7.41433 7.80365 7.11692 7.62006 6.93383L6.16784 5.48167C7.60214 5.71563 9.92531 6.33902 11.581 7.99461C11.7728 8.18642 11.9612 8.40487 12.1676 8.6708L13.8959 12.8384C13.4633 13.0985 13.1001 13.4622 12.8419 13.8924L8.67702 12.1656C8.47744 12.014 8.2304 11.8173 7.99837 11.5761C6.32672 9.9045 5.70814 7.55286 5.47999 6.1225ZM1.80002 15.9674H3.85532C4.11447 15.9674 4.32519 15.7567 4.32519 15.4976C4.32519 15.238 4.11447 15.0277 3.85532 15.0277H1.7976C2.97565 14.1786 5.06971 12.9643 7.42146 12.9643C7.74261 12.9643 8.04391 12.9958 8.30597 13.0282L12.481 14.7599C12.4238 14.9948 12.3904 15.2399 12.3904 15.4961C12.3904 15.7543 12.4238 16.0018 12.482 16.2387L8.31275 17.9674C8.04972 18.0003 7.74649 18.0323 7.42097 18.0323C5.07116 18.0323 2.97856 16.8175 1.80002 15.9674ZM11.5805 23.0025C9.91901 24.6605 7.58518 25.2829 6.15233 25.5159L7.56532 24.1001C7.74891 23.9165 7.74794 23.6191 7.56435 23.4355C7.38077 23.2519 7.08335 23.2529 6.90024 23.436L5.48193 24.8572C5.71299 23.4239 6.33301 21.0815 7.99789 19.4162C8.1902 19.2239 8.41302 19.033 8.67217 18.8354L12.8428 17.1057C13.1025 17.5392 13.4658 17.901 13.8945 18.1563L12.1661 22.3234C11.9482 22.6043 11.766 22.817 11.5805 23.0025ZM15.9725 29.1991V27.3255C15.9725 27.0664 15.7618 26.8557 15.5027 26.8557C15.243 26.8557 15.0328 27.0664 15.0328 27.3255V29.2059C14.1836 28.0303 12.9683 25.9363 12.9683 23.574C12.9683 23.251 13.0007 22.9376 13.0322 22.6867L14.7635 18.5118C15.0018 18.5709 15.2479 18.6044 15.5002 18.6044C15.7526 18.6044 16.0006 18.5709 16.2409 18.5114L17.9721 22.6852C18.0041 22.9511 18.0365 23.2558 18.0365 23.5736C18.0365 25.9271 16.8226 28.0206 15.9725 29.1991ZM25.5249 24.8644L24.1632 23.5058C23.9787 23.3222 23.6817 23.3231 23.4991 23.5062C23.3155 23.6898 23.3165 23.9872 23.5001 24.1708L24.8462 25.5149C23.4119 25.2815 21.081 24.659 19.4243 23.0054C19.2388 22.8165 19.0509 22.5951 18.8377 22.3195L17.1084 18.1515C17.5342 17.8933 17.8937 17.5329 18.1538 17.1047L22.3307 18.8369C22.5841 19.034 22.8093 19.2253 23.0099 19.4191C24.6762 21.0873 25.2952 23.4331 25.5249 24.8644ZM23.579 18.0323C23.2593 18.0323 22.9517 18.0003 22.6839 17.9669L18.5161 16.2382C18.5757 15.9965 18.6096 15.749 18.6096 15.4961C18.6096 15.2472 18.5757 14.9987 18.5171 14.7604L22.6911 13.0292C22.9571 12.9963 23.2627 12.9643 23.5785 12.9643C25.94 12.9643 28.0403 14.1878 29.2164 15.0369H27.228C26.9688 15.0369 26.7576 15.2472 26.7576 15.5068C26.7576 15.7664 26.9688 15.9766 27.228 15.9766H29.1903C28.0122 16.8262 25.9279 18.0323 23.579 18.0323Z"
      fill="#D3DCD6"
    />
  </svg>
);

export const servicesIcon = (
  <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.9664 12.65C24.9879 12.602 25 12.5504 25 12.4965C25 12.3937 24.959 12.2953 24.884 12.2238C24.7801 12.123 22.351 9.81602 19.2525 9.70156C21.3658 7.4293 21.4483 4.08008 21.4514 3.93516C21.453 3.83242 21.4131 3.73359 21.3401 3.66055C21.2674 3.58789 21.1705 3.55469 21.0662 3.54961C20.9213 3.55195 17.5743 3.63477 15.2988 5.74453C15.1851 2.64258 12.8737 0.219922 12.7729 0.115625C12.7721 0.114844 12.7705 0.114844 12.7701 0.114062C12.701 0.0441406 12.6057 0 12.4998 0C12.3924 0 12.2963 0.0457031 12.2275 0.117578C12.1224 0.226172 9.81804 2.64844 9.70553 5.74844C7.51598 3.7125 4.33575 3.56211 3.97597 3.55117C3.86776 3.54062 3.75564 3.57188 3.67244 3.65508C3.67166 3.65547 3.67166 3.65625 3.67127 3.65703C3.66931 3.65859 3.66619 3.65937 3.66462 3.66094C3.59157 3.73398 3.55173 3.83242 3.55329 3.93555C3.55642 4.08086 3.63884 7.43437 5.75105 9.70195C2.6513 9.81484 0.220713 12.1234 0.116021 12.2242C0.0421895 12.2957 0 12.3941 0 12.4969C0 12.5996 0.0417988 12.698 0.116021 12.7695C0.220713 12.8703 2.64973 15.1809 5.74832 15.2953C3.63845 17.568 3.55642 20.9168 3.55329 21.0621C3.55329 21.0641 3.55485 21.0664 3.55485 21.0688L3.55446 21.0699C3.55446 21.0805 3.55954 21.0891 3.56032 21.0992C3.56423 21.1391 3.56853 21.1785 3.58415 21.2148C3.59509 21.241 3.61384 21.2613 3.62986 21.284C3.64236 21.3012 3.64978 21.3215 3.66502 21.3363C3.66502 21.3363 3.66619 21.3367 3.66658 21.3375C3.70174 21.3723 3.74353 21.4 3.79002 21.4191C3.80057 21.4234 3.81307 21.4227 3.8244 21.4262C3.86034 21.4371 3.89628 21.4484 3.93534 21.4484C3.93768 21.4484 3.93964 21.4473 3.94237 21.4473C4.10371 21.4441 7.43941 21.3531 9.70592 19.2492C9.81999 22.3508 12.1275 24.7801 12.2279 24.8844C12.299 24.9582 12.3975 25 12.5002 25C12.5522 25 12.6025 24.9891 12.6494 24.9691C12.6959 24.9496 12.7373 24.9203 12.7717 24.8848C12.7725 24.8848 12.7729 24.8844 12.7729 24.8844C12.8733 24.7801 15.1824 22.3523 15.2984 19.252C17.5207 21.3121 20.765 21.4395 21.0428 21.4465C21.0518 21.4469 21.0611 21.452 21.0709 21.452C21.1678 21.452 21.2647 21.4148 21.3389 21.341C21.3772 21.3027 21.4045 21.2578 21.4229 21.2105C21.4244 21.2086 21.4237 21.2063 21.4244 21.2039C21.4405 21.1605 21.4494 21.1156 21.4494 21.0703C21.4494 21.0676 21.451 21.0648 21.451 21.0621C21.4479 20.9172 21.3655 17.568 19.256 15.2957C22.2842 15.182 24.6656 12.9773 24.8676 12.7852C24.9102 12.7469 24.9449 12.7027 24.9664 12.65ZM15.6621 6.44648C17.0035 5.10586 18.8888 4.60508 20.0455 4.41836L18.9056 5.56016C18.7575 5.7082 18.7583 5.94805 18.9064 6.09609C18.9802 6.16992 19.0775 6.20664 19.1743 6.20664C19.2712 6.20664 19.3681 6.16953 19.4423 6.09531L20.5838 4.95117C20.3974 6.10625 19.897 7.99258 18.5552 9.33516C18.3677 9.52266 18.1743 9.67813 18.0051 9.80898L14.6456 11.2023C14.4382 10.8547 14.146 10.5621 13.7987 10.3535L15.1925 6.99297C15.3546 6.78359 15.5093 6.60234 15.6621 6.44648ZM13.1686 14.1133C12.744 14.291 12.2607 14.293 11.8291 14.1105C11.4025 13.9418 11.0587 13.5988 10.8822 13.1605C10.7946 12.959 10.7505 12.7355 10.7505 12.4969C10.7505 12.2574 10.7946 12.0359 10.8857 11.8285C11.0599 11.3992 11.4044 11.0543 11.8381 10.8797C12.0459 10.7914 12.2689 10.7469 12.5006 10.7469C12.7318 10.7469 12.9565 10.7918 13.1725 10.882C13.5999 11.0555 13.9424 11.398 14.1155 11.8301C14.1163 11.8309 14.1155 11.8316 14.1163 11.8324C14.1163 11.8336 14.1178 11.8348 14.1186 11.8359C14.205 12.0402 14.2507 12.2688 14.2507 12.4969C14.2507 12.7281 14.2057 12.9531 14.1163 13.1656C13.9385 13.5945 13.5936 13.9395 13.1686 14.1133ZM12.1209 1.45117V3.11797C12.1209 3.32695 12.2908 3.49687 12.4998 3.49687C12.7088 3.49687 12.8787 3.32695 12.8787 3.11797V1.44609C13.5639 2.39141 14.546 4.07656 14.546 5.98203C14.546 6.24375 14.5202 6.4875 14.494 6.69883L13.0979 10.066C12.7045 9.96992 12.2916 9.9707 11.9068 10.0648L10.5114 6.70039C10.4849 6.48828 10.4591 6.24375 10.4591 5.98242C10.4587 4.08437 11.4365 2.39922 12.1209 1.45117ZM4.41935 4.9375L5.60925 6.12734C5.68308 6.20117 5.78035 6.23828 5.87723 6.23828C5.97411 6.23828 6.07099 6.20117 6.14521 6.12734C6.29326 5.9793 6.29326 5.73945 6.14521 5.5918L4.97406 4.4207C6.13076 4.60938 8.00428 5.11211 9.3395 6.44727C9.49419 6.60195 9.64616 6.77812 9.81257 6.99258L11.2064 10.3535C10.8575 10.5633 10.5646 10.8566 10.3563 11.2035L6.99759 9.81094C6.83665 9.68867 6.63742 9.53008 6.4503 9.33555C5.10219 7.9875 4.60334 6.09102 4.41935 4.9375ZM1.45163 12.877H3.10913C3.31812 12.877 3.48805 12.707 3.48805 12.498C3.48805 12.2887 3.31812 12.1191 3.10913 12.1191H1.44968C2.39972 11.4344 4.08847 10.4551 5.98505 10.4551C6.24404 10.4551 6.48702 10.4805 6.69836 10.5066L10.0653 11.9031C10.0192 12.0926 9.99226 12.2902 9.99226 12.4969C9.99226 12.7051 10.0192 12.9047 10.0661 13.0957L6.70383 14.4898C6.49171 14.5164 6.24717 14.5422 5.98466 14.5422C4.08964 14.5422 2.40207 13.5625 1.45163 12.877ZM9.33911 18.5504C7.9992 19.8875 6.11708 20.3895 4.96156 20.5773L6.10107 19.4355C6.24912 19.2875 6.24834 19.0477 6.10029 18.8996C5.95223 18.7516 5.71238 18.7523 5.56471 18.9L4.42091 20.0461C4.60725 18.8902 5.10727 17.0012 6.44991 15.6582C6.605 15.5031 6.78469 15.3492 6.99369 15.1898L10.3571 13.7949C10.5665 14.1445 10.8595 14.4363 11.2052 14.6422L9.8114 18.0027C9.63561 18.2293 9.48873 18.4008 9.33911 18.5504ZM12.8811 23.5477V22.0367C12.8811 21.8277 12.7111 21.6578 12.5021 21.6578C12.2928 21.6578 12.1232 21.8277 12.1232 22.0367V23.5531C11.4384 22.6051 10.4583 20.9164 10.4583 19.0113C10.4583 18.7508 10.4845 18.498 10.5099 18.2957L11.906 14.9289C12.0982 14.9766 12.2967 15.0035 12.5002 15.0035C12.7037 15.0035 12.9037 14.9766 13.0975 14.9285L14.4936 18.2945C14.5194 18.509 14.5456 18.7547 14.5456 19.0109C14.5456 20.909 13.5667 22.5973 12.8811 23.5477ZM20.5846 20.052L19.4865 18.9562C19.3376 18.8082 19.0982 18.809 18.9509 18.9566C18.8028 19.1047 18.8036 19.3445 18.9517 19.4926L20.0373 20.5766C18.8806 20.3883 17.0008 19.8863 15.6648 18.5527C15.5152 18.4004 15.3636 18.2219 15.1917 17.9996L13.7971 14.6383C14.1405 14.4301 14.4304 14.1395 14.6401 13.7941L18.0087 15.191C18.213 15.35 18.3946 15.5043 18.5563 15.6605C19.9002 17.0059 20.3994 18.8977 20.5846 20.052ZM19.0153 14.5422C18.7575 14.5422 18.5095 14.5164 18.2934 14.4895L14.9323 13.0953C14.9804 12.9004 15.0077 12.7008 15.0077 12.4969C15.0077 12.2961 14.9804 12.0957 14.9331 11.9035L18.2993 10.5074C18.5138 10.4809 18.7603 10.4551 19.015 10.4551C20.9193 10.4551 22.6132 11.4418 23.5617 12.1266H21.9581C21.7491 12.1266 21.5787 12.2961 21.5787 12.5055C21.5787 12.7148 21.7491 12.8844 21.9581 12.8844H23.5406C22.5905 13.5695 20.9096 14.5422 19.0153 14.5422Z"
      fill="currentColor"
    />
  </svg>
);

export const communityIcon = (
  <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_432_3579)">
      <path
        d="M23.4344 6.44929C22.7281 6.40774 22.1464 7.0217 22.1464 7.73274V13.5542C22.1464 13.8219 22.0448 14.6483 21.911 14.7868L19.2656 17.4322C19.1964 17.4968 19.1087 17.5338 19.021 17.5338C18.9332 17.5338 18.8456 17.4968 18.7763 17.4322L20.279 13.2324C20.2767 13.2324 20.2744 13.2325 20.2721 13.2325M23.4344 6.44929L23.4042 6.94838C23.4043 6.94838 23.4045 6.94839 23.4046 6.9484M23.4344 6.44929L23.4051 6.94843C23.4049 6.94842 23.4048 6.94841 23.4046 6.9484M23.4344 6.44929C23.7392 6.46775 24.0115 6.60163 24.2193 6.80476C24.4409 7.02175 24.5747 7.32644 24.5747 7.65881V15.6039C24.5747 15.8993 24.4593 16.181 24.2516 16.3841L14.5582 18.8221M23.4046 6.9484C23.0207 6.92607 22.6464 7.27322 22.6464 7.73274V13.5542C22.6464 13.7256 22.6167 14.0286 22.5723 14.2998C22.5497 14.4378 22.521 14.5825 22.4857 14.7084C22.4681 14.771 22.4464 14.8384 22.4191 14.902C22.396 14.9559 22.3511 15.051 22.2706 15.1343L22.2646 15.1404L22.2645 15.1404L19.6192 17.7857L19.6131 17.7918L19.6069 17.7976C19.4555 17.9389 19.249 18.0338 19.021 18.0338C18.793 18.0338 18.5865 17.939 18.4351 17.7976L18.4257 17.7889L18.4168 17.7796C18.0988 17.4507 18.0905 16.9217 18.4226 16.5894L18.4228 16.5892L20.9523 14.0597M23.4046 6.9484C23.5778 6.95901 23.7394 7.03496 23.8694 7.16199C23.9958 7.28574 24.0747 7.46201 24.0747 7.65881V15.6039C24.0747 15.7696 24.0101 15.9209 23.902 16.0266L23.8892 16.0391L23.8774 16.0525C23.878 16.0517 23.8743 16.0558 23.8629 16.0685L23.8197 16.1164L23.6618 16.291L23.1099 16.9007C22.6555 17.4023 22.0531 18.0667 21.4506 18.7296C20.8479 19.3926 20.2457 20.0535 19.7914 20.5483C19.5641 20.7959 19.3748 21.0009 19.2414 21.1434C19.2181 21.1683 19.1967 21.1911 19.1773 21.2116H14.5582V18.8221M20.9523 14.0597C20.9519 14.0765 20.9512 14.0922 20.9504 14.1065C20.9494 14.1221 20.9484 14.1348 20.9473 14.1445L20.946 14.1558C20.9456 14.1586 20.9454 14.1599 20.9454 14.1599L20.9457 14.1583L20.9467 14.1535C20.9476 14.1496 20.9496 14.1414 20.9531 14.1301C20.9563 14.1201 20.9631 14.0996 20.9754 14.074C20.9852 14.0539 21.0127 13.9994 21.0679 13.9441M20.9523 14.0597L21.0679 13.9441M20.9523 14.0597C20.9538 14.0005 20.9523 13.9268 20.9455 13.8483C20.9365 13.7463 20.9198 13.6507 20.8961 13.5747C20.8736 13.5023 20.8541 13.4774 20.8544 13.4772C20.8544 13.4771 20.8549 13.4776 20.8557 13.4784C20.6971 13.3198 20.4855 13.2371 20.2721 13.2325M21.0679 13.9441L21.4217 14.2975L21.0681 13.9439L21.0679 13.9441ZM20.2721 13.2325C20.0587 13.2371 19.847 13.3198 19.6885 13.4784L14.7349 18.432C14.6244 18.5425 14.5647 18.6792 14.5582 18.8221M20.2721 13.2325L14.5582 18.8221M14.0784 23.1358H19.3674C19.4658 23.1358 19.5435 23.2133 19.5438 23.3118C19.5438 23.3119 19.5438 23.3121 19.5438 23.3123L19.5416 24.5H13.902V23.3121C13.902 23.2136 13.9798 23.1358 14.0784 23.1358Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        d="M1.11432 16.5129L1.11637 16.511L1.11588 16.5105L1.11488 16.5094L1.11261 16.5069L1.02894 16.4153L1.02896 16.4153L1.02891 16.4153L1.02889 16.4153L0.888896 16.2621L0.887543 16.2606L0.884184 16.2569L0.884205 16.2569L0.883006 16.2556L0.87485 16.2466L0.873635 16.2453L0.873586 16.2452L0.872866 16.2445L0.74394 16.1033L0.742688 16.1019L0.742419 16.1016L0.742375 16.1016L0.702251 16.0577L0.701806 16.0572L0.691989 16.0464L0.692003 16.0464L0.686378 16.0403L0.685924 16.0398L0.685661 16.0395L0.685524 16.0393L0.685484 16.0393L0.68547 16.0393L0.685431 16.0392L0.685401 16.0392L0.685265 16.039C0.677316 16.0386 0.669452 16.0382 0.661671 16.0379L0.672759 16.0265C0.564689 15.9209 0.500111 15.7697 0.500111 15.604V7.6588H0.500158L0.500063 7.6519C0.49748 7.46488 0.575352 7.28933 0.705453 7.16189L0.705471 7.16191L0.70909 7.15829C0.830351 7.03706 0.993912 6.95914 1.17022 6.94834C1.55415 6.92602 1.92843 7.27321 1.92843 7.73268V13.5542C1.92843 13.7449 1.97007 14.0655 2.02356 14.3413C2.05111 14.4833 2.08496 14.6302 2.12407 14.7568C2.14352 14.8197 2.16698 14.8865 2.19535 14.949C2.21889 15.0009 2.26557 15.0956 2.34729 15.1773L4.99235 17.8224M1.11432 16.5129C1.11414 16.5128 1.11396 16.5126 1.11378 16.5124L1.04178 16.5787L1.08217 16.5424L1.08437 16.5404M1.11432 16.5129C1.11444 16.513 1.11455 16.5131 1.11467 16.5132M1.11432 16.5129L1.08437 16.5404M1.08437 16.5404L0.748135 16.8493L0.751722 16.8533M1.08437 16.5404L1.11467 16.5132M0.751722 16.8533L0.756898 16.8589M0.751722 16.8533L1.12209 16.5199C1.12281 16.5206 1.1235 16.5213 1.12417 16.5219L0.756898 16.8589M0.751722 16.8533L1.11516 16.5137C1.115 16.5135 1.11484 16.5134 1.11467 16.5132M0.756898 16.8589L0.76896 16.8721L1.139 16.5363C1.13731 16.5346 1.13528 16.5326 1.13303 16.5304C1.13282 16.5302 1.13232 16.5297 1.13158 16.529L0.756898 16.8589ZM1.11467 16.5132L1.11668 16.5114C1.1165 16.5112 1.11664 16.5114 1.11806 16.5129L1.11976 16.5148C1.12187 16.5171 1.12463 16.5201 1.12786 16.5237L1.13924 16.5361L1.13927 16.5361L1.15167 16.5497L1.15367 16.5519L5.40962 21.2116H10.0168V18.8267C10.0067 18.6738 9.94563 18.5376 9.84006 18.432L4.88198 13.4786L4.88184 13.4785C4.72195 13.3186 4.51425 13.2371 4.30279 13.2325C4.09021 13.2371 3.87934 13.3192 3.72089 13.4767M3.72089 13.4767C3.72094 13.4766 3.72097 13.4766 3.72098 13.4766C3.72129 13.4769 3.70283 13.5009 3.68282 13.5713C3.66121 13.6473 3.64737 13.7438 3.64225 13.8478C3.63786 13.9365 3.64038 14.0194 3.64576 14.0829L6.18906 16.6262L6.18913 16.6263C6.51814 16.9554 6.51814 17.4935 6.18913 17.8226L6.18894 17.8228C6.02107 17.9905 5.80412 18.0707 5.59083 18.0707C5.37769 18.0707 5.16039 17.9907 4.99235 17.8224M3.72089 13.4767C3.72031 13.4772 3.71974 13.4778 3.71917 13.4784M3.72089 13.4767L3.71917 13.4784M4.99235 17.8224L4.9926 17.8227L5.34616 17.4691L4.99235 17.8224ZM3.71917 13.4784L3.36559 13.1249L3.71911 13.4785C3.71913 13.4784 3.71915 13.4784 3.71917 13.4784ZM0.51847 16.5979L0.732517 16.4039C0.777433 16.3945 0.817034 16.3897 0.843677 16.3908C0.897011 16.3974 0.942955 16.4122 0.977364 16.4266L0.642142 16.7332L0.51847 16.5979ZM0.51847 16.5979L0.730281 16.4043C0.726836 16.4051 0.72336 16.4058 0.719858 16.4066L0.514557 16.5936L0.51847 16.5979ZM0.779824 16.8839C0.780445 16.8846 0.780967 16.8852 0.781387 16.8856L1.14966 16.5475L1.14725 16.5449L0.779824 16.8839ZM0.660029 16.7528L0.742611 16.8432L1.11011 16.5092C1.10959 16.5088 1.10907 16.5083 1.10854 16.5079L1.10822 16.5076C1.10477 16.5046 1.0795 16.4826 1.04427 16.461L1.04411 16.4609C1.04244 16.4598 1.02801 16.4503 1.00367 16.4385L0.660029 16.7528ZM0.672086 16.4185C0.677583 16.417 0.683055 16.4155 0.688488 16.4141L0.504927 16.583L0.498938 16.5765L0.672086 16.4185ZM0.669747 16.1678L0.372783 16.4384L0.33261 16.3944L0.336958 16.3902L0.685534 16.0729C0.683522 16.0956 0.678797 16.1286 0.669747 16.1678ZM0.337153 16.39L0.686742 16.0515C0.68668 16.0568 0.686332 16.0637 0.685615 16.072L0.337153 16.39Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        d="M10.3547 11.2391C10.5725 11.0871 10.7864 10.9936 10.9851 10.9367C10.8962 10.7425 10.8564 10.5377 10.8658 10.3375C10.8815 10.0027 11.0589 9.61791 11.4177 9.45559C11.2902 9.33583 11.1793 9.20986 11.0813 9.08325C10.9716 8.94145 10.8775 8.79804 10.7967 8.66828C10.8127 8.76008 10.8247 8.85858 10.8287 8.962L10.829 8.97108L10.829 8.97108C10.8407 9.54614 10.6073 10.1425 10.0724 10.426C9.51548 10.7212 8.8498 10.5671 8.23753 10.0931L8.232 10.0888L8.23203 10.0887C8.14467 10.0191 8.0495 9.94578 7.95013 9.86919C7.64145 9.63128 7.29226 9.36214 7.01117 9.07719C6.62952 8.69029 6.27874 8.18617 6.27221 7.53347L6.27216 7.52846H6.27218C6.27218 6.84311 6.66138 6.1906 7.27104 5.8863C6.77477 5.90124 6.23104 5.85005 5.68286 5.66924C5.55139 6.19453 5.47987 6.7422 5.4798 7.30663L10.3547 11.2391ZM10.3547 11.2391C10.0045 11.4737 9.76613 11.7541 9.63355 12.0757C9.50191 12.395 9.49224 12.712 9.52659 12.9906C9.55259 13.2015 9.60597 13.4046 9.65876 13.5812C7.2038 12.5534 5.47956 10.1331 5.4798 7.30664L10.3547 11.2391ZM16.4016 2.78636C16.3943 2.76344 16.388 2.74408 16.3825 2.72709C16.3741 2.70127 16.3675 2.68092 16.3616 2.66177C16.392 2.62454 16.4458 2.56533 16.5406 2.47074C16.6119 2.3996 16.6968 2.31762 16.7997 2.21912C18.2069 3.46688 19.0946 5.28202 19.0943 7.30711C19.0941 9.11927 18.3838 10.764 17.2264 11.984C17.2566 11.5489 17.3848 11.1415 17.521 10.7087C17.5308 10.6777 17.5406 10.6465 17.5504 10.6151C17.7798 9.88339 18.0353 9.00117 17.3673 8.06802C17.0902 7.67721 16.7088 7.44106 16.3352 7.2834C15.986 7.13606 15.609 7.04395 15.2927 6.96667C15.2758 6.96254 15.2591 6.95846 15.2426 6.95441C14.8913 6.86837 14.6378 6.80104 14.4582 6.70759C14.3021 6.62637 14.2745 6.56471 14.2644 6.50326C14.2514 6.41971 14.2669 6.32618 14.4596 6.15027C14.6025 6.01978 14.7672 5.90876 14.9687 5.77293C15.0784 5.69896 15.199 5.61763 15.333 5.52179C15.6727 5.27882 16.0647 4.95957 16.3059 4.50726C16.5611 4.02877 16.6184 3.45992 16.4016 2.78636ZM16.4016 2.78636L15.9255 2.93891L16.4014 2.78562C16.4015 2.78587 16.4015 2.78612 16.4016 2.78636ZM10.3245 0.787522C11.2816 0.497895 12.3119 0.417302 13.3702 0.590345C13.3675 0.677486 13.3682 0.767558 13.3727 0.860852V0.862137L13.3734 0.875288C13.3827 1.05191 13.3794 1.17033 13.3711 1.24808C13.3682 1.2483 13.3653 1.24854 13.3623 1.24877C13.3476 1.24992 13.3309 1.25123 13.3103 1.25294L13.3101 1.25295C12.8872 1.28835 12.5482 1.40538 12.293 1.61439C12.0343 1.82635 11.9154 2.08896 11.8532 2.30927C11.8229 2.41657 11.8047 2.5186 11.7915 2.59883C11.7902 2.60675 11.789 2.61434 11.7878 2.62163C11.7607 2.60414 11.7296 2.58137 11.6943 2.55193C11.5166 2.40375 11.3206 2.16165 11.097 1.85214C11.0238 1.75076 10.9456 1.63914 10.8653 1.52445C10.7198 1.31672 10.5672 1.09891 10.4242 0.913647C10.3922 0.87214 10.3589 0.829899 10.3245 0.787522ZM11.7484 2.8251C11.7484 2.82488 11.7492 2.82203 11.7513 2.81722C11.7496 2.82292 11.7485 2.82533 11.7484 2.8251ZM10.3374 8.04844C10.3373 8.04838 10.3383 8.04864 10.3402 8.04937C10.3383 8.04886 10.3374 8.04849 10.3374 8.04844ZM11.7286 9.70826C11.8132 9.76733 11.9037 9.82327 12.0007 9.87515L11.7286 9.70826ZM5.20636 23.1357H10.4954C10.594 23.1357 10.6718 23.2135 10.6718 23.3121V24.4999H5.03216L5.02999 23.3121C5.02999 23.312 5.02999 23.3119 5.02999 23.3118C5.03014 23.2133 5.10784 23.1357 5.20636 23.1357Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        d="M8.43286 1.26685L8.52747 1.75782C8.65866 1.73254 8.74272 1.71722 8.81041 1.71251C8.82131 1.71175 8.8303 1.71141 8.83757 1.71131C8.85094 1.72431 8.87196 1.74594 8.901 1.77991C8.9709 1.86168 9.05445 1.97488 9.1571 2.12077C9.19989 2.18158 9.24557 2.24753 9.29381 2.31716C9.46703 2.56722 9.67322 2.86488 9.89708 3.1437C10.1831 3.49994 10.5324 3.87093 10.9436 4.11734C11.3684 4.37189 11.8819 4.50467 12.445 4.32948L12.445 4.32952L12.4507 4.32765C12.883 4.1874 13.1509 3.9214 13.3046 3.6234C13.4295 3.38133 13.4698 3.13272 13.4902 2.9799C13.9259 2.93862 14.2838 2.81191 14.5556 2.58422C14.5766 2.56659 14.5969 2.5486 14.6163 2.53029C14.608 2.77576 14.6583 3.03333 14.749 3.31587C14.7865 3.43389 14.7845 3.51476 14.7715 3.57423C14.7579 3.63667 14.7252 3.70708 14.658 3.79191C14.5081 3.98098 14.2639 4.1551 13.9216 4.39917L13.9181 4.40167C13.6054 4.62464 13.215 4.9046 12.9333 5.27194C12.6324 5.66435 12.4528 6.15759 12.55 6.7762L12.55 6.7762L12.5504 6.77869C12.6427 7.34759 12.916 7.753 13.2899 8.03467C13.644 8.3014 14.0672 8.44069 14.4378 8.53816C14.6104 8.58358 14.7613 8.61822 14.9011 8.65029C15.0984 8.69559 15.2734 8.73578 15.4561 8.79397C15.7479 8.88693 15.887 8.98103 15.9528 9.07401L15.9528 9.07401L15.9545 9.07643C16.0471 9.2057 16.0752 9.34118 16.0443 9.55767C16.0155 9.7588 15.9461 9.97318 15.8531 10.2605C15.8304 10.3304 15.8064 10.4045 15.7813 10.4839C15.5587 11.1853 15.3215 12.0932 15.6123 13.2404C14.6273 13.7953 13.4944 14.1148 12.2849 14.1148H12.2849C12.0444 14.1148 11.8058 14.099 11.5677 14.0714C11.5264 13.703 11.4229 13.3901 11.3478 13.1631C11.3276 13.1019 11.3094 13.0469 11.295 12.9988C11.2437 12.8266 11.2448 12.7672 11.2483 12.7482C11.2485 12.7472 11.2477 12.7476 11.2511 12.7429C11.2565 12.7354 11.2761 12.7115 11.33 12.6756L11.33 12.6757L11.3399 12.6688C11.4224 12.6108 11.4881 12.5954 11.6167 12.5912C11.6397 12.5905 11.6691 12.5904 11.7037 12.5904C11.8452 12.5903 12.0735 12.5902 12.2995 12.5396L12.3183 12.5353L12.3367 12.5297C12.7824 12.393 13.1554 12.0672 13.2564 11.6008C13.2801 11.491 13.2871 11.3818 13.2788 11.2746C13.7071 11.2331 14.0602 11.0692 14.3163 10.799C14.7286 10.3641 14.7984 9.73152 14.5494 9.26011L14.5494 9.2601L14.5474 9.25638C14.4534 9.08187 14.3228 8.89913 14.0693 8.75195C13.8452 8.62185 13.5537 8.53668 13.1726 8.46603C12.7659 8.38343 12.5749 8.20137 12.4041 7.95652C12.3363 7.85936 12.2808 7.76622 12.2159 7.65716C12.1826 7.60135 12.1469 7.54137 12.1057 7.47456C11.994 7.29313 11.8567 7.08749 11.6684 6.89698L11.6676 6.89611C11.3866 6.6132 11.0013 6.40893 10.5946 6.34885C10.526 6.33871 10.456 6.33266 10.3854 6.33118C10.5003 6.1626 10.5883 5.98221 10.6493 5.79647C10.8824 5.08641 10.7223 4.11113 9.88232 3.81169C9.71025 3.74762 9.535 3.73949 9.38606 3.74801C9.23324 3.75675 9.07519 3.78532 8.92515 3.81825C8.79376 3.84709 8.65285 3.88293 8.5138 3.91829C8.49369 3.9234 8.47361 3.92851 8.4536 3.93358C8.29153 3.97469 8.12716 4.01555 7.95699 4.05121C7.42124 4.16348 6.8661 4.21533 6.31409 4.05171C6.79974 3.16145 7.47731 2.39196 8.29316 1.79894C8.37685 1.78614 8.45598 1.77168 8.52802 1.75771L8.43286 1.26685ZM8.43286 1.26685C8.68018 1.2192 8.89473 1.17847 9.04815 1.24986C9.21674 1.32794 9.43873 1.64832 9.71093 2.04116C10.3275 2.93101 11.2017 4.19266 12.2964 3.85206L5.62862 4.30796C6.17232 3.10235 7.03091 2.07144 8.10298 1.32042C8.21812 1.30655 8.32959 1.28687 8.43286 1.26685ZM15.1047 1.11561C15.183 1.1514 15.2605 1.18864 15.3372 1.2273C15.3021 1.2618 15.2686 1.2953 15.2369 1.32771C15.1851 1.38049 15.1343 1.4341 15.0854 1.48901C15.0995 1.35835 15.1038 1.23129 15.1047 1.11561ZM8.43366 7.37721C8.62911 7.36072 8.81241 7.32892 8.98349 7.28388C8.86671 7.60875 8.87442 7.93971 8.91181 8.20575C8.92318 8.28666 8.93781 8.36554 8.95373 8.44033C8.92273 8.41562 8.89251 8.39157 8.86304 8.36811C8.61437 8.17021 8.41893 8.01467 8.26147 7.86571C8.02522 7.64224 8.00945 7.55142 8.00861 7.52149C8.00884 7.48629 8.01292 7.46666 8.01554 7.45775C8.0176 7.45643 8.0205 7.45471 8.02444 7.45263C8.04792 7.4402 8.09185 7.42401 8.16777 7.40953C8.24316 7.39516 8.32934 7.38609 8.43366 7.37721ZM8.01772 7.45177C8.01774 7.4518 8.01757 7.45223 8.01715 7.45301L8.01772 7.45177Z"
        fill="white"
        stroke="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_432_3579">
        <rect width="25" height="25" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const communityActiveIcon = (
  <svg viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.321 24.315L18.3208 24.315V24.3274V27.9224V28.2974H18.6958H25.3019C25.3898 28.2974 25.4529 28.266 25.4634 28.261C25.4872 28.2498 25.5048 28.2384 25.5131 28.2328C25.5306 28.221 25.544 28.21 25.5498 28.2052C25.563 28.1941 25.5751 28.1827 25.5833 28.1748C25.6012 28.1577 25.6233 28.1355 25.6474 28.1107C25.6965 28.0602 25.7651 27.9878 25.8493 27.8978C26.0182 27.7174 26.2556 27.4604 26.538 27.1528C27.103 26.5374 27.8511 25.7164 28.5987 24.8939C30.0358 23.3129 31.4751 21.7217 31.6068 21.5755C31.9333 21.2513 32.1113 20.8082 32.1113 20.3489V10.4969C32.1113 9.98309 31.9041 9.50896 31.558 9.16996L31.5577 9.16974C31.242 8.86101 30.8213 8.65164 30.345 8.62279L30.3444 8.62275C29.2268 8.55701 28.3502 9.51837 28.3502 10.5886V17.8072C28.3502 17.945 28.322 18.2622 28.2714 18.5709C28.2464 18.7235 28.2178 18.863 28.1878 18.9699C28.1728 19.0235 28.1594 19.0619 28.1488 19.0866C28.1479 19.0887 28.147 19.0906 28.1463 19.0924L24.8938 22.3447C24.8711 22.3646 24.8531 22.3668 24.8497 22.3668C24.8465 22.3668 24.8307 22.3649 24.8103 22.3487C24.7891 22.3213 24.7956 22.2901 24.8116 22.2741L28.0917 18.994L28.0918 18.9939C28.1632 18.9225 28.189 18.8385 28.1943 18.8213L28.1948 18.8195C28.205 18.7871 28.2116 18.7553 28.2161 18.7296C28.2253 18.6766 28.2315 18.6151 28.2354 18.5515C28.2431 18.4227 28.2424 18.2586 28.2272 18.0851C28.2121 17.9124 28.1817 17.7194 28.125 17.5372C28.0699 17.3599 27.9806 17.1619 27.8283 17.0097C27.4341 16.6155 26.9151 16.4203 26.4062 16.4132L26.4063 16.4131L26.3959 16.4132C25.887 16.4203 25.368 16.6155 24.9738 17.0097L18.8314 23.1521C18.5205 23.4629 18.3357 23.8728 18.321 24.315ZM17.5071 32V32.375H17.8821H26.1142H26.4885L26.4892 32.0007L26.493 29.9078V29.9071C26.4929 29.2353 25.951 28.6934 25.2792 28.6934H18.7208C18.0491 28.6934 17.5071 29.2352 17.5071 29.907V32ZM1.61527 21.8178L2.1701 21.3132C2.16567 21.3082 2.16009 21.3021 2.15368 21.2954L1.60767 21.8096L1.61527 21.8178ZM1.61151 21.8137L1.62546 21.8012L1.61194 21.8141L1.61151 21.8137Z"
      fill="currentColor"
      stroke="#D3DCD6"
      stroke-width="0.75"
    />
    <path
      d="M1.39386 21.5761L1.39862 21.5813L1.39896 21.5817L1.60497 21.8073L1.60519 21.8075L1.60528 21.8076L1.60532 21.8076L1.614 21.8171L1.61449 21.8176L1.6151 21.8183L1.62875 21.8333L1.62977 21.8345L1.78345 22.0026L1.78343 22.0026L1.78414 22.0034L1.90801 22.139L1.91107 22.1424L1.91397 22.1456L1.91709 22.149L1.91704 22.149L1.92082 22.1531L1.9208 22.1531L1.92594 22.1587L1.95414 22.1895L1.95482 22.1902L2.23044 21.9359C2.23154 21.9371 2.2324 21.938 2.23301 21.9387L1.95676 22.1924L1.9581 22.1938L7.4213 28.1754L7.53282 28.2975H7.69819H14.3045H14.6795V27.9225V24.3275V24.3181L14.679 24.3088C14.6573 23.8753 14.4829 23.4661 14.1689 23.1521L14.1688 23.152L8.02066 17.0097C8.02063 17.0097 8.0206 17.0096 8.02056 17.0096C7.62729 16.6165 7.11454 16.4203 6.6043 16.4133L6.6043 16.4132L6.59398 16.4133C6.08511 16.4203 5.5661 16.6155 5.17186 17.0097L5.17182 17.0097C5.01407 17.1675 4.92551 17.3726 4.87327 17.5565C4.81971 17.7449 4.79506 17.9441 4.78627 18.1222C4.77743 18.3013 4.78407 18.4709 4.79853 18.6048C4.80569 18.6711 4.81545 18.7351 4.82825 18.7905C4.83452 18.8177 4.84319 18.8501 4.85548 18.8827L4.85579 18.8836C4.86332 18.9036 4.89056 18.9761 4.95435 19.0399C4.95439 19.04 4.95443 19.04 4.95447 19.04L8.23449 22.3201C8.23451 22.3201 8.23453 22.3201 8.23454 22.3201L1.39386 21.5761ZM1.39386 21.5761C1.06685 21.2519 0.888809 20.8086 0.888809 20.349V10.4994C0.882418 9.98002 1.09893 9.5069 1.44081 9.17133C1.75399 8.85887 2.18187 8.65146 2.65515 8.62279L2.6558 8.62275C3.77328 8.55701 4.64993 9.51843 4.64993 10.5886V17.8073C4.64993 17.9491 4.68759 18.2736 4.74968 18.5938C4.78012 18.7508 4.81417 18.8947 4.84815 19.0046C4.86522 19.0599 4.88025 19.0999 4.89202 19.1258C4.89357 19.1292 4.89495 19.1321 4.89615 19.1346L1.39386 21.5761ZM1.67595 21.3289L1.72599 21.3837L1.54679 21.547C1.49735 21.5594 1.45342 21.5642 1.42288 21.5648L1.51209 21.4785L1.51895 21.4718L1.67154 21.3241C1.67292 21.3256 1.67439 21.3272 1.67595 21.3289ZM1.86003 21.9326C1.86886 21.868 1.92269 21.7361 1.9822 21.6642L2.06015 21.7495L1.86003 21.9326ZM1.87767 22.0564C1.87314 22.041 1.86644 22.0064 1.86239 21.9746L2.08209 21.7736L2.1855 21.8867L1.91332 22.1342C1.90912 22.1272 1.90271 22.1161 1.89605 22.1022C1.89178 22.093 1.88246 22.0701 1.87767 22.0564ZM2.19125 21.8931L2.19581 21.8981L2.20223 21.9051L2.21841 21.9228L1.94132 22.1743C1.93932 22.1718 1.93629 22.1679 1.9329 22.1633C1.93203 22.1622 1.93034 22.1599 1.92811 22.1567C1.92705 22.1552 1.92588 22.1535 1.92461 22.1517C1.92434 22.1513 1.92406 22.1509 1.92379 22.1505C1.92279 22.149 1.92174 22.1474 1.92066 22.1458C1.92011 22.145 1.91955 22.1441 1.91899 22.1432L2.19125 21.8931Z"
      fill="currentColor"
      stroke="#D3DCD6"
      stroke-width="0.75"
    />
    <path
      d="M2.33352 21.8395L1.95181 22.187L1.95349 22.1889L1.95593 22.1915L1.95628 22.192C1.95883 22.1947 1.96298 22.1992 1.96825 22.2045L2.51111 21.6873L2.50954 21.6856L2.50809 21.684L2.5064 21.6821L2.50635 21.6822M2.33352 21.8395L2.32069 21.8523L2.30899 21.864L2.50806 21.684C2.50755 21.6834 2.50697 21.6828 2.50635 21.6822M2.33352 21.8395L2.49879 21.6744C2.50177 21.6773 2.50433 21.68 2.50635 21.6822M2.33352 21.8395L2.50635 21.6822M16.3458 5.26492L16.3458 5.2649C15.872 5.4127 15.4495 5.19742 15.1272 4.92852C14.802 4.65729 14.4962 4.26541 14.2174 3.87936C14.1069 3.72637 14.0014 3.57566 13.8986 3.4287C13.7297 3.18718 13.5678 2.95577 13.402 2.74092C13.132 2.39109 12.9111 2.16829 12.7336 2.0785L12.0201 1.71755L12.7539 1.39977C14.5313 0.629977 16.543 0.396958 18.6053 0.868074L18.9626 0.949691L18.8892 1.30875C18.8468 1.51636 18.8259 1.75337 18.8403 2.03294L18.8408 2.04256V2.04306C18.8554 2.32742 18.8502 2.55985 18.8207 2.74856C18.791 2.93857 18.7319 3.11547 18.6136 3.25617C18.4883 3.40503 18.3329 3.47098 18.1962 3.50284C18.0944 3.52657 17.9796 3.53536 17.8938 3.54192C17.8786 3.54308 17.8643 3.54418 17.8512 3.54527L16.3458 5.26492ZM16.3458 5.26492L16.3497 5.26366M16.3458 5.26492L16.3497 5.26366M16.3497 5.26366C16.6905 5.15324 16.7806 4.83379 16.8173 4.66656M16.3497 5.26366L16.8173 4.66656M16.8173 4.66656C16.8334 4.59367 16.8465 4.51177 16.858 4.43972M16.8173 4.66656L16.858 4.43972M16.858 4.43972C16.8611 4.42044 16.864 4.40187 16.8669 4.38437M16.858 4.43972L16.8669 4.38437M16.8669 4.38437C16.8819 4.2937 16.8972 4.21172 16.9192 4.13392M16.8669 4.38437L16.9192 4.13392M16.9192 4.13392C16.9619 3.9826 17.0248 3.86397 17.1375 3.77168M16.9192 4.13392L17.1375 3.77168M17.1375 3.77168C17.2529 3.67718 17.4601 3.57802 17.8511 3.54528L17.1375 3.77168ZM1.91051 22.1417L2.46401 21.6357L2.46341 21.635L2.35949 21.5212L2.35919 21.5209L1.80457 22.0257C1.84686 22.0722 1.88306 22.1118 1.91051 22.1417ZM6.50586 29.9071L6.50586 29.9078L6.50967 32.0007L6.51035 32.375H6.88467H15.1167H15.4917V32V29.907C15.4917 29.2352 14.9497 28.6934 14.278 28.6934H7.71955C7.04775 28.6934 6.50586 29.2353 6.50586 29.9071ZM20.6541 4.75873L20.6543 4.75929C20.8509 5.36978 20.7801 5.79266 20.605 6.12087C20.4195 6.46885 20.0943 6.75412 19.6977 7.03782C19.5881 7.11626 19.4683 7.19728 19.3455 7.28038C19.058 7.47487 18.7536 7.68074 18.5227 7.89154C18.1726 8.21113 17.8768 8.63789 17.9689 9.2206L17.9691 9.22202C18.0483 9.7111 18.3661 10.0094 18.7325 10.2001C19.0818 10.3819 19.5214 10.4905 19.9278 10.59L19.9653 10.5992C20.3772 10.7 20.7748 10.7973 21.1325 10.9482C21.4962 11.1017 21.7886 11.2991 21.988 11.5808L21.9893 11.5826C22.5103 12.3095 22.3615 12.9568 22.0768 13.8652C22.0609 13.9159 22.0446 13.9674 22.0281 14.0195C21.7541 14.8843 21.4191 15.9417 21.7783 17.2439L21.9294 17.7916L22.3736 17.4374C24.5407 15.7093 25.9353 13.05 25.9357 10.061C25.936 7.03688 24.5077 4.35203 22.2974 2.62596L22.0415 2.42616L21.8071 2.65076C21.7233 2.73104 21.6447 2.80617 21.571 2.87652C21.367 3.07136 21.2014 3.22957 21.0713 3.35936C20.8985 3.53173 20.7602 3.68085 20.6711 3.82361C20.5682 3.98837 20.5249 4.1532 20.5442 4.33873C20.557 4.46182 20.6006 4.59497 20.6369 4.70598C20.6429 4.72421 20.6487 4.74184 20.6541 4.75873ZM13.9918 19.1508L14.4779 19.2846L14.4509 18.501C14.4509 18.501 14.4509 18.5009 14.4508 18.5008C14.4187 18.2722 14.3398 18.0223 14.2686 17.7968C14.2611 17.7731 14.2537 17.7498 14.2465 17.7267C14.1653 17.4679 14.0935 17.2246 14.0642 16.9867C14.0354 16.7532 14.0504 16.5442 14.1291 16.3532C14.2068 16.1649 14.3596 15.9617 14.6613 15.7606L14.6614 15.7606L14.6687 15.7555C14.9946 15.5267 15.3004 15.4677 15.5566 15.4543C15.6604 15.4489 15.7499 15.4509 15.8406 15.453C15.8686 15.4536 15.8967 15.4543 15.9253 15.4547C15.9809 15.4555 16.0462 15.4555 16.1086 15.4495C16.1667 15.4438 16.2583 15.4301 16.3482 15.3815L16.7762 15.15L16.4434 14.7951C16.3905 14.7387 16.298 14.6499 16.1264 14.5321C15.8078 14.3077 15.7228 14.0423 15.7311 13.8654C15.7406 13.6646 15.8414 13.6263 15.8666 13.6238L15.8671 13.6237C16.1775 13.5918 16.4826 13.6659 16.8227 13.7486L16.8372 13.7521C16.9992 13.7914 17.1806 13.8347 17.3535 13.851C17.526 13.8672 17.7268 13.8607 17.9201 13.7721L17.9278 13.7689C17.9278 13.7689 17.9278 13.7689 17.9278 13.7689C17.9278 13.7689 17.9278 13.7689 17.9278 13.7689C18.0714 13.707 18.1682 13.6013 18.225 13.516C18.2546 13.4716 18.2808 13.4217 18.2992 13.3691C18.3084 13.343 18.318 13.3094 18.3233 13.2706C18.3277 13.2381 18.3338 13.1698 18.3091 13.0906L18.2985 13.0566L18.2817 13.0253C18.2353 12.9385 18.1693 12.8846 18.1264 12.8548C18.0803 12.8229 18.0329 12.7998 17.9933 12.7831C17.9144 12.7497 17.8272 12.7252 17.7519 12.707C17.6364 12.6792 17.5062 12.6568 17.4242 12.6426C17.4025 12.6389 17.3841 12.6357 17.3704 12.6332C16.5752 12.4723 16.1196 12.0784 15.7914 11.6543C15.6314 11.4477 15.5029 11.2356 15.375 11.0244C15.367 11.0113 15.3591 10.9982 15.3512 10.9851C15.2233 10.7743 15.0805 10.5401 14.9089 10.3665L14.9083 10.3658C14.7825 10.2391 14.6352 10.1337 14.4787 10.0672C14.3267 10.0026 14.1338 9.96176 13.9388 10.0163C13.7239 10.0765 13.5693 10.2354 13.4947 10.4446C13.4261 10.637 13.4266 10.8625 13.4682 11.101L13.4682 11.101L13.4688 11.1042C13.4918 11.2299 13.5326 11.3736 13.5694 11.5035C13.5829 11.5512 13.5959 11.597 13.6073 11.6394C13.6541 11.8133 13.6899 11.9794 13.6969 12.148C13.7054 12.6142 13.5166 12.9278 13.2875 13.0492C13.0745 13.1621 12.677 13.1845 12.0893 12.7303C11.9532 12.6218 11.8172 12.5169 11.6834 12.4137C11.315 12.1296 10.9626 11.8579 10.6659 11.557C10.2689 11.1546 10.0411 10.7651 10.0362 10.3335C10.0369 9.83563 10.3315 9.37288 10.749 9.17733L10.749 9.17736L10.7532 9.1753C10.8968 9.10582 11.0833 9.06675 11.3261 9.03387C11.3843 9.02601 11.4472 9.01837 11.5131 9.01038C11.6991 8.98783 11.9087 8.96243 12.1003 8.92078C12.3691 8.86233 12.6608 8.7621 12.9071 8.5514C13.16 8.33502 13.3321 8.03079 13.4108 7.6255C13.4434 7.47024 13.4388 7.32616 13.4147 7.20937C13.4028 7.15151 13.3843 7.09141 13.3568 7.03585C13.3432 7.0085 13.3233 6.97358 13.2944 6.93873C13.2711 6.91052 13.2133 6.84679 13.1155 6.81234L13.1072 6.8094L13.0987 6.80687C12.9984 6.77677 12.9025 6.78947 12.8645 6.79475C12.8114 6.80215 12.7547 6.81487 12.701 6.8283C12.6149 6.84984 12.5077 6.88078 12.3914 6.91435C12.3634 6.92243 12.3348 6.93067 12.3059 6.93896C11.9995 7.02691 11.6033 7.13599 11.1488 7.21273C10.2358 7.36684 9.12147 7.38437 8.0768 6.8598L7.68975 6.66545L7.55277 7.07631C7.2402 8.01382 7.06374 9.01516 7.06361 10.0602C7.06324 14.4039 9.99932 18.052 13.9918 19.1508ZM16.0441 14.7019C16.0442 14.7019 16.0432 14.7021 16.0412 14.7024L16.0441 14.7019ZM1.9518 22.187V22.187Z"
      fill="currentColor"
      stroke="#D3DCD6"
      stroke-width="0.75"
    />
    <path
      d="M12.6412 2.2097C12.4627 2.12671 12.2747 2.12014 12.1196 2.13094C11.9666 2.14157 11.803 2.17311 11.6572 2.2012L11.6495 2.2027L11.6491 2.20278C11.525 2.22683 11.3966 2.24937 11.2665 2.26503L11.1732 2.27627L11.0962 2.33021C9.71195 3.29994 8.60338 4.63098 7.90132 6.18774L7.75704 6.50765L8.06671 6.67279C9.23842 7.29765 10.4039 7.19237 11.3344 6.99737C11.5673 6.94857 11.7883 6.89348 11.9908 6.84213C12.0165 6.8356 12.0419 6.82915 12.0669 6.82279C12.2414 6.77844 12.3985 6.73849 12.5442 6.70652C12.711 6.66991 12.8474 6.64733 12.9592 6.64093C13.0725 6.63445 13.1371 6.64623 13.1718 6.65943L13.1717 6.65954L13.1808 6.66273C13.49 6.77148 13.7312 7.2445 13.5234 7.87731C13.3343 8.45334 12.7652 9.06135 11.6373 9.15632L11.637 9.15635C11.3847 9.17784 11.0344 9.21065 10.7487 9.36176C10.596 9.44255 10.4521 9.56127 10.349 9.73444C10.2464 9.90688 10.1993 10.1081 10.1993 10.3306L10.1994 10.3344C10.2041 10.8002 10.4894 11.1597 10.8241 11.4763C11.05 11.69 11.3466 11.9263 11.6806 12.1923C11.8407 12.3198 12.0094 12.4542 12.183 12.5962L12.1829 12.5963L12.1902 12.602C12.3118 12.6965 12.4353 12.7835 12.5543 12.8472C12.6637 12.9058 12.8178 12.9718 12.9869 12.9628C13.0799 12.9578 13.1781 12.93 13.2673 12.8677C13.3551 12.8064 13.414 12.7257 13.4525 12.6456C13.5239 12.4969 13.5386 12.3212 13.5351 12.1559L13.5352 12.1559L13.5349 12.1486C13.5287 11.9973 13.4783 11.8078 13.4362 11.6496C13.433 11.6376 13.4299 11.6257 13.4268 11.6141C13.3774 11.4273 13.3274 11.2344 13.2996 11.0367C13.2441 10.6412 13.2879 10.3074 13.542 10.0549C13.733 9.87729 13.9824 9.81656 14.2556 9.85692C14.5362 9.89838 14.8202 10.0458 15.0252 10.252C15.1789 10.4077 15.3024 10.5869 15.4275 10.7901C15.4619 10.846 15.4978 10.9061 15.535 10.9686C15.6255 11.1202 15.724 11.2854 15.8288 11.4354C16.1497 11.8955 16.5889 12.31 17.406 12.4743L17.406 12.4743L17.4117 12.4754C17.8548 12.5573 18.0818 12.6385 18.21 12.7129C18.3162 12.7746 18.3654 12.8368 18.4258 12.9485C18.5329 13.1528 18.5134 13.4746 18.2938 13.7063C18.0889 13.9224 17.6335 14.1272 16.7579 13.901L16.4207 14.5493C16.7205 14.805 16.7595 15.0341 16.7291 15.1745C16.6975 15.3203 16.5662 15.4905 16.283 15.5813C16.1275 15.6146 16.0018 15.615 15.8464 15.6156C15.7826 15.6159 15.7137 15.6161 15.6358 15.6187C15.3723 15.6273 15.0758 15.6698 14.757 15.8925C14.4679 16.0863 14.2882 16.3275 14.233 16.6277C14.1825 16.9021 14.248 17.1746 14.316 17.4027C14.3439 17.4963 14.3738 17.5887 14.4038 17.6811C14.5312 18.0736 14.6591 18.4677 14.6316 18.9688L14.6131 19.3043L14.9446 19.3593C15.4453 19.4424 15.9622 19.4974 16.4969 19.4974C18.3608 19.4974 20.0936 18.9498 21.5562 18.0184L21.8059 17.8593L21.7092 17.5795C21.2419 16.2278 21.4966 15.1968 21.7809 14.3009C21.8055 14.2232 21.831 14.1448 21.8566 14.0662C21.9746 13.7036 22.0947 13.3348 22.1436 12.9922C22.2067 12.5505 22.1617 12.1022 21.8566 11.6761C21.5819 11.2885 21.1474 11.0891 20.7313 10.9565C20.4788 10.8761 20.1817 10.8069 19.8974 10.7407C19.7298 10.7017 19.5666 10.6637 19.4196 10.6251C18.9889 10.5118 18.6203 10.378 18.3418 10.1682C18.0784 9.96982 17.881 9.69272 17.8085 9.24725C17.736 8.78442 17.8606 8.44254 18.0906 8.14271C18.335 7.8239 18.6944 7.55729 19.0998 7.26823C19.1232 7.25155 19.1468 7.23474 19.1706 7.21781C19.5354 6.95836 19.9433 6.66826 20.2193 6.32013C20.3722 6.12719 20.4959 5.90415 20.5526 5.64367C20.6098 5.38102 20.5938 5.10298 20.5003 4.80925L20.5 4.80843C20.3266 4.26823 20.3624 4.02866 20.4883 3.80772C20.5633 3.676 20.6825 3.53212 20.8681 3.34277C20.9906 3.21776 21.1297 3.08494 21.2922 2.92973C21.3784 2.8474 21.4712 2.75877 21.5717 2.66166L21.9155 2.3292L21.5106 2.07461C20.8909 1.68495 20.224 1.36443 19.5172 1.12568L19.0952 0.983109L19.0267 1.4233C18.9927 1.64191 18.9953 1.89642 18.9976 2.12339C18.998 2.16009 18.9984 2.19608 18.9986 2.23108C19.0002 2.50281 18.9939 2.74653 18.9444 2.96062C18.8967 3.16695 18.8136 3.32445 18.6736 3.44175C18.5309 3.56138 18.2896 3.672 17.8652 3.70743C17.8651 3.70744 17.8651 3.70744 17.8651 3.70744L17.8517 3.70855C17.7491 3.71708 17.6463 3.72562 17.5621 3.74122C17.4734 3.75764 17.3453 3.79122 17.2358 3.89167C17.1235 3.99479 17.0811 4.12173 17.0597 4.21093C17.0408 4.28939 17.0285 4.38468 17.0168 4.47489C17.0159 4.48225 17.0149 4.48957 17.014 4.49684C16.9893 4.68716 16.9624 4.87167 16.8771 5.03685C16.8011 5.18425 16.6709 5.33001 16.3977 5.41918C16.0357 5.53109 15.6935 5.46073 15.3451 5.25202C14.9859 5.03678 14.6407 4.68476 14.3119 4.27528C14.0587 3.95993 13.8306 3.63076 13.6182 3.32422C13.5549 3.23288 13.493 3.14356 13.4322 3.05721C13.3032 2.87384 13.1767 2.70031 13.0572 2.56055C12.9467 2.43131 12.8058 2.28599 12.6412 2.2097ZM12.6412 2.2097C12.6414 2.20975 12.6415 2.2098 12.6416 2.20986L12.4834 2.54984L12.641 2.20957C12.6411 2.20961 12.6412 2.20965 12.6412 2.2097Z"
      fill="currentColor"
      stroke="#D3DCD6"
      stroke-width="0.75"
    />
  </svg>
);

export const libraryIcon = (
  <svg viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.7409 1.04837e-05C10.7607 1.04837e-05 10.7806 1.04837e-05 10.801 1.04837e-05H20.1987C20.219 1.04837e-05 20.2389 1.04837e-05 20.2587 1.04837e-05C20.5758 -7.60282e-05 20.8187 -0.000148145 21.0312 0.0226477C22.9838 0.232194 24.4781 1.83559 24.5688 3.77787C26.526 4.36229 27.8417 6.34476 27.4681 8.47738L25.3378 8.1041C25.5515 6.8846 24.6131 5.76747 23.375 5.76747H7.62438C6.3863 5.76747 5.44791 6.8846 5.66159 8.1041L3.53126 8.47738C3.15756 6.34466 4.47354 4.3621 6.43078 3.77778C6.52147 1.83555 8.01593 0.232194 9.96844 0.0226477C10.1809 -0.000148145 10.4239 -7.60282e-05 10.7409 1.04837e-05ZM8.62536 3.60467H22.3743C22.2206 2.8496 21.5937 2.25824 20.8004 2.1731C20.7192 2.16439 20.6036 2.16281 20.1987 2.16281H10.801C10.396 2.16281 10.2804 2.16439 10.1992 2.1731C9.40589 2.25824 8.77894 2.8496 8.62536 3.60467Z"
      fill="currentColor"
    />
    <path
      d="M10.5928 24.1512C10.5928 23.8301 10.8531 23.5698 11.1742 23.5698H19.8253C20.1464 23.5698 20.4067 23.8301 20.4067 24.1512C20.4067 24.4722 20.1464 24.7326 19.8253 24.7326H11.1742C10.8531 24.7326 10.5928 24.4722 10.5928 24.1512Z"
      fill="currentColor"
      stroke="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.6206 7.20923H20.3792C22.7433 7.2092 24.6269 7.20919 26.0855 7.4032C27.5841 7.60251 28.8272 8.02772 29.7571 9.03219C30.6972 10.0476 30.9886 11.299 30.9997 12.7608C31.0103 14.1662 30.7599 15.9422 30.4489 18.1476L29.8159 22.637C29.5728 24.3617 29.3753 25.7626 29.068 26.8604C28.7465 28.009 28.2727 28.954 27.3953 29.6804C26.5249 30.4012 25.4922 30.7119 24.2715 30.8584C23.0914 31 21.6065 31 19.7579 31H11.242C9.39336 31 7.90862 31 6.72839 30.8584C5.50778 30.7119 4.47512 30.4012 3.60469 29.6804C2.7273 28.954 2.25342 28.009 1.93193 26.8604C1.62463 25.7626 1.42713 24.3617 1.18402 22.637L0.551061 18.1476C0.240081 15.9422 -0.010341 14.1662 0.000328753 12.7608C0.0114166 11.299 0.302744 10.0476 1.24282 9.03219C2.17275 8.02772 3.41583 7.60251 4.91436 7.4032C6.37301 7.20919 8.2567 7.2092 10.6206 7.20923ZM5.19951 9.54711C3.92338 9.71685 3.26663 10.0297 2.82989 10.5015C2.4033 10.9623 2.17207 11.5893 2.16304 12.7773C2.15374 14.003 2.37879 15.6193 2.70515 17.9343L3.31502 22.2598C3.57134 24.0777 3.75085 25.3349 4.01467 26.2775C4.26873 27.1851 4.56773 27.6699 4.98398 28.0146C5.40717 28.365 5.9753 28.5898 6.98608 28.711C8.0224 28.8353 9.37708 28.8372 11.3119 28.8372H19.688C21.6228 28.8372 22.9776 28.8353 24.0139 28.711C25.0246 28.5898 25.5928 28.365 26.016 28.0146C26.4321 27.6699 26.7312 27.1851 26.9852 26.2775C27.2491 25.3349 27.4286 24.0777 27.685 22.2598L28.2947 17.9343C28.6212 15.6193 28.8463 14.003 28.8369 12.7773C28.8279 11.5893 28.5967 10.9623 28.17 10.5015C27.7333 10.0297 27.0765 9.71685 25.8005 9.54711C24.5011 9.37429 22.7618 9.37203 20.2979 9.37203H10.702C8.23816 9.37203 6.49883 9.37429 5.19951 9.54711Z"
      fill="currentColor"
    />
  </svg>
);

export const libraryActiveIcon = (
  <svg viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.7409 1.04836e-05C10.7607 1.04836e-05 10.7806 1.04836e-05 10.801 1.04836e-05H20.1987C20.219 1.04836e-05 20.2389 1.04836e-05 20.2587 1.04836e-05C20.5758 -7.60278e-05 20.8187 -0.000148145 21.0312 0.0226476C22.9838 0.232193 24.4781 1.83558 24.5688 3.77785C26.526 4.36227 27.8417 6.34473 27.4681 8.47734L25.3378 8.10406C25.5515 6.88457 24.6131 5.76744 23.375 5.76744H7.62438C6.3863 5.76744 5.44791 6.88457 5.66159 8.10406L3.53126 8.47734C3.15756 6.34463 4.47354 4.36208 6.43078 3.77777C6.52147 1.83554 8.01593 0.232193 9.96844 0.0226476C10.1809 -0.000148145 10.4239 -7.60278e-05 10.7409 1.04836e-05ZM8.62536 3.60466H22.3743C22.2206 2.84958 21.5937 2.25823 20.8004 2.17309C20.7192 2.16438 20.6036 2.1628 20.1987 2.1628H10.801C10.396 2.1628 10.2804 2.16438 10.1992 2.17309C9.40589 2.25823 8.77895 2.84958 8.62536 3.60466Z"
      fill="currentColor"
    />
    <path
      d="M1.54639 9.36047H29.4533L27.2208 29.4535H4.33708L1.54639 9.36047Z"
      fill="currentColor"
    />
    <path
      d="M1.54639 9.36047H29.4533L27.2208 29.4535H4.33708L1.54639 9.36047Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.6206 7.20935H20.3792C22.7433 7.20932 24.6269 7.20931 26.0855 7.40332C27.5841 7.60263 28.8272 8.02784 29.7571 9.03231C30.6972 10.0477 30.9886 11.2991 30.9997 12.7609C31.0103 14.1663 30.7599 15.9423 30.4489 18.1477L29.8159 22.6371C29.5728 24.3617 29.3753 25.7626 29.068 26.8604C28.7465 28.009 28.2727 28.954 27.3953 29.6804C26.5249 30.4012 25.4922 30.7119 24.2715 30.8584C23.0914 31 21.6065 31 19.7579 31H11.242C9.39336 31 7.90862 31 6.72839 30.8584C5.50778 30.7119 4.47512 30.4012 3.60469 29.6804C2.7273 28.954 2.25342 28.009 1.93193 26.8604C1.62463 25.7626 1.42713 24.3617 1.18402 22.6371L0.551061 18.1477C0.240081 15.9423 -0.010341 14.1663 0.000328753 12.7609C0.0114166 11.2991 0.302744 10.0477 1.24282 9.03231C2.17275 8.02784 3.41583 7.60263 4.91436 7.40332C6.37301 7.20931 8.2567 7.20932 10.6206 7.20935ZM5.19951 9.54722C3.92338 9.71696 3.26663 10.0299 2.82989 10.5016C2.4033 10.9624 2.17207 11.5894 2.16304 12.7774C2.15374 14.0031 2.37879 15.6194 2.70515 17.9343L3.31502 22.2599C3.57134 24.0778 3.75085 25.335 4.01467 26.2775C4.26873 27.1851 4.56773 27.6699 4.98398 28.0146C5.40717 28.365 5.9753 28.5898 6.98608 28.7111C8.0224 28.8354 9.37708 28.8372 11.3119 28.8372H19.688C21.6228 28.8372 22.9776 28.8354 24.0139 28.7111C25.0246 28.5898 25.5928 28.365 26.016 28.0146C26.4321 27.6699 26.7312 27.1851 26.9852 26.2775C27.2491 25.335 27.4286 24.0778 27.685 22.2599L28.2947 17.9343C28.6212 15.6194 28.8463 14.0031 28.8369 12.7774C28.8279 11.5894 28.5967 10.9624 28.17 10.5016C27.7333 10.0299 27.0765 9.71696 25.8005 9.54722C24.5011 9.3744 22.7618 9.37214 20.2979 9.37214H10.702C8.23816 9.37214 6.49883 9.3744 5.19951 9.54722Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0928 24.1512C10.0928 23.5539 10.5769 23.0698 11.1742 23.0698H19.8253C20.4225 23.0698 20.9067 23.5539 20.9067 24.1512C20.9067 24.7484 20.4225 25.2326 19.8253 25.2326H11.1742C10.5769 25.2326 10.0928 24.7484 10.0928 24.1512Z"
      fill="currentColor"
    />
  </svg>
);

export const activeTaskIcon = (
  <svg viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.1226 0.576841L12.4739 0.224575L12.1226 0.576842L13.1103 1.56195C13.144 1.61187 13.1672 1.68358 13.1672 1.76025C13.1672 1.84678 13.1392 1.88463 13.1356 1.88873L5.75075 9.13509L5.75074 9.13508L5.74786 9.13795C5.55365 9.33164 5.32796 9.40789 5.08814 9.40789C4.84832 9.40789 4.62263 9.33164 4.42842 9.13795L0.913407 5.6323C0.849264 5.56833 0.836914 5.51416 0.836914 5.48128C0.836914 5.44839 0.849264 5.39423 0.913407 5.33025L1.92621 4.32015C1.99035 4.25619 2.04527 4.24331 2.07953 4.24331C2.11379 4.24331 2.16871 4.25619 2.23285 4.32015L2.23282 4.32018L2.23704 4.32428L4.79883 6.81982L5.15018 7.16209L5.49912 6.81736L11.8142 0.578515L11.8159 0.576842C11.8801 0.512875 11.935 0.5 11.9692 0.5C12.0035 0.5 12.0584 0.512875 12.1226 0.576841Z"
      fill="currentColor"
      stroke="currentColor"
    />
    <path
      d="M28.0248 7.50647H15.5733C15.312 7.50647 15.1201 7.31314 15.1201 7.05578V5.15442C15.1201 4.89706 15.312 4.70374 15.5733 4.70374H28.0248C28.2861 4.70374 28.4781 4.89706 28.4781 5.15442V7.05578C28.4781 7.31314 28.2861 7.50647 28.0248 7.50647Z"
      fill="currentColor"
      stroke="currentColor"
    />
    <path
      d="M28.0251 16.0032H12.714C12.4527 16.0032 12.2607 15.8098 12.2607 15.5525V13.6511C12.2607 13.3938 12.4527 13.2004 12.714 13.2004H28.0251C28.2864 13.2004 28.4784 13.3938 28.4784 13.6511V15.5525C28.4784 15.8098 28.2864 16.0032 28.0251 16.0032Z"
      fill="currentColor"
      stroke="currentColor"
    />
    <path
      d="M7.38809 15.5525V15.5803L7.39117 15.6078C7.40173 15.7027 7.36891 15.7909 7.28942 15.8669C7.20536 15.9473 7.07654 16.0032 6.93487 16.0032H5.02842C4.76711 16.0032 4.5752 15.8098 4.5752 15.5525V13.6511C4.5752 13.3938 4.76711 13.2004 5.02842 13.2004H6.93487C7.19618 13.2004 7.38809 13.3938 7.38809 13.6511V15.5525Z"
      fill="currentColor"
      stroke="currentColor"
    />
    <path
      d="M7.38809 24.0493V24.0771L7.39117 24.1047C7.40173 24.1995 7.36891 24.2878 7.28942 24.3637C7.20536 24.4441 7.07654 24.5 6.93487 24.5H5.02842C4.76711 24.5 4.5752 24.3067 4.5752 24.0493V22.1479C4.5752 21.8906 4.76711 21.6973 5.02842 21.6973H6.93487C7.19617 21.6973 7.38809 21.8906 7.38809 22.1479V24.0493Z"
      fill="currentColor"
      stroke="currentColor"
    />
    <path
      d="M28.0251 24.5H12.714C12.4527 24.5 12.2607 24.3067 12.2607 24.0493V22.1479C12.2607 21.8906 12.4527 21.6973 12.714 21.6973H28.0251C28.2864 21.6973 28.4784 21.8906 28.4784 22.1479V24.0493C28.4784 24.3067 28.2864 24.5 28.0251 24.5Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
);

export const taskIcon = (
  <svg viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.1226 0.576841L12.4739 0.224575L12.1226 0.576842L13.1103 1.56195C13.144 1.61187 13.1672 1.68358 13.1672 1.76025C13.1672 1.84678 13.1392 1.88463 13.1356 1.88873L5.75075 9.13509L5.75074 9.13508L5.74786 9.13795C5.55365 9.33164 5.32796 9.40789 5.08814 9.40789C4.84832 9.40789 4.62263 9.33164 4.42842 9.13795L0.913407 5.6323C0.849264 5.56833 0.836914 5.51416 0.836914 5.48128C0.836914 5.44839 0.849264 5.39423 0.913407 5.33025L1.92621 4.32015C1.99035 4.25619 2.04527 4.24331 2.07953 4.24331C2.11379 4.24331 2.16871 4.25619 2.23285 4.32015L2.23282 4.32018L2.23704 4.32428L4.79883 6.81982L5.15018 7.16209L5.49912 6.81736L11.8142 0.578515L11.8159 0.576842C11.8801 0.512875 11.935 0.5 11.9692 0.5C12.0035 0.5 12.0584 0.512875 12.1226 0.576841Z"
      fill="currentColor"
    />
    <path
      d="M28.0248 7.50647H15.5733C15.312 7.50647 15.1201 7.31314 15.1201 7.05578V5.15442C15.1201 4.89706 15.312 4.70374 15.5733 4.70374H28.0248C28.2861 4.70374 28.4781 4.89706 28.4781 5.15442V7.05578C28.4781 7.31314 28.2861 7.50647 28.0248 7.50647Z"
      fill="currentColor"
    />
    <path
      d="M28.0251 16.0032H12.714C12.4527 16.0032 12.2607 15.8098 12.2607 15.5525V13.6511C12.2607 13.3938 12.4527 13.2004 12.714 13.2004H28.0251C28.2864 13.2004 28.4784 13.3938 28.4784 13.6511V15.5525C28.4784 15.8098 28.2864 16.0032 28.0251 16.0032Z"
      fill="currentColor"
    />
    <path
      d="M7.38809 15.5525V15.5803L7.39117 15.6078C7.40173 15.7027 7.36891 15.7909 7.28942 15.8669C7.20536 15.9473 7.07654 16.0032 6.93487 16.0032H5.02842C4.76711 16.0032 4.5752 15.8098 4.5752 15.5525V13.6511C4.5752 13.3938 4.76711 13.2004 5.02842 13.2004H6.93487C7.19618 13.2004 7.38809 13.3938 7.38809 13.6511V15.5525Z"
      fill="currentColor"
    />
    <path
      d="M7.38809 24.0493V24.0771L7.39117 24.1047C7.40173 24.1995 7.36891 24.2878 7.28942 24.3637C7.20536 24.4441 7.07654 24.5 6.93487 24.5H5.02842C4.76711 24.5 4.5752 24.3067 4.5752 24.0493V22.1479C4.5752 21.8906 4.76711 21.6973 5.02842 21.6973H6.93487C7.19617 21.6973 7.38809 21.8906 7.38809 22.1479V24.0493Z"
      fill="currentColor"
    />
    <path
      d="M28.0251 24.5H12.714C12.4527 24.5 12.2607 24.3067 12.2607 24.0493V22.1479C12.2607 21.8906 12.4527 21.6973 12.714 21.6973H28.0251C28.2864 21.6973 28.4784 21.8906 28.4784 22.1479V24.0493C28.4784 24.3067 28.2864 24.5 28.0251 24.5Z"
      fill="currentColor"
    />
  </svg>
);

export const bankInfo = (
  <svg viewBox="0 -960 960 960" fill="currentColor">
    <path d="M200-280v-280h80v280h-80Zm240 0v-280h80v280h-80ZM80-120v-80h800v80H80Zm600-160v-280h80v280h-80ZM80-640v-80l400-200 400 200v80H80Zm178-80h444-444Zm0 0h444L480-830 258-720Z" />
  </svg>
);

export const forwordArrow = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M6 12H18M18 12L13 7M18 12L13 17"
        stroke="#000000"
        stroke-width="0.9359999999999999"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </g>
  </svg>
);

export const inviteFriendsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
  >
    <path d="M500-482q29-32 44.5-73t15.5-85q0-44-15.5-85T500-798q60 8 100 53t40 105q0 60-40 105t-100 53Zm220 322v-120q0-36-16-68.5T662-406q51 18 94.5 46.5T800-280v120h-80Zm80-280v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80Zm-480-40q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM0-160v-112q0-34 17.5-62.5T64-378q62-31 126-46.5T320-440q66 0 130 15.5T576-378q29 15 46.5 43.5T640-272v112H0Zm320-400q33 0 56.5-23.5T400-640q0-33-23.5-56.5T320-720q-33 0-56.5 23.5T240-640q0 33 23.5 56.5T320-560ZM80-240h480v-32q0-11-5.5-20T540-306q-54-27-109-40.5T320-360q-56 0-111 13.5T100-306q-9 5-14.5 14T80-272v32Zm240-400Zm0 400Z" />
  </svg>
);

export const sendGiftIcon = (
  <svg
    viewBox="0 0 64 60"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.26 34.66H0.42C0.2 34.66 0 34.84 0 35.08V54.9C0 55.13 0.2 55.32 0.42 55.32H10.25C10.49 55.32 10.67 55.12 10.67 54.9V35.08C10.6725 35.025 10.6636 34.9701 10.644 34.9187C10.6244 34.8673 10.5945 34.8205 10.5561 34.7811C10.5176 34.7417 10.4715 34.7107 10.4206 34.6898C10.3697 34.669 10.315 34.6588 10.26 34.66ZM6.45 53.46C5.5 53.46 4.72 52.68 4.72 51.73C4.72 50.77 5.5 49.99 6.45 49.99C7.41 49.99 8.19 50.77 8.19 51.73C8.19 52.68 7.41 53.46 6.45 53.46ZM61.35 42.75L45.6 47.94C44.99 48.5 44.19 48.82 43.37 48.82H26.97C26.8334 48.82 26.7024 48.7657 26.6058 48.6692C26.5093 48.5726 26.455 48.4416 26.455 48.305C26.455 48.1684 26.5093 48.0374 26.6058 47.9408C26.7024 47.8443 26.8334 47.79 26.97 47.79H43.37C43.94 47.79 44.49 47.57 44.91 47.19C44.94 47.15 44.98 47.12 45.02 47.08C45.41 46.67 45.63 46.11 45.63 45.52C45.63 44.27 44.62 43.25 43.37 43.25H32.05C31.75 43.25 31.49 43.14 31.28 42.91C26.4 37.37 17.46 36.53 12.56 36.53C12.26 36.53 11.97 36.54 11.7 36.54V52.68L26.75 57.81C30.31 59.02 34.12 59.34 37.87 58.67C40.2552 58.2544 42.558 57.4575 44.69 56.31L62.95 46.39C63.6 46.04 63.99 45.37 63.99 44.64C63.99 44.34 63.93 44.06 63.79 43.79C63.5844 43.3452 63.2209 42.9926 62.7701 42.8004C62.3194 42.6083 61.8133 42.5903 61.35 42.75ZM26.59 8.76L26.52 13.63C26.52 13.68 26.55 13.71 26.59 13.71H63.94C63.97 13.71 64 13.68 64 13.63V8.82L26.59 8.76ZM42.48 36.85V14.72H28.36V36.33C28.36 36.62 28.59 36.86 28.88 36.86H42.48V36.85ZM62.17 36.33V14.72H48.04V36.85H61.65C61.93 36.85 62.17 36.61 62.17 36.33ZM43.5 14.72H47.03V36.85H43.5V14.72ZM39.47 7.57L41.82 8.35H48.29L50.65 7.57C51.2794 7.36399 51.8448 6.99889 52.2916 6.51007C52.7384 6.02125 53.0513 5.42531 53.2 4.78C53.52 3.47 53.13 2.11 52.17 1.14C51.44 0.4 50.47 0 49.44 0C49.13 0 48.83 0.0399999 48.53 0.11C47.8848 0.2589 47.2889 0.571872 46.8001 1.01861C46.3113 1.46535 45.9462 2.03073 45.74 2.66L45.07 4.69L44.39 2.66C43.94 1.37 42.9 0.41 41.58 0.11C40.936 -0.0473126 40.2622 -0.0351214 39.6243 0.145386C38.9864 0.325892 38.4061 0.668559 37.94 1.14C36.98 2.1 36.59 3.46 36.9 4.78C37.0547 5.42573 37.372 6.02112 37.8219 6.50949C38.2717 6.99786 38.8391 7.36295 39.47 7.57ZM47.86 3.37C48.04 2.83 48.48 2.43 49.03 2.3C49.16 2.27 49.29 2.25 49.41 2.25C49.84 2.25 50.25 2.42 50.55 2.73C50.95 3.12 51.12 3.7 50.99 4.25C50.85 4.81 50.45 5.25 49.91 5.43L46.81 6.46L47.86 3.37ZM39.53 2.74C39.84 2.43 40.25 2.26 40.68 2.26C40.81 2.26 40.94 2.28 41.07 2.31C41.62 2.44 42.06 2.84 42.24 3.38L43.27 6.48L40.17 5.45C39.63 5.27 39.23 4.83 39.09 4.28C38.97 3.71 39.13 3.14 39.53 2.74Z"
      fill="black"
    />
  </svg>
);

export const wellnessLibraryIcon = (
  <svg viewBox="0 0 94 81" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M33.3304 6.75002H60.6692C61.5798 6.74982 62.2777 6.74969 62.888 6.80112C67.2268 7.16687 70.7785 9.41482 72.2844 12.4429H21.7151C23.2211 9.41482 26.7726 7.16687 31.1115 6.80112C31.7218 6.74969 32.4199 6.74982 33.3304 6.75002Z"
      fill="url(#paint0_linear_3_58)"
    />
    <path
      d="M24.7162 15.9405C19.2696 15.9405 14.8035 18.7747 13.3131 22.5346C13.2821 22.6129 13.2523 22.6917 13.2238 22.7709C14.7832 22.364 16.4062 22.0981 18.0491 21.9166C22.2805 21.4492 27.6281 21.4494 33.8401 21.4497H34.304H60.8341C67.0459 21.4494 72.3937 21.4492 76.6253 21.9166C78.2679 22.0981 79.891 22.364 81.4502 22.7709C81.422 22.6917 81.3923 22.6129 81.3609 22.5346C79.8706 18.7747 75.4045 15.9405 69.9579 15.9405H24.7162Z"
      fill="url(#paint1_linear_3_58)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M33.9669 25.4544H60.0331C73.2511 25.4544 79.86 25.4544 83.5727 28.7849C87.2849 32.1155 86.4115 37.261 84.6646 47.5524L83.0079 57.3112C81.6378 65.3818 80.9532 69.417 77.4392 71.8335C73.9251 74.25 68.7422 74.25 58.3763 74.25H35.6235C25.2578 74.25 20.075 74.25 16.561 71.8335C13.047 69.417 12.362 65.3818 10.992 57.3112L9.33541 47.5524C7.58846 37.261 6.715 32.1155 10.4274 28.7849C14.1398 25.4544 20.7489 25.4544 33.9669 25.4544ZM31.3333 60.7503C31.3333 59.3524 32.7946 58.2191 34.5972 58.2191H59.4029C61.2054 58.2191 62.6667 59.3524 62.6667 60.7503C62.6667 62.1486 61.2054 63.2819 59.4029 63.2819H34.5972C32.7946 63.2819 31.3333 62.1486 31.3333 60.7503Z"
      fill="url(#paint2_linear_3_58)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3_58"
        x1="47"
        y1="6.74999"
        x2="47"
        y2="74.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#854D9C" />
        <stop offset="1" stop-color="#CD4ED3" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3_58"
        x1="47"
        y1="6.74999"
        x2="47"
        y2="74.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#854D9C" />
        <stop offset="1" stop-color="#CD4ED3" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3_58"
        x1="47"
        y1="6.74999"
        x2="47"
        y2="74.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#854D9C" />
        <stop offset="1" stop-color="#CD4ED3" />
      </linearGradient>
    </defs>
  </svg>
);
export const zoomSessionIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <circle cx="24" cy="24" r="20" fill="#2196f3" />
    <path
      fill="#fff"
      d="M29,31H14c-1.657,0-3-1.343-3-3V17h15c1.657,0,3,1.343,3,3V31z"
    />
    <polygon fill="#fff" points="37,31 31,27 31,21 37,17" />
  </svg>
);
export const communitySupportIcon = (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2_7)">
      <path
        d="M48.1 26.6C47.3 23.8 47.2 20.8 46.6 17.9C46 15 45 12 42.8 10.1C40.3 8 36.8 7.5 33.5 7.2C29.6 6.8 25.5 6.4 22.1 8.4C18.3 10.6 16.5 15.1 15.5 19.3C14.5 23.6 13.9 28.1 11.5 31.7C9.6 34.5 6.7 36.6 5.7 39.9C4.7 43 5.8 46.4 7.9 48.8C10 51.3 12.8 52.9 15.8 54.1C27.6 58.9 41.6 57.9 52.6 51.5C54.8 50.2 57 48.7 58.3 46.4C59.4 44.6 59.6 42.4 58.9 40.4C58.2 38.6 56.9 38.1 55.4 37C51.8 34.4 49.3 30.7 48.1 26.6Z"
        fill="url(#paint0_linear_2_7)"
      />
      <path
        d="M26.7 16.8C26.7 18.4 25.4 19.6 23.9 19.6C22.4 19.6 21 18.4 21 16.8C21 15.2 22.3 14 23.8 14C25.3 14 26.7 15.2 26.7 16.8Z"
        fill="#FED3BE"
        stroke="#0000DB"
        stroke-width="1.267"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M27.2 36.7V43.9C27.2 44.9 26.4 45.7 25.5 45.7C25 45.7 24.6 45.5 24.3 45.2C24 44.9 23.8 44.4 23.8 43.9C23.8 44.9 23 45.7 22.1 45.7C21.6 45.7 21.2 45.5 20.9 45.2C20.6 44.9 20.4 44.4 20.4 43.9V36L18.1 24C18.6 22.9 19.7 22.1 20.9 22.1H26.6C27.5 22.1 28.3 22.5 28.9 23.2"
        fill="#9495FA"
      />
      <path
        d="M27.2 36.7V43.9C27.2 44.9 26.4 45.7 25.5 45.7C25 45.7 24.6 45.5 24.3 45.2C24 44.9 23.8 44.4 23.8 43.9M23.8 43.9V35.2M23.8 43.9C23.8 44.9 23 45.7 22.1 45.7C21.6 45.7 21.2 45.5 20.9 45.2C20.6 44.9 20.4 44.4 20.4 43.9V36L18.1 24C18.6 22.9 19.7 22.1 20.9 22.1H26.6C27.5 22.1 28.3 22.5 28.9 23.2"
        stroke="#0000DB"
        stroke-width="1.267"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M44.7 16.8C44.7 18.4 43.4 19.6 41.9 19.6C40.3 19.6 39.1 18.3 39.1 16.8C39.1 15.2 40.4 14 41.9 14C43.4 14 44.7 15.2 44.7 16.8Z"
        fill="#FED3BE"
        stroke="#0000DB"
        stroke-width="1.267"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M45.2 36V44C45.2 45 44.5 45.8 43.5 45.8C43 45.8 42.6 45.6 42.3 45.3C42 45 41.8 44.5 41.8 44C41.8 45 41 45.8 40.1 45.8C39.6 45.8 39.2 45.6 38.9 45.3C38.6 45 38.4 44.5 38.4 44V36.8L36.6 23.2C37.2 22.5 38 22.1 38.9 22.1H44.6C45.8 22.1 46.9 22.9 47.4 24"
        fill="#9495FA"
      />
      <path
        d="M45.2 36V44C45.2 45 44.5 45.8 43.5 45.8C43 45.8 42.6 45.6 42.3 45.3C42 45 41.8 44.5 41.8 44M41.8 44V35.3M41.8 44C41.8 45 41 45.8 40.1 45.8C39.6 45.8 39.2 45.6 38.9 45.3C38.6 45 38.4 44.5 38.4 44V36.8L36.6 23.2C37.2 22.5 38 22.1 38.9 22.1H44.6C45.8 22.1 46.9 22.9 47.4 24"
        stroke="#0000DB"
        stroke-width="1.267"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M36 17.2C36 18.9 34.6 20.3 32.9 20.3C31.2 20.3 29.8 18.9 29.8 17.2C29.8 15.5 31.2 14.1 32.9 14.1C34.6 14.1 36 15.5 36 17.2Z"
        fill="#FED3BE"
        stroke="#0000DB"
        stroke-width="1.267"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29.2 35.2C29.2 36.1 28.5 36.8 27.7 36.8C26.9 36.8 26.2 36.1 26.2 35.2V26.9C26.2 24.8 27.8 23.1 29.7 23.1H36C37.9 23.1 39.5 24.8 39.5 26.9V35.2C39.5 36.1 38.8 36.8 38 36.8C37.2 36.8 36.5 36.1 36.5 35.2"
        fill="#FF9D23"
      />
      <path
        d="M29.2 35.2C29.2 36.1 28.5 36.8 27.7 36.8C26.9 36.8 26.2 36.1 26.2 35.2V26.9C26.2 24.8 27.8 23.1 29.7 23.1H36C37.9 23.1 39.5 24.8 39.5 26.9V35.2C39.5 36.1 38.8 36.8 38 36.8C37.2 36.8 36.5 36.1 36.5 35.2"
        stroke="#0000DB"
        stroke-width="1.267"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.8 18.9C17.8 20.4 16.5 21.7 15 21.7C13.5 21.7 12.2 20.4 12.2 18.9C12.2 17.4 13.5 16.1 15 16.1C16.6 16.1 17.8 17.3 17.8 18.9Z"
        fill="#FED3BE"
        stroke="#0000DB"
        stroke-width="1.267"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.7 34.8C11.7 35.6 11.1 36.2 10.4 36.2C9.70001 36.2 9.10001 35.6 9.10001 34.8V27.4C9.10001 25.5 10.5 24 12.2 24H17.8C19.5 24 20.9 25.5 20.9 27.4V34.8C20.9 35.6 20.3 36.2 19.6 36.2C18.9 36.2 18.3 35.6 18.3 34.8"
        fill="#F86C66"
      />
      <path
        d="M11.7 34.8C11.7 35.6 11.1 36.2 10.4 36.2C9.70001 36.2 9.10001 35.6 9.10001 34.8V27.4C9.10001 25.5 10.5 24 12.2 24H17.8C19.5 24 20.9 25.5 20.9 27.4V34.8C20.9 35.6 20.3 36.2 19.6 36.2C18.9 36.2 18.3 35.6 18.3 34.8"
        stroke="#0000DB"
        stroke-width="1.267"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3 30V45.6C18.3 46.6 17.6 47.4 16.7 47.4C15.8 47.4 15.1 46.6 15.1 45.6C15.1 46.6 14.4 47.4 13.4 47.4C12.5 47.4 11.7 46.6 11.7 45.6V30"
        fill="#F86C66"
      />
      <path
        d="M18.3 30V45.6C18.3 46.6 17.6 47.4 16.7 47.4C15.8 47.4 15.1 46.6 15.1 45.6M15.1 45.6V37M15.1 45.6C15.1 46.6 14.4 47.4 13.4 47.4C12.5 47.4 11.7 46.6 11.7 45.6V30"
        stroke="#0000DB"
        stroke-width="1.267"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.5 18.9C53.5 20.4 52.2 21.7 50.7 21.7C49.2 21.7 47.9 20.4 47.9 18.9C47.9 17.4 49.2 16.1 50.7 16.1C52.2 16.1 53.5 17.3 53.5 18.9Z"
        fill="#FED3BE"
        stroke="#0000DB"
        stroke-width="1.267"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M47.4 34.8C47.4 35.6 46.8 36.2 46.1 36.2C45.4 36.2 44.8 35.6 44.8 34.8V27.4C44.8 25.5 46.2 24 47.9 24H53.5C55.2 24 56.6 25.5 56.6 27.4V34.8C56.6 35.6 56 36.2 55.3 36.2C54.6 36.2 54 35.6 54 34.8"
        fill="#F86C66"
      />
      <path
        d="M47.4 34.8C47.4 35.6 46.8 36.2 46.1 36.2C45.4 36.2 44.8 35.6 44.8 34.8V27.4C44.8 25.5 46.2 24 47.9 24H53.5C55.2 24 56.6 25.5 56.6 27.4V34.8C56.6 35.6 56 36.2 55.3 36.2C54.6 36.2 54 35.6 54 34.8"
        stroke="#0000DB"
        stroke-width="1.267"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M54 30V45.6C54 46.6 53.3 47.4 52.4 47.4C51.5 47.4 50.8 46.6 50.8 45.6C50.8 46.6 50.1 47.4 49.1 47.4C48.2 47.4 47.4 46.6 47.4 45.6V30"
        fill="#F86C66"
      />
      <path
        d="M54 30V45.6C54 46.6 53.3 47.4 52.4 47.4C51.5 47.4 50.8 46.6 50.8 45.6M50.8 45.6V37M50.8 45.6C50.8 46.6 50.1 47.4 49.1 47.4C48.2 47.4 47.4 46.6 47.4 45.6V30"
        stroke="#0000DB"
        stroke-width="1.267"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0 33.5L1.9 31.6L3.6 33.3"
        stroke="#FF9D23"
        stroke-width="1.387"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M60.7 39.6L62.4 37.8L64 39.4"
        stroke="#9495FA"
        stroke-width="1.267"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.89999 22L2.39999 24.6"
        stroke="#9495FA"
        stroke-width="1.387"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M62 21.7L59.3 24.4"
        stroke="#FF9D23"
        stroke-width="1.387"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.9 54.4L18.2 57.1"
        stroke="#0000DB"
        stroke-width="1.267"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M43.1 51.8L40.3 54.5"
        stroke="#FF4B4D"
        stroke-width="1.267"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2_7"
        x1="32.163"
        y1="6.889"
        x2="32.163"
        y2="57.066"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0.25" />
        <stop offset="1" stop-color="#FED3BE" />
      </linearGradient>
      <clipPath id="clip0_2_7">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const offlineEventIcon = (
  <svg viewBox="0 0 141 113" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M37.4443 10.5938C37.155 10.5974 36.8694 10.6468 36.6038 10.7389C36.3383 10.8311 36.098 10.9642 35.8967 11.1308C35.6954 11.2974 35.537 11.4941 35.4306 11.7098C35.3241 11.9254 35.2718 12.1558 35.2764 12.3876V17.6563H15.4219C14.8376 17.6563 14.2772 17.8423 13.864 18.1734C13.4509 18.5045 13.2188 18.9536 13.2188 19.4219V35.3125H17.625V21.1875H35.2764V25.0436C32.7208 25.7781 30.8702 27.7309 30.8702 30.0156C30.8702 32.9183 33.8532 35.3125 37.4796 35.3125C41.1015 35.3125 44.0889 32.9183 44.0889 30.0156C44.0889 27.7309 42.2339 25.7781 39.6827 25.0436V21.1875H105.776V25.0436C103.221 25.7781 101.37 27.7309 101.37 30.0156C101.37 32.9183 104.353 35.3125 107.98 35.3125C111.602 35.3125 114.589 32.9183 114.589 30.0156C114.589 27.7309 112.734 25.7781 110.183 25.0436V21.1875H127.834V35.3125H132.24V19.4219C132.24 18.9536 132.008 18.5045 131.595 18.1734C131.182 17.8423 130.622 17.6563 130.037 17.6563H110.183V12.3876C110.187 12.151 110.133 11.916 110.022 11.6966C109.911 11.4773 109.747 11.278 109.538 11.1107C109.329 10.9433 109.08 10.8113 108.807 10.7225C108.533 10.6337 108.24 10.5899 107.944 10.5938C107.655 10.5974 107.369 10.6468 107.104 10.7389C106.838 10.8311 106.598 10.9642 106.397 11.1308C106.195 11.2974 106.037 11.4941 105.931 11.7098C105.824 11.9254 105.772 12.1558 105.776 12.3876V17.6563H39.6827V12.3876C39.6874 12.151 39.6328 11.916 39.522 11.6966C39.4112 11.4773 39.2465 11.278 39.0377 11.1107C38.8289 10.9433 38.5802 10.8113 38.3065 10.7225C38.0328 10.6337 37.7396 10.5899 37.4443 10.5938ZM37.2372 28.2853C37.3954 28.2991 37.5549 28.2991 37.7131 28.2853C38.253 28.3218 38.7559 28.5203 39.1211 28.8411C39.4862 29.1619 39.6868 29.5814 39.6827 30.0156C39.6827 31.0114 38.7221 31.7812 37.4796 31.7812C37.1891 31.7846 36.9007 31.7412 36.6316 31.6536C36.3624 31.5661 36.1179 31.4361 35.9125 31.2715C35.707 31.1069 35.5449 30.9109 35.4357 30.6952C35.3264 30.4795 35.2723 30.2484 35.2764 30.0156C35.2764 29.0904 36.1224 28.3807 37.2372 28.2853ZM107.737 28.2853C107.895 28.2991 108.055 28.2991 108.213 28.2853C108.753 28.3218 109.256 28.5203 109.621 28.8411C109.986 29.1619 110.187 29.5814 110.183 30.0156C110.183 31.0114 109.222 31.7812 107.98 31.7812C107.689 31.7846 107.401 31.7412 107.132 31.6536C106.862 31.5661 106.618 31.4361 106.412 31.2715C106.207 31.1069 106.045 30.9109 105.936 30.6952C105.826 30.4795 105.772 30.2484 105.776 30.0156C105.776 29.0904 106.622 28.3807 107.737 28.2853ZM15.4483 38.8438C14.864 38.8438 14.3036 39.0298 13.8905 39.3609C13.4773 39.692 13.2452 40.1411 13.2452 40.6094V104.172C13.2452 104.64 13.4773 105.089 13.8905 105.42C14.3036 105.751 14.864 105.938 15.4483 105.938H130.011C130.595 105.938 131.155 105.751 131.569 105.42C131.982 105.089 132.214 104.64 132.214 104.172V40.6094C132.214 40.1411 131.982 39.692 131.569 39.3609C131.155 39.0298 130.595 38.8438 130.011 38.8438H15.4483ZM17.6514 42.375H127.808V102.406H17.6514V42.375ZM59.5108 45.9062C58.9265 45.9062 58.3661 46.0923 57.953 46.4234C57.5398 46.7545 57.3077 47.2036 57.3077 47.6719V54.7344C57.3077 55.2026 57.5398 55.6517 57.953 55.9829C58.3661 56.314 58.9265 56.5 59.5108 56.5H68.3233C68.9076 56.5 69.468 56.314 69.8812 55.9829C70.2943 55.6517 70.5264 55.2026 70.5264 54.7344V47.6719C70.5264 47.2036 70.2943 46.7545 69.8812 46.4234C69.468 46.0923 68.9076 45.9062 68.3233 45.9062H59.5108ZM77.1358 45.9062C76.5515 45.9062 75.9911 46.0923 75.578 46.4234C75.1648 46.7545 74.9327 47.2036 74.9327 47.6719V54.7344C74.9327 55.2026 75.1648 55.6517 75.578 55.9829C75.9911 56.314 76.5515 56.5 77.1358 56.5H85.9483C86.5326 56.5 87.093 56.314 87.5062 55.9829C87.9193 55.6517 88.1514 55.2026 88.1514 54.7344V47.6719C88.1514 47.2036 87.9193 46.7545 87.5062 46.4234C87.093 46.0923 86.5326 45.9062 85.9483 45.9062H77.1358ZM94.7608 45.9062C94.1765 45.9062 93.6161 46.0923 93.203 46.4234C92.7898 46.7545 92.5577 47.2036 92.5577 47.6719V54.7344C92.5577 55.2026 92.7898 55.6517 93.203 55.9829C93.6161 56.314 94.1765 56.5 94.7608 56.5H103.573C104.158 56.5 104.718 56.314 105.131 55.9829C105.544 55.6517 105.776 55.2026 105.776 54.7344V47.6719C105.776 47.2036 105.544 46.7545 105.131 46.4234C104.718 46.0923 104.158 45.9062 103.573 45.9062H94.7608ZM112.386 45.9062C111.802 45.9062 111.241 46.0923 110.828 46.4234C110.415 46.7545 110.183 47.2036 110.183 47.6719V54.7344C110.183 55.2026 110.415 55.6517 110.828 55.9829C111.241 56.314 111.802 56.5 112.386 56.5H121.198C121.783 56.5 122.343 56.314 122.756 55.9829C123.169 55.6517 123.401 55.2026 123.401 54.7344V47.6719C123.401 47.2036 123.169 46.7545 122.756 46.4234C122.343 46.0923 121.783 45.9062 121.198 45.9062H112.386ZM50.6366 48.3216C50.066 48.3319 49.5226 48.5193 49.1209 48.8442L44.8292 52.2519L43.45 51.1608C43.2455 50.9933 43.0015 50.8601 42.7321 50.769C42.4628 50.6779 42.1735 50.6307 41.8811 50.6301C41.5888 50.6295 41.2992 50.6755 41.0292 50.7655C40.7593 50.8555 40.5144 50.9877 40.3089 51.1543C40.1033 51.3209 39.9412 51.5187 39.8319 51.736C39.7227 51.9533 39.6685 52.1859 39.6726 52.4202C39.6766 52.6545 39.7388 52.8858 39.8556 53.1006C39.9723 53.3154 40.1412 53.5095 40.3524 53.6715L43.2782 55.988C43.6906 56.3147 44.2471 56.4979 44.827 56.4979C45.4069 56.4979 45.9634 56.3147 46.3758 55.988L52.2229 51.355C52.5429 51.108 52.7623 50.7893 52.8522 50.4407C52.9422 50.092 52.8986 49.7297 52.727 49.4013C52.5555 49.0729 52.2641 48.7937 51.891 48.6004C51.518 48.4071 51.0807 48.3087 50.6366 48.3181V48.3216ZM26.4639 49.4375V52.9688H30.8702V49.4375H26.4639ZM61.7139 49.4375H66.1202V52.9688H61.7139V49.4375ZM79.3389 49.4375H83.7452V52.9688H79.3389V49.4375ZM96.9639 49.4375H101.37V52.9688H96.9639V49.4375ZM114.589 49.4375H118.995V52.9688H114.589V49.4375ZM24.2608 60.0312C23.6765 60.0312 23.1161 60.2173 22.703 60.5484C22.2898 60.8795 22.0577 61.3286 22.0577 61.7969V68.8594C22.0577 69.3276 22.2898 69.7767 22.703 70.1079C23.1161 70.439 23.6765 70.625 24.2608 70.625H33.0733C33.6576 70.625 34.218 70.439 34.6312 70.1079C35.0443 69.7767 35.2764 69.3276 35.2764 68.8594V61.7969C35.2764 61.3286 35.0443 60.8795 34.6312 60.5484C34.218 60.2173 33.6576 60.0312 33.0733 60.0312H24.2608ZM41.8858 60.0312C41.3015 60.0312 40.7411 60.2173 40.328 60.5484C39.9148 60.8795 39.6827 61.3286 39.6827 61.7969V68.8594C39.6827 69.3276 39.9148 69.7767 40.328 70.1079C40.7411 70.439 41.3015 70.625 41.8858 70.625H50.6983C51.2826 70.625 51.843 70.439 52.2562 70.1079C52.6693 69.7767 52.9014 69.3276 52.9014 68.8594V61.7969C52.9014 61.3286 52.6693 60.8795 52.2562 60.5484C51.843 60.2173 51.2826 60.0312 50.6983 60.0312H41.8858ZM59.5108 60.0312C58.9265 60.0312 58.3661 60.2173 57.953 60.5484C57.5398 60.8795 57.3077 61.3286 57.3077 61.7969V68.8594C57.3077 69.3276 57.5398 69.7767 57.953 70.1079C58.3661 70.439 58.9265 70.625 59.5108 70.625H68.3233C68.9076 70.625 69.468 70.439 69.8812 70.1079C70.2943 69.7767 70.5264 69.3276 70.5264 68.8594V61.7969C70.5264 61.3286 70.2943 60.8795 69.8812 60.5484C69.468 60.2173 68.9076 60.0312 68.3233 60.0312H59.5108ZM77.1358 60.0312C76.5515 60.0312 75.9911 60.2173 75.578 60.5484C75.1648 60.8795 74.9327 61.3286 74.9327 61.7969V68.8594C74.9327 69.3276 75.1648 69.7767 75.578 70.1079C75.9911 70.439 76.5515 70.625 77.1358 70.625H85.9483C86.5326 70.625 87.093 70.439 87.5062 70.1079C87.9193 69.7767 88.1514 69.3276 88.1514 68.8594V61.7969C88.1514 61.3286 87.9193 60.8795 87.5062 60.5484C87.093 60.2173 86.5326 60.0312 85.9483 60.0312H77.1358ZM112.386 60.0312C111.802 60.0312 111.241 60.2173 110.828 60.5484C110.415 60.8795 110.183 61.3286 110.183 61.7969V68.8594C110.183 69.3276 110.415 69.7767 110.828 70.1079C111.241 70.439 111.802 70.625 112.386 70.625H121.198C121.783 70.625 122.343 70.439 122.756 70.1079C123.169 69.7767 123.401 69.3276 123.401 68.8594V61.7969C123.401 61.3286 123.169 60.8795 122.756 60.5484C122.343 60.2173 121.783 60.0312 121.198 60.0312H112.386ZM103.52 62.4466C102.95 62.4569 102.406 62.6443 102.005 62.9693L97.7042 66.3769L96.325 65.2858C96.1205 65.1183 95.8765 64.9851 95.6071 64.894C95.3378 64.8029 95.0485 64.7557 94.7561 64.7551C94.4638 64.7545 94.1742 64.8005 93.9042 64.8905C93.6343 64.9805 93.3894 65.1127 93.1839 65.2793C92.9783 65.4459 92.8162 65.6437 92.7069 65.861C92.5977 66.0783 92.5435 66.3109 92.5476 66.5452C92.5516 66.7795 92.6138 67.0108 92.7306 67.2256C92.8473 67.4404 93.0162 67.6345 93.2274 67.7965L96.1532 70.113C96.5656 70.4397 97.1221 70.6229 97.702 70.6229C98.2819 70.6229 98.8384 70.4397 99.2508 70.113L105.107 65.48C105.427 65.233 105.646 64.9143 105.736 64.5657C105.826 64.217 105.782 63.8547 105.611 63.5263C105.439 63.1979 105.148 62.9187 104.775 62.7254C104.402 62.5321 103.965 62.4372 103.52 62.4466ZM26.4639 63.5625H30.8702V67.0938H26.4639V63.5625ZM44.0889 63.5625H48.4952V67.0938H44.0889V63.5625ZM61.7139 63.5625H66.1202V67.0938H61.7139V63.5625ZM79.3389 63.5625H83.7452V67.0938H79.3389V63.5625ZM114.589 63.5625H118.995V67.0938H114.589V63.5625ZM24.2608 74.1562C23.6765 74.1562 23.1161 74.3423 22.703 74.6734C22.2898 75.0045 22.0577 75.4536 22.0577 75.9219V82.9844C22.0577 83.4526 22.2898 83.9017 22.703 84.2329C23.1161 84.564 23.6765 84.75 24.2608 84.75H33.0733C33.6576 84.75 34.218 84.564 34.6312 84.2329C35.0443 83.9017 35.2764 83.4526 35.2764 82.9844V75.9219C35.2764 75.4536 35.0443 75.0045 34.6312 74.6734C34.218 74.3423 33.6576 74.1562 33.0733 74.1562H24.2608ZM41.8858 74.1562C41.3015 74.1562 40.7411 74.3423 40.328 74.6734C39.9148 75.0045 39.6827 75.4536 39.6827 75.9219V82.9844C39.6827 83.4526 39.9148 83.9017 40.328 84.2329C40.7411 84.564 41.3015 84.75 41.8858 84.75H50.6983C51.2826 84.75 51.843 84.564 52.2562 84.2329C52.6693 83.9017 52.9014 83.4526 52.9014 82.9844V75.9219C52.9014 75.4536 52.6693 75.0045 52.2562 74.6734C51.843 74.3423 51.2826 74.1562 50.6983 74.1562H41.8858ZM77.1358 74.1562C76.5515 74.1562 75.9911 74.3423 75.578 74.6734C75.1648 75.0045 74.9327 75.4536 74.9327 75.9219V82.9844C74.9327 83.4526 75.1648 83.9017 75.578 84.2329C75.9911 84.564 76.5515 84.75 77.1358 84.75H85.9483C86.5326 84.75 87.093 84.564 87.5062 84.2329C87.9193 83.9017 88.1514 83.4526 88.1514 82.9844V75.9219C88.1514 75.4536 87.9193 75.0045 87.5062 74.6734C87.093 74.3423 86.5326 74.1562 85.9483 74.1562H77.1358ZM94.7608 74.1562C94.1765 74.1562 93.6161 74.3423 93.203 74.6734C92.7898 75.0045 92.5577 75.4536 92.5577 75.9219V82.9844C92.5577 83.4526 92.7898 83.9017 93.203 84.2329C93.6161 84.564 94.1765 84.75 94.7608 84.75H103.573C104.158 84.75 104.718 84.564 105.131 84.2329C105.544 83.9017 105.776 83.4526 105.776 82.9844V75.9219C105.776 75.4536 105.544 75.0045 105.131 74.6734C104.718 74.3423 104.158 74.1562 103.573 74.1562H94.7608ZM112.386 74.1562C111.802 74.1562 111.241 74.3423 110.828 74.6734C110.415 75.0045 110.183 75.4536 110.183 75.9219V82.9844C110.183 83.4526 110.415 83.9017 110.828 84.2329C111.241 84.564 111.802 84.75 112.386 84.75H121.198C121.783 84.75 122.343 84.564 122.756 84.2329C123.169 83.9017 123.401 83.4526 123.401 82.9844V75.9219C123.401 75.4536 123.169 75.0045 122.756 74.6734C122.343 74.3423 121.783 74.1562 121.198 74.1562H112.386ZM68.2704 76.5646C67.6967 76.573 67.1497 76.7605 66.7459 77.0872L62.4542 80.5019L61.075 79.4108C60.8705 79.2433 60.6265 79.1101 60.3571 79.019C60.0878 78.9279 59.7985 78.8807 59.5061 78.8801C59.2138 78.8795 58.9242 78.9255 58.6542 79.0155C58.3843 79.1055 58.1394 79.2377 57.9339 79.4043C57.7283 79.5709 57.5662 79.7687 57.4569 79.986C57.3477 80.2033 57.2935 80.4359 57.2976 80.6702C57.3016 80.9045 57.3638 81.1358 57.4806 81.3506C57.5973 81.5654 57.7662 81.7595 57.9774 81.9215L60.9032 84.238C61.3156 84.5647 61.8721 84.7479 62.452 84.7479C63.0319 84.7479 63.5884 84.5647 64.0008 84.238L69.8479 79.5979C70.1673 79.3514 70.3864 79.0333 70.4766 78.6854C70.5668 78.3374 70.5239 77.9758 70.3535 77.6477C70.183 77.3196 69.8931 77.0403 69.5214 76.8465C69.1498 76.6526 68.7138 76.5566 68.2704 76.5646ZM26.4639 77.6875H30.8702V81.2188H26.4639V77.6875ZM44.0889 77.6875H48.4952V81.2188H44.0889V77.6875ZM79.3389 77.6875H83.7452V81.2188H79.3389V77.6875ZM96.9639 77.6875H101.37V81.2188H96.9639V77.6875ZM114.589 77.6875H118.995V81.2188H114.589V77.6875ZM24.2608 88.2812C23.6765 88.2812 23.1161 88.4673 22.703 88.7984C22.2898 89.1295 22.0577 89.5786 22.0577 90.0469V97.1094C22.0577 97.5776 22.2898 98.0267 22.703 98.3579C23.1161 98.689 23.6765 98.875 24.2608 98.875H33.0733C33.6576 98.875 34.218 98.689 34.6312 98.3579C35.0443 98.0267 35.2764 97.5776 35.2764 97.1094V90.0469C35.2764 89.5786 35.0443 89.1295 34.6312 88.7984C34.218 88.4673 33.6576 88.2812 33.0733 88.2812H24.2608ZM41.8858 88.2812C41.3015 88.2812 40.7411 88.4673 40.328 88.7984C39.9148 89.1295 39.6827 89.5786 39.6827 90.0469V97.1094C39.6827 97.5776 39.9148 98.0267 40.328 98.3579C40.7411 98.689 41.3015 98.875 41.8858 98.875H50.6983C51.2826 98.875 51.843 98.689 52.2562 98.3579C52.6693 98.0267 52.9014 97.5776 52.9014 97.1094V90.0469C52.9014 89.5786 52.6693 89.1295 52.2562 88.7984C51.843 88.4673 51.2826 88.2812 50.6983 88.2812H41.8858ZM26.4639 91.8125H30.8702V95.3438H26.4639V91.8125ZM44.0889 91.8125H48.4952V95.3438H44.0889V91.8125ZM61.7139 91.8125V95.3438H66.1202V91.8125H61.7139ZM79.3389 91.8125V95.3438H83.7452V91.8125H79.3389ZM96.9639 91.8125V95.3438H101.37V91.8125H96.9639ZM114.589 91.8125V95.3438H118.995V91.8125H114.589Z"
      fill="url(#paint0_linear_3_85)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3_85"
        x1="13.2188"
        y1="58.2656"
        x2="118.969"
        y2="58.2656"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#000092" />
        <stop offset="1" stop-color="#FF00F3" />
      </linearGradient>
    </defs>
  </svg>
);
export const wellnessWarriorIcon = (
  <svg viewBox="0 0 55 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.28875 22.5141H12.0162C12.6764 22.5182 13.3206 22.717 13.8684 23.0856C14.4161 23.4542 14.8429 23.9761 15.0953 24.5862C15.3477 25.1962 15.4146 25.8671 15.2874 26.515C15.1603 27.1628 14.8448 27.7587 14.3806 28.2281L12.4621 30.157C12.3448 30.273 12.2518 30.4111 12.1882 30.5633C12.1247 30.7155 12.092 30.8788 12.092 31.0437C12.092 31.2086 12.1247 31.3719 12.1882 31.5241C12.2518 31.6763 12.3448 31.8143 12.4621 31.9303L15.0131 34.4815C15.2512 34.711 15.5691 34.8393 15.8998 34.8393C16.2305 34.8393 16.5484 34.711 16.7865 34.4815L18.7154 32.5526C19.1901 32.1002 19.786 31.7956 20.4307 31.6758C21.0753 31.5561 21.7409 31.6263 22.3464 31.8779C22.9519 32.1296 23.4711 32.5518 23.8409 33.0933C24.2108 33.6347 24.4152 34.272 24.4294 34.9275L24.4295 37.6444C24.4285 37.9785 24.56 38.2993 24.7953 38.5365C25.0305 38.7737 25.3502 38.9079 25.6843 38.9096C26.1282 38.9078 28.7891 38.9103 29.2932 38.9096C29.6272 38.9079 29.947 38.7737 30.1822 38.5365C30.4174 38.2993 30.549 37.9785 30.548 37.6444V34.9274C30.5529 34.2676 30.7519 33.6239 31.1202 33.0764C31.4885 32.5289 32.0097 32.102 32.619 31.8488C33.2283 31.5955 33.8987 31.5273 34.5465 31.6524C35.1943 31.7776 35.791 32.0907 36.2621 32.5526L38.191 34.4815C38.4291 34.7111 38.7469 34.8393 39.0776 34.8393C39.4084 34.8393 39.7262 34.7111 39.9643 34.4815L42.5154 31.9304C42.6327 31.8144 42.7257 31.6763 42.7893 31.5241C42.8528 31.3719 42.8855 31.2086 42.8855 31.0437C42.8855 30.8788 42.8528 30.7155 42.7893 30.5633C42.7257 30.4111 42.6327 30.273 42.5154 30.1571L40.5969 28.2281C40.1419 27.7553 39.8345 27.1601 39.7126 26.5152C39.5906 25.8704 39.6593 25.2041 39.9102 24.5977C40.1611 23.9913 40.5834 23.4713 41.1253 23.1012C41.6673 22.7311 42.3054 22.5271 42.9615 22.5141L45.6888 22.5141C46.0212 22.5129 46.3397 22.3803 46.5748 22.1453C46.8099 21.9102 46.9424 21.5917 46.9436 21.2592V17.6504C46.9425 17.3179 46.8099 16.9994 46.5748 16.7643C46.3397 16.5293 46.0212 16.3967 45.6888 16.3956H42.9613C42.3011 16.3915 41.6568 16.1927 41.1091 15.8241C40.5614 15.4555 40.1346 14.9335 39.8822 14.3234C39.6297 13.7134 39.5629 13.0425 39.6901 12.3946C39.8172 11.7468 40.1327 11.1509 40.5969 10.6815L42.5154 8.7526C42.6327 8.63557 42.7257 8.49656 42.7892 8.34352C42.8527 8.19048 42.8854 8.02642 42.8854 7.86073C42.8854 7.69505 42.8527 7.53099 42.7892 7.37795C42.7257 7.22491 42.6327 7.08589 42.5154 6.96886L39.9643 4.41779C39.7239 4.19289 39.4069 4.06778 39.0777 4.06778C38.7484 4.06778 38.4314 4.19289 38.191 4.41779L36.2621 6.34666C35.7885 6.79955 35.1934 7.10497 34.5493 7.22572C33.9052 7.34648 33.2399 7.27736 32.6344 7.02679C32.0289 6.77623 31.5093 6.35501 31.1389 5.81444C30.7685 5.27387 30.5632 4.63726 30.5481 3.98213L30.548 1.25484C30.5483 1.08997 30.5161 0.926655 30.4531 0.774273C30.3902 0.62189 30.2978 0.483437 30.1812 0.366853C30.0646 0.25027 29.9261 0.157851 29.7738 0.094898C29.6214 0.0319449 29.4581 -0.000303513 29.2932 2.15273e-06H25.6843C25.5194 -0.000300877 25.3561 0.0319499 25.2038 0.0949042C25.0514 0.157858 24.9129 0.250278 24.7963 0.366861C24.6798 0.483444 24.5873 0.621896 24.5244 0.774277C24.4614 0.926658 24.4292 1.08997 24.4295 1.25484V3.98225C24.4143 4.63737 24.209 5.27394 23.8385 5.81447C23.4681 6.355 22.9485 6.77617 22.343 7.02671C21.7375 7.27724 21.0722 7.34634 20.4281 7.22558C19.784 7.10482 19.189 6.79941 18.7153 6.34654L16.7865 4.41779C16.5472 4.19057 16.2298 4.06388 15.8998 4.06388C15.5699 4.06388 15.2525 4.19057 15.0132 4.41779L12.4621 6.96886C12.3448 7.08589 12.2517 7.22491 12.1883 7.37795C12.1248 7.53099 12.0921 7.69505 12.0921 7.86073C12.0921 8.02642 12.1248 8.19048 12.1883 8.34352C12.2517 8.49656 12.3448 8.63557 12.4621 8.7526L14.3806 10.6815C14.8454 11.1507 15.1613 11.7466 15.2887 12.3946C15.4162 13.0426 15.3494 13.7139 15.0969 14.3241C14.8444 14.9344 14.4174 15.4565 13.8693 15.825C13.3212 16.1935 12.6766 16.392 12.0162 16.3956H9.28875C8.9563 16.3967 8.63779 16.5293 8.40271 16.7643C8.16763 16.9994 8.03506 17.3179 8.03392 17.6504V21.2593C8.03507 21.5917 8.16764 21.9102 8.40272 22.1453C8.6378 22.3804 8.9563 22.513 9.28875 22.5141ZM27.4888 9.9971C29.9964 9.9995 32.4006 10.9967 34.1738 12.7699C35.9469 14.543 36.9441 16.9473 36.9465 19.4549C36.4382 31.9986 18.5374 31.995 18.031 19.4548C18.0334 16.9472 19.0306 14.543 20.8037 12.7698C22.5769 10.9967 24.9811 9.9995 27.4888 9.9971ZM27.4888 26.8386C29.4468 26.8378 31.3244 26.0596 32.7089 24.6751C34.0935 23.2905 34.8717 21.4129 34.8725 19.4549C34.5315 9.68133 20.4445 9.68382 20.1051 19.455C20.1059 21.413 20.8841 23.2906 22.2686 24.6751C23.6532 26.0596 25.5308 26.8378 27.4888 26.8386ZM22.5214 17.9719C22.6243 17.882 22.7441 17.8137 22.8737 17.7707C23.0034 17.7277 23.1403 17.7111 23.2765 17.7217C23.4126 17.7323 23.5453 17.77 23.6667 17.8326C23.7882 17.8951 23.8959 17.9812 23.9836 18.0859L25.9332 20.357L31.1391 16.3022C31.2466 16.2173 31.3698 16.1545 31.5017 16.1175C31.6335 16.0804 31.7714 16.0698 31.9073 16.0863C32.0433 16.1028 32.1746 16.146 32.2938 16.2134C32.413 16.2808 32.5177 16.3712 32.6018 16.4793C32.6859 16.5873 32.7478 16.711 32.784 16.8431C32.8201 16.9751 32.8298 17.1131 32.8124 17.2489C32.795 17.3848 32.7509 17.5158 32.6826 17.6345C32.6144 17.7533 32.5233 17.8573 32.4147 17.9407L26.4309 22.6074C26.2191 22.7707 25.9527 22.8467 25.6865 22.8197C25.4203 22.7927 25.1746 22.6648 24.9998 22.4622L22.4072 19.4237C22.3186 19.3212 22.2512 19.2022 22.209 19.0735C22.1667 18.9448 22.1504 18.809 22.161 18.6739C22.1716 18.5389 22.209 18.4073 22.2708 18.2868C22.3327 18.1663 22.4179 18.0592 22.5214 17.9719ZM26.7836 40.9837L17.0769 55.5333C16.9841 55.677 16.8566 55.7951 16.7062 55.8766C16.5558 55.9582 16.3873 56.0006 16.2162 56C15.9849 55.9986 15.7606 55.9205 15.5785 55.7778C15.3964 55.6352 15.2669 55.4361 15.2102 55.2119L12.9391 45.9615L1.40723 50.2963C1.20069 50.3728 0.975256 50.382 0.76315 50.3227C0.551045 50.2633 0.363122 50.1385 0.226237 49.9659C0.0893524 49.7934 0.0105108 49.582 0.000979029 49.3619C-0.00855275 49.1419 0.0517129 48.9245 0.173164 48.7407L10.668 33.0194C11.3814 33.8761 12.7641 35.1448 13.5406 35.9541C14.1754 36.5582 15.0183 36.8952 15.8947 36.8952C16.7711 36.8952 17.6139 36.5582 18.2488 35.9541L20.1776 34.0252C20.3556 33.846 20.5838 33.7253 20.832 33.679C21.0803 33.6327 21.3367 33.663 21.5672 33.7659C21.799 33.8595 21.9977 34.0199 22.138 34.2268C22.2784 34.4336 22.354 34.6775 22.3554 34.9274V37.6444C22.3545 38.3115 22.5537 38.9634 22.9271 39.5162C23.3005 40.0689 23.8311 40.497 24.4502 40.7451C25.205 40.976 25.9977 41.057 26.7836 40.9837ZM53.5703 50.2963L42.0384 45.9615L39.7673 55.2118C39.7169 55.4052 39.6118 55.58 39.4647 55.7152C39.3175 55.8505 39.1345 55.9404 38.9376 55.9743C38.7406 56.0083 38.5381 55.9847 38.3542 55.9065C38.1702 55.8283 38.0128 55.6987 37.9006 55.5333L28.1939 40.9837H29.2932C30.1771 40.9812 31.0239 40.6282 31.6479 40.0022C32.272 39.3763 32.6223 38.5283 32.6221 37.6444V34.9274C32.6248 34.6723 32.7045 34.424 32.8507 34.2149C32.9968 34.0059 33.2027 33.8458 33.4413 33.7556C33.6686 33.6589 33.9198 33.6328 34.1622 33.6809C34.4045 33.729 34.6267 33.849 34.7998 34.0252L36.7287 35.9541C37.3636 36.5583 38.2064 36.8952 39.0828 36.8952C39.9592 36.8952 40.8021 36.5583 41.4369 35.9541L42.8472 34.5438C43.0853 34.286 44.1439 33.2995 44.3095 33.0193L54.8043 48.7407C54.9216 48.925 54.9784 49.1413 54.9671 49.3594C54.9557 49.5775 54.8766 49.7866 54.7409 49.9577C54.6052 50.1288 54.4195 50.2534 54.2097 50.3141C53.9999 50.3747 53.7764 50.3685 53.5703 50.2963Z"
      fill="url(#paint0_linear_2_6)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2_6"
        x1="-0.000595159"
        y1="28"
        x2="54.9834"
        y2="28"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFA68D" />
        <stop offset="1" stop-color="#FD3A84" />
      </linearGradient>
    </defs>
  </svg>
);
export const affordableIcon = (
  <svg viewBox="0 0 101 91" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_11_5)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M92 40.8881V26.2291C92 22.4718 89.2161 19.3553 85.5997 18.8204L84.746 18.6941V14.7581C84.746 10.6234 81.3807 7.25814 77.246 7.25814H72.7871L70.5607 1.32444C70.5156 1.20413 70.4259 1.10576 70.3102 1.04983C70.1946 0.993952 70.0619 0.984691 69.9397 1.02396C69.9396 1.02399 69.9397 1.02393 69.9397 1.02396L50.5891 7.25814H11.235C7.79828 7.25814 5 10.0564 5 13.4931V74.0211C5 78.1559 8.36528 81.5211 12.5 81.5211H84.5C88.6347 81.5211 92 78.1559 92 74.0211V59.3621H93.5C94.8777 59.3621 96 58.2399 96 56.8621V43.3881C96 42.0112 94.8775 40.8881 93.5 40.8881H92ZM93.5 39.8881H93V26.2291C93 21.9661 89.843 18.4371 85.746 17.8311V14.7581C85.746 10.0711 81.933 6.25814 77.246 6.25814H73.48L71.497 0.973138C71.3616 0.612208 71.0924 0.317261 70.7454 0.149496C70.3983 -0.0182678 70 -0.0459697 69.633 0.0721382L50.432 6.25814H11.235C7.246 6.25814 4 9.50414 4 13.4931V74.0211C4 78.7081 7.813 82.5211 12.5 82.5211H84.5C89.187 82.5211 93 78.7081 93 74.0211V60.3621H93.5C95.43 60.3621 97 58.7921 97 56.8621V43.3881C97 41.4591 95.43 39.8881 93.5 39.8881ZM73.1626 8.25914H77.246C80.8302 8.25914 83.746 11.1737 83.746 14.7591V18.7301H77.0921L76.5498 17.2845L73.1626 8.25914ZM77.785 17.7301H82.746V14.7591C82.746 11.7261 80.278 9.25914 77.246 9.25914H74.606L77.785 17.7301ZM76.0244 18.7301H24.609L24.3024 16.7783L69.7921 2.12388L71.2122 5.90777L70.276 6.25914L69.191 3.36814L24.609 17.7301H74.581L70.276 6.25914L71.2122 5.90777L76.0244 18.7301ZM41.119 8.25914L41.4257 10.211L22.5857 16.281L14.9831 18.7301H11.235C8.34771 18.7301 6 16.3824 6 13.4951C6 10.6082 8.34741 8.25914 11.235 8.25914H41.119ZM12.4989 80.5211C10.7759 80.5193 9.12393 79.834 7.90556 78.6156C6.68719 77.3972 6.00188 75.7453 6 74.0222L6 17.3381L7.56391 18.5296C7.58449 18.5419 7.61403 18.5603 7.64785 18.5844C7.87586 18.7452 8.11046 18.8901 8.35347 19.0175L8.35612 19.0189C8.38578 19.0346 8.38818 19.0354 8.39279 19.0371C8.39903 19.0392 8.40931 19.0428 8.49684 19.0865C8.72501 19.1992 8.95911 19.2977 9.20026 19.3816L9.20585 19.3835C9.28747 19.4124 9.29427 19.4159 9.29833 19.418C9.30112 19.4195 9.30262 19.4202 9.32617 19.4281C9.5857 19.5119 9.85948 19.5772 10.1496 19.6283L10.1513 19.6286C10.1899 19.6355 10.2248 19.6406 10.2748 19.6479C10.2944 19.6507 10.3163 19.6539 10.3417 19.6577C10.6522 19.7023 10.946 19.7301 11.235 19.7301H84.5C88.0842 19.7301 91 22.6447 91 26.2301V40.8891H80.062C75.9273 40.8891 72.562 44.2544 72.562 48.3891V51.8631C72.562 55.9979 75.9273 59.3631 80.062 59.3631H91V74.0211C91 77.6065 88.0842 80.5211 84.5 80.5211H12.4989ZM10.197 20.6471C10.1792 20.6445 10.1613 20.6419 10.1435 20.6393C10.0874 20.6311 10.0314 20.623 9.976 20.6131C9.647 20.5551 9.326 20.4791 9.014 20.3781C8.98632 20.3689 8.9593 20.3587 8.93218 20.3484C8.91227 20.3409 8.89232 20.3333 8.872 20.3261C8.59 20.2281 8.317 20.1131 8.052 19.9821C8.03482 19.9735 8.01743 19.9653 8 19.957C7.99435 19.9544 7.98869 19.9517 7.98304 19.9491C7.95133 19.9342 7.91966 19.9193 7.889 19.9031C7.603 19.7531 7.33 19.5841 7.068 19.3991C7.05739 19.3914 7.04607 19.3851 7.03485 19.3788C7.02281 19.3721 7.01087 19.3654 7 19.3571V74.0211C7.00159 75.4793 7.58156 76.8774 8.61267 77.9085C9.64377 78.9396 11.0418 79.5196 12.5 79.5211H84.5C87.532 79.5211 90 77.0541 90 74.0211V60.3631H80.062C75.375 60.3631 71.562 56.5501 71.562 51.8631V48.3891C71.562 43.7021 75.375 39.8891 80.062 39.8891H90V26.2301C90 23.1971 87.532 20.7301 84.5 20.7301H11.235C10.882 20.7301 10.537 20.6961 10.197 20.6471ZM7.52004 18.5044C7.52004 18.5044 7.52091 18.5049 7.5221 18.5056L7.52004 18.5044ZM80.0609 58.3621C78.3379 58.3603 76.6859 57.675 75.4676 56.4566C74.2492 55.2382 73.5639 53.5863 73.562 51.8632V48.3881C73.562 44.8027 76.4778 41.8881 80.062 41.8881H93.5C93.8978 41.8881 94.2794 42.0462 94.5607 42.3275C94.842 42.6088 95 42.9903 95 43.3881V56.8621C95 57.26 94.842 57.6415 94.5607 57.9228C94.2794 58.2041 93.8978 58.3621 93.5 58.3621H80.0609ZM14.826 17.7301H11.235C8.9 17.7301 7 15.8301 7 13.4951C7 11.1601 8.9 9.25914 11.235 9.25914H41.119L14.826 17.7301ZM80.062 57.3621H93.5C93.6326 57.3621 93.7598 57.3095 93.8536 57.2157C93.9473 57.1219 94 56.9947 94 56.8621V43.3881C94 43.2555 93.9473 43.1284 93.8536 43.0346C93.7598 42.9408 93.6326 42.8881 93.5 42.8881H80.062C77.03 42.8881 74.562 45.3551 74.562 48.3881V51.8621C74.5636 53.3203 75.1436 54.7184 76.1747 55.7495C77.2058 56.7806 78.6038 57.3605 80.062 57.3621Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_11_5"
        x="0"
        y="0"
        width="101"
        height="90.5211"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_11_5"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_11_5"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export const kidProgramIcon = (
  <svg viewBox="0 0 301 178" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2_51)">
      <path
        d="M228.527 35.6058C225.576 26.0799 218.86 18.0643 211.061 11.7621C203.171 5.28566 193.293 0.842196 182.903 0.145182C176.037 -0.377579 169.081 0.755069 162.727 3.2527C155.439 6.0698 148.904 10.6004 143.423 16.0023C140.954 18.3837 138.785 20.9975 136.557 23.5532C131.467 29.5359 126.408 35.4896 121.62 41.6756C120.747 42.8663 119.813 44.028 119.12 45.3349C120.807 46.9613 122.554 48.5296 124.33 50.0688C132.762 57.4456 141.405 64.59 150.048 71.7344C159.926 79.8372 169.834 87.8819 179.862 95.8394C183.837 98.947 187.722 102.2 191.908 105.104C194.468 103.158 196.666 100.835 198.955 98.5984C203.954 93.5451 208.832 88.3465 213.5 83.0027C220.005 75.6841 225.636 67.378 228.437 58.0555C230.665 50.7949 230.846 42.8954 228.527 35.6058ZM199.918 54.7446C198.413 59.4495 194.919 63.225 191.396 66.6229C191.125 66.8262 190.854 67.2909 190.462 67.0586C179.862 58.3749 169.292 49.6332 158.48 41.1819C158.631 40.6301 159.053 40.2526 159.384 39.8169C160.95 37.9582 162.456 36.0414 164.383 34.5022C167.665 31.8012 171.912 30.1168 176.248 30.0297C181.247 29.8554 186.186 31.6851 190.161 34.5312C193.745 37.1741 197.057 40.3397 199.015 44.2894C200.671 47.5131 201.033 51.3176 199.918 54.7446ZM99.9675 61.7729C100.329 61.3953 100.6 60.6983 101.262 60.8435C104.515 61.2791 107.737 61.9471 110.959 62.586C115.567 63.5444 120.235 64.5028 124.752 65.9549C125.595 66.2744 126.529 66.5068 127.191 67.1166C127.432 67.6684 126.92 68.2493 126.77 68.772C124.21 73.9416 121.228 78.8787 118.337 83.874C114.724 90.031 111.05 96.1589 107.346 102.229C107.135 102.635 106.773 102.955 106.743 103.419C110.086 107.573 113.128 111.958 116.139 116.372C119.873 121.803 123.517 127.321 127.071 132.868C129.841 137.254 132.732 141.581 135.172 146.17C134.78 146.838 133.997 147.07 133.365 147.448C128.366 149.974 123.126 152.036 117.856 153.924C114.603 154.969 111.321 156.16 107.888 156.364C107.075 156.538 106.683 155.754 106.261 155.26C103.13 151.049 100.299 146.605 97.4077 142.249C93.9144 136.818 90.391 131.387 86.9579 125.898C86.7772 125.637 86.6267 125.259 86.2653 125.143C84.0669 128.396 81.6577 131.503 79.6099 134.785C80.2423 141.9 80.8446 149.016 81.5975 156.102C81.1157 156.596 80.3327 156.48 79.7003 156.654C72.6534 157.612 65.6066 158.28 58.5296 158.774C56.3613 158.832 54.163 159.21 52.0549 158.803C50.7299 151.368 50.0071 143.846 49.1037 136.353C46.9053 116.401 44.7973 96.4203 43.412 76.3811C43.2313 73.3898 43.0506 70.3984 43.1109 67.4071C43.2012 66.9424 43.1109 66.3906 43.3819 65.984C44.1348 65.4903 45.0382 65.3451 45.9115 65.1418C49.5554 64.4448 53.2896 64.1543 57.0239 63.8639C62.5349 63.5154 68.076 63.1669 73.6171 63.225C73.7074 63.2831 73.8881 63.3992 73.9785 63.4864C74.2495 64.6771 74.3398 65.8969 74.4603 67.1166C75.3035 77.659 75.5444 88.2013 76.0564 98.7437C81.5674 89.7986 87.1988 80.9408 92.9206 72.1119C95.2094 68.6268 97.468 65.1127 99.9675 61.7729ZM244.639 67.0876C249.999 65.5193 255.811 65.5774 261.202 66.9424C267.345 68.4816 272.977 71.5601 277.946 75.3356C284.029 80.0695 289.449 85.6166 294.057 91.7445C296.948 95.6942 299.658 99.9344 300.923 104.668V105.133C300.502 105.946 299.688 106.498 298.966 107.021C296.225 108.85 293.244 110.302 290.263 111.755C286.89 113.294 283.487 114.833 279.903 115.937C279.271 116.053 278.307 116.518 277.976 115.733C276.289 112.858 274.723 109.925 272.856 107.195C270.025 102.984 266.743 99.005 262.708 95.8104C261.111 94.6197 259.335 93.3999 257.257 93.1675C255.54 92.9642 254.095 94.3873 253.733 95.8975C253.523 97.4077 254.426 98.7727 255.149 100.022C257.98 104.465 261.503 108.415 264.334 112.829C267.616 117.824 270.387 123.313 271.11 129.267C271.682 133.798 270.808 138.503 268.73 142.597C266.924 146.112 264.454 149.277 261.503 151.949C256.474 156.451 249.668 158.977 242.802 159.123C236.508 159.297 230.304 157.554 224.763 154.795C215.427 150.032 207.628 142.801 201.424 134.64C197.78 129.761 194.528 124.562 192.329 118.928C192.179 118.463 191.878 117.97 191.968 117.447C192.871 116.372 194.136 115.646 195.311 114.833C199.948 111.813 204.827 109.141 209.856 106.788C211.362 106.149 212.838 105.365 214.524 105.249C215.608 107.253 216.271 109.431 217.204 111.522C219.914 117.883 223.348 124.243 228.949 128.686C230.726 130.022 232.653 131.474 234.972 131.678C236.839 131.881 238.525 130.4 238.887 128.715C239.188 127.147 238.525 125.608 237.833 124.214C236.357 121.397 234.4 118.841 232.442 116.343C229.22 112.364 226.299 108.066 224.522 103.274C222.836 98.8017 222.354 93.8355 223.588 89.1888C224.944 83.7869 228.196 79.053 231.96 74.958C235.363 71.2987 239.76 68.5107 244.639 67.0876Z"
        fill="white"
        stroke="#333333"
        stroke-width="0.23449"
      />
      <path
        d="M138.183 89.3921C141.195 87.5915 144.176 85.6747 147.368 84.1645C147.91 83.7579 148.332 84.3968 148.633 84.7744C151.825 88.8984 154.746 93.1966 157.728 97.4368C164.895 107.718 171.912 118.086 178.898 128.483C184.801 137.341 190.703 146.17 196.395 155.144C197.63 157.148 198.955 159.123 200.009 161.243C200.43 161.94 199.738 162.608 199.286 163.101C197.389 165.047 195.07 166.557 192.841 168.126C187.752 171.466 182.512 174.631 177.031 177.332C176.308 177.564 175.586 178.174 174.833 177.942C168.087 168.91 161.763 159.587 155.379 150.323C148.723 140.623 142.128 130.893 135.653 121.106C131.166 114.281 126.649 107.485 122.523 100.457C122.975 99.7021 123.758 99.2955 124.391 98.7147C128.787 95.3458 133.485 92.3544 138.183 89.3921Z"
        fill="white"
        stroke="#333333"
        stroke-width="0.23449"
      />
    </g>
    <defs>
      <clipPath id="clip0_2_51">
        <rect width="301" height="178" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const assesmentIcon = (
  <svg viewBox="0 0 196 193" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1831 3.01562H128.532C129.587 3.01562 130.494 3.38579 131.239 4.11972L152.733 25.2838C153.478 26.0177 153.854 26.9111 153.854 27.9492V186.215C153.854 188.291 152.134 189.984 150.026 189.984H11.1831C9.07457 189.984 7.35497 188.291 7.35497 186.215V6.78516C7.35497 4.7089 9.07495 3.01562 11.1831 3.01562Z"
      fill="#ECEFF1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1831 3.01562H18.8397V189.984H11.1831C9.07495 189.984 7.35497 188.291 7.35497 186.215V6.78516C7.35497 4.7089 9.07495 3.01562 11.1831 3.01562Z"
      fill="#D1D1D6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M130.118 3.34244V22.6183C130.118 24.6946 131.838 26.3878 133.946 26.3878H153.522C153.328 25.9761 153.061 25.6021 152.733 25.2837L131.239 4.11972C130.916 3.79644 130.536 3.53315 130.118 3.34244ZM33.7158 29.4031C32.9036 29.4031 32.1246 29.0854 31.5503 28.5198C30.976 27.9543 30.6533 27.1873 30.6533 26.3875C30.6533 25.5877 30.976 24.8206 31.5503 24.2551C32.1246 23.6896 32.9036 23.3718 33.7158 23.3718H103.863C104.675 23.3718 105.454 23.6896 106.029 24.2551C106.603 24.8206 106.926 25.5877 106.926 26.3875C106.926 27.1873 106.603 27.9543 106.029 28.5198C105.454 29.0854 104.675 29.4031 103.863 29.4031H33.7158ZM84.7221 57.5019C83.9099 57.5019 83.131 57.1842 82.5566 56.6187C81.9823 56.0531 81.6596 55.2861 81.6596 54.4863C81.6596 53.6865 81.9823 52.9195 82.5566 52.3539C83.131 51.7884 83.9099 51.4707 84.7221 51.4707H125.3C126.112 51.4707 126.891 51.7884 127.466 52.3539C128.04 52.9195 128.363 53.6865 128.363 54.4863C128.363 55.2861 128.04 56.0531 127.466 56.6187C126.891 57.1842 126.112 57.5019 125.3 57.5019H84.7221ZM84.7221 70.1299C83.9099 70.1299 83.131 69.8121 82.5566 69.2466C81.9823 68.6811 81.6596 67.914 81.6596 67.1142C81.6596 66.3144 81.9823 65.5474 82.5566 64.9819C83.131 64.4163 83.9099 64.0986 84.7221 64.0986H111.136C111.948 64.0986 112.727 64.4163 113.302 64.9819C113.876 65.5474 114.199 66.3144 114.199 67.1142C114.199 67.914 113.876 68.6811 113.302 69.2466C112.727 69.8121 111.948 70.1299 111.136 70.1299H84.7221ZM84.7221 102.422C83.9099 102.422 83.131 102.104 82.5566 101.539C81.9823 100.973 81.6596 100.206 81.6596 99.4063C81.6596 98.6065 81.9823 97.8395 82.5566 97.2739C83.131 96.7084 83.9099 96.3907 84.7221 96.3907H125.3C126.112 96.3907 126.891 96.7084 127.466 97.2739C128.04 97.8395 128.363 98.6065 128.363 99.4063C128.363 100.206 128.04 100.973 127.466 101.539C126.891 102.104 126.112 102.422 125.3 102.422H84.7221ZM84.7221 115.05C83.9099 115.05 83.131 114.732 82.5566 114.167C81.9823 113.601 81.6596 112.834 81.6596 112.034C81.6596 111.234 81.9823 110.467 82.5566 109.902C83.131 109.336 83.9099 109.019 84.7221 109.019H111.136C111.948 109.019 112.727 109.336 113.302 109.902C113.876 110.467 114.199 111.234 114.199 112.034C114.199 112.834 113.876 113.601 113.302 114.167C112.727 114.732 111.948 115.05 111.136 115.05H84.7221ZM84.7221 147.342C83.9099 147.342 83.131 147.024 82.5566 146.459C81.9823 145.893 81.6596 145.126 81.6596 144.326C81.6596 143.527 81.9823 142.759 82.5566 142.194C83.131 141.628 83.9099 141.311 84.7221 141.311H125.3C126.112 141.311 126.891 141.628 127.466 142.194C128.04 142.759 128.363 143.527 128.363 144.326C128.363 145.126 128.04 145.893 127.466 146.459C126.891 147.024 126.112 147.342 125.3 147.342H84.7221ZM84.7221 159.97C83.9099 159.97 83.131 159.652 82.5566 159.087C81.9823 158.521 81.6596 157.754 81.6596 156.954C81.6596 156.154 81.9823 155.387 82.5566 154.822C83.131 154.256 83.9099 153.939 84.7221 153.939H111.136C111.948 153.939 112.727 154.256 113.302 154.822C113.876 155.387 114.199 156.154 114.199 156.954C114.199 157.754 113.876 158.521 113.302 159.087C112.727 159.652 111.948 159.97 111.136 159.97H84.7221Z"
      fill="#A79BA7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M111.136 131.834L165.133 39.741C168.06 34.7487 174.583 33.0279 179.653 35.9101L183.335 38.0033C188.405 40.8855 190.153 47.3084 187.226 52.3007L133.229 144.394L118.867 145.02C118.165 145.05 117.562 145.366 116.953 145.02C116.344 144.673 116.265 144.027 115.996 143.387L111.136 131.834Z"
      fill="#FFE177"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M178.11 35.189C178.643 35.3882 179.159 35.6293 179.653 35.9101L183.335 38.0033C188.405 40.8855 190.153 47.3084 187.226 52.3008L133.229 144.394L120.719 148.961C120.06 149.201 119.413 149.307 118.805 148.961C118.196 148.615 117.848 148.021 117.848 147.329V143.054L126.598 140.625L180.595 48.5312C183.232 44.0327 182.074 38.3735 178.11 35.189Z"
      fill="#FFC338"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M111.136 153.69V131.834L133.229 144.394L114.007 155.322C113.399 155.668 112.702 155.668 112.093 155.322C111.485 154.976 111.136 154.382 111.136 153.69Z"
      fill="#837683"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36.951 45.4112H61.7366C63.5163 45.4112 64.9721 46.8447 64.9721 48.5972V73.0034C64.9721 74.7558 63.5163 76.1894 61.7366 76.1894H36.951C35.1713 76.1894 33.7155 74.7558 33.7155 73.0034V48.5972C33.7158 46.8447 35.1713 45.4112 36.951 45.4112Z"
      fill="#6CF5C2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M40.5854 62.3009C40.025 61.7326 39.7141 60.97 39.72 60.1779C39.7259 59.3857 40.0481 58.6277 40.617 58.0676C41.1859 57.5075 41.9557 57.1903 42.7602 57.1845C43.5646 57.1788 44.3391 57.4849 44.9162 58.0368L47.9435 61.0178L53.5566 54.1848C54.0716 53.5759 54.8092 53.1912 55.61 53.1136C56.4107 53.036 57.2104 53.2719 57.8359 53.7702C58.4615 54.2685 58.8628 54.9893 58.953 55.7766C59.0432 56.5639 58.8151 57.3546 58.3181 57.9777L50.5791 67.3985C50.3104 67.7305 49.9736 68.0028 49.5906 68.1978C49.2076 68.3927 48.7871 68.5058 48.3567 68.5296C47.9262 68.5535 47.4955 68.4875 47.0928 68.3361C46.69 68.1847 46.3242 67.9513 46.0194 67.651L40.5854 62.3009Z"
      fill="#ECEFF1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36.951 135.251H61.7366C63.5163 135.251 64.9721 136.684 64.9721 138.437V162.843C64.9721 164.595 63.5163 166.029 61.7366 166.029H36.951C35.1713 166.029 33.7155 164.595 33.7155 162.843V138.437C33.7158 136.685 35.1713 135.251 36.951 135.251Z"
      fill="#6CF5C2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M40.5854 152.141C40.025 151.573 39.7141 150.81 39.72 150.018C39.7259 149.226 40.0481 148.468 40.617 147.908C41.1859 147.347 41.9557 147.03 42.7602 147.024C43.5646 147.019 44.3391 147.325 44.9162 147.877L47.9435 150.858L53.5566 144.025C54.0708 143.413 54.8091 143.026 55.6114 142.947C56.4136 142.868 57.2152 143.104 57.842 143.603C58.4688 144.103 58.8703 144.825 58.9595 145.614C59.0486 146.403 58.8181 147.195 58.3181 147.818L50.5791 157.239C50.3104 157.571 49.9736 157.843 49.5906 158.038C49.2076 158.233 48.7871 158.346 48.3567 158.37C47.9262 158.394 47.4955 158.328 47.0928 158.176C46.69 158.025 46.3242 157.792 46.0194 157.491L40.5854 152.141Z"
      fill="#ECEFF1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36.951 90.3308H61.7366C63.5163 90.3308 64.9721 91.7643 64.9721 93.5168V117.923C64.9721 119.676 63.5163 121.109 61.7366 121.109H36.951C35.1713 121.109 33.7155 119.676 33.7155 117.923V93.5168C33.7158 91.7647 35.1713 90.3308 36.951 90.3308Z"
      fill="#FE646F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M46.3908 114.11C46.1405 114.425 45.8289 114.689 45.4742 114.885C45.1195 115.08 44.7287 115.205 44.3247 115.25C43.9207 115.296 43.5115 115.261 43.1211 115.15C42.7306 115.038 42.3667 114.85 42.0506 114.598C41.7344 114.347 41.4724 114.035 41.2798 113.683C41.0871 113.33 40.9677 112.943 40.9285 112.545C40.8894 112.146 40.9312 111.744 41.0516 111.361C41.172 110.979 41.3685 110.624 41.6297 110.317L45.4058 105.72L41.6297 101.124C41.3685 100.817 41.172 100.462 41.0516 100.079C40.9312 99.6968 40.8894 99.2946 40.9285 98.896C40.9677 98.4975 41.0871 98.1106 41.2798 97.7579C41.4724 97.4053 41.7344 97.094 42.0506 96.8421C42.3667 96.5903 42.7306 96.4029 43.1211 96.291C43.5115 96.1792 43.9207 96.145 44.3247 96.1905C44.7287 96.2359 45.1195 96.3602 45.4742 96.556C45.8289 96.7518 46.1405 97.0152 46.3908 97.3308L49.3442 100.926L52.2976 97.3308C52.8125 96.722 53.5501 96.3372 54.3509 96.2596C55.1517 96.1821 55.9513 96.4179 56.5769 96.9163C57.2024 97.4146 57.6037 98.1353 57.6939 98.9227C57.7841 99.71 57.5561 100.501 57.059 101.124L53.2829 105.72L57.059 110.317C57.312 110.625 57.5009 110.979 57.6149 111.358C57.729 111.738 57.7659 112.136 57.7237 112.53C57.6815 112.924 57.5609 113.306 57.3688 113.653C57.1767 114.001 56.9169 114.309 56.6042 114.558C56.2916 114.807 55.9322 114.993 55.5465 115.105C55.1609 115.217 54.7566 115.254 54.3567 115.212C53.9568 115.17 53.5691 115.052 53.2158 114.863C52.8625 114.673 52.5505 114.418 52.2976 114.11L49.3442 110.515L46.3908 114.11Z"
      fill="#ECEFF1"
    />
  </svg>
);
export const individualIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="#e8eaed"
  >
    <path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z" />
  </svg>
);
export const downChevronIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="white"
      fill-rule="evenodd"
      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
    />
  </svg>
);

export const fastForward = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
  >
    <path d="M100-240v-480l360 240-360 240Zm400 0v-480l360 240-360 240ZM180-480Zm400 0Zm-400 90 136-90-136-90v180Zm400 0 136-90-136-90v180Z" />
  </svg>
);

export const fastRewind = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
  >
    <path d="M860-240 500-480l360-240v480Zm-400 0L100-480l360-240v480Zm-80-240Zm400 0Zm-400 90v-180l-136 90 136 90Zm400 0v-180l-136 90 136 90Z" />
  </svg>
);

export const loopIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
  >
    <path d="M280-80 120-240l160-160 56 58-62 62h406v-160h80v240H274l62 62-56 58Zm-80-440v-240h486l-62-62 56-58 160 160-160 160-56-58 62-62H280v160h-80Z" />
  </svg>
);

export const muteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
  >
    <path d="M792-56 671-177q-25 16-53 27.5T560-131v-82q14-5 27.5-10t25.5-12L480-368v208L280-360H120v-240h128L56-792l56-56 736 736-56 56Zm-8-232-58-58q17-31 25.5-65t8.5-70q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 53-14.5 102T784-288ZM650-422l-90-90v-130q47 22 73.5 66t26.5 96q0 15-2.5 29.5T650-422ZM480-592 376-696l104-104v208Zm-80 238v-94l-72-72H200v80h114l86 86Zm-36-130Z" />
  </svg>
);

export const volumeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
  >
    <path d="M560-131v-82q90-26 145-100t55-168q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 127-78 224.5T560-131ZM120-360v-240h160l200-200v640L280-360H120Zm440 40v-322q47 22 73.5 66t26.5 96q0 51-26.5 94.5T560-320ZM400-606l-86 86H200v80h114l86 86v-252ZM300-480Z" />
  </svg>
);

export const clipIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path d="M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z" />
  </svg>
);

export const linkShareIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z" />
  </svg>
);

export const faqsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
  </svg>
);
